/*
 * @license
 * Broadcast Theme (c) Invisible Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
! function(t, e, i, s, r, o, n) {
    "use strict";

    function a(t) {
        t.querySelectorAll(".form-field").forEach(t => {
            let e = t.querySelector("label"),
                i = t.querySelector("input, textarea");
            e && i && (i.addEventListener("keyup", t => {
                "" !== t.target.value ? e.classList.add("label--float") : e.classList.remove("label--float")
            }), i.value && i.value.length && e.classList.add("label--float"))
        })
    }! function() {
        let t = {
            NODE_ENV: "production"
        };
        try {
            if (process) return process.env = Object.assign({}, process.env), void Object.assign(process.env, t)
        } catch (e) {}
        globalThis.process = {
            env: t
        }
    }(), window.theme = window.theme || {}, window.theme.sizes = {
        mobile: 480,
        small: 750,
        large: 990,
        widescreen: 1400
    }, window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    let l = p();

    function h() {
        let t = {};
        return t.windowHeight = Math.min(window.screen.height, window.innerHeight), t.footerHeight = m('[data-section-type*="footer"]'), t.headerHeight = m("[data-header-height]"), t.stickyHeaderHeight = document.querySelector("[data-header-sticky]") ? t.headerHeight : 0, t.collectionNavHeight = m("[data-collection-nav]"), t.logoHeight = function() {
            let t = m("[data-footer-logo]");
            return t > 0 ? t + 20 : 0
        }(), t
    }

    function c() {
        document.addEventListener("theme:resize", u), d()
    }

    function d() {
        let {
            windowHeight: t,
            headerHeight: e,
            logoHeight: i,
            footerHeight: s,
            collectionNavHeight: r
        } = h();
        document.documentElement.style.setProperty("--full-height", `${t}px`), document.documentElement.style.setProperty("--three-quarters", t * (3 / 4) + "px"), document.documentElement.style.setProperty("--two-thirds", t * (2 / 3) + "px"), document.documentElement.style.setProperty("--one-half", t / 2 + "px"), document.documentElement.style.setProperty("--one-third", t / 3 + "px"), document.documentElement.style.setProperty("--collection-nav-height", `${r}px`), document.documentElement.style.setProperty("--header-height", `${e}px`), document.documentElement.style.setProperty("--footer-height", `${s}px`), document.documentElement.style.setProperty("--content-full", t - e - i / 2 + "px"), document.documentElement.style.setProperty("--content-min", t - e - s + "px"), document.querySelector("[data-tracking-consent].popup-cookies--bottom") && document.documentElement.style.setProperty("--cookie-bar-height", `${document.querySelector("[data-tracking-consent].popup-cookies--bottom").offsetHeight}px`)
    }

    function u() {
        let {
            windowHeight: t,
            headerHeight: e,
            logoHeight: i,
            footerHeight: s,
            collectionNavHeight: r
        } = h(), o = p();
        (o !== l || window.innerWidth > window.theme.sizes.mobile) && (document.documentElement.style.setProperty("--full-height", `${t}px`), document.documentElement.style.setProperty("--three-quarters", t * (3 / 4) + "px"), document.documentElement.style.setProperty("--two-thirds", t * (2 / 3) + "px"), document.documentElement.style.setProperty("--one-half", t / 2 + "px"), document.documentElement.style.setProperty("--one-third", t / 3 + "px"), l = o), document.documentElement.style.setProperty("--collection-nav-height", `${r}px`), document.documentElement.style.setProperty("--header-height", `${e}px`), document.documentElement.style.setProperty("--footer-height", `${s}px`), document.documentElement.style.setProperty("--content-full", t - e - i / 2 + "px"), document.documentElement.style.setProperty("--content-min", t - e - s + "px"), document.querySelector("[data-tracking-consent].popup-cookies--bottom") && document.documentElement.style.setProperty("--cookie-bar-height", `${document.querySelector("[data-tracking-consent].popup-cookies--bottom").offsetHeight}px`)
    }

    function p() {
        return window.matchMedia("(orientation: portrait)").matches ? "portrait" : window.matchMedia("(orientation: landscape)").matches ? "landscape" : void 0
    }

    function m(t) {
        let e = document.querySelector(t);
        return e ? e.offsetHeight : 0
    }

    function g(t, e) {
        let i;
        return function() {
            if (t) {
                let s = () => t.apply(this, arguments);
                clearTimeout(i), i = setTimeout(s, e)
            }
        }
    }

    function v() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    }

    function f() {
        return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    }

    function y() {
        return v() >= window.theme.sizes.small
    }

    function b() {
        return v() < window.theme.sizes.small
    }
    window.initialWindowHeight = Math.min(window.screen.height, window.innerHeight);
    let S = v(),
        L = f(),
        E = window.scrollY,
        w = null,
        k = null,
        $ = null,
        A = null,
        C = 0;

    function T() {
        t.clearQueueScrollLocks(), t.enablePageScroll(), document.documentElement.removeAttribute("data-scroll-locked")
    }
    let q = (t, e = "", i) => {
        let s = i || document.createElement("div");
        return s.classList.add(e), t.parentNode.insertBefore(s, t), s.appendChild(t)
    };

    function x(t) {
        t.querySelectorAll(".rte table").forEach(t => {
            q(t, "rte__table-wrapper"), t.setAttribute("data-scroll-lock-scrollable", "")
        }), t.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe').forEach(t => {
            q(t, "rte__video-wrapper")
        })
    }

    function _(t) {
        let e = t.querySelectorAll("[data-aria-toggle]");
        e.length && e.forEach(t => {
            t.addEventListener("click", function(t) {
                t.preventDefault();
                let e = t.currentTarget;
                e.setAttribute("aria-expanded", "false" == e.getAttribute("aria-expanded") ? "true" : "false");
                let i = e.getAttribute("aria-controls"),
                    s = document.querySelector(`#${i}`),
                    r = () => {
                        s.classList.remove("expanding"), s.removeEventListener("transitionend", r)
                    },
                    o = () => {
                        s.classList.add("expanding"), s.removeEventListener("transitionstart", o)
                    };
                s.addEventListener("transitionstart", o), s.addEventListener("transitionend", r), s.classList.toggle("expanded")
            })
        })
    }
    let P = "is-loading";

    function M(t, e) {
        e = e || {};
        var i = t.tabIndex;
        t.tabIndex = -1, t.dataset.tabIndex = i, t.focus(), void 0 !== e.className && t.classList.add(e.className), t.addEventListener("blur", function s(r) {
            r.target.removeEventListener(r.type, s), t.tabIndex = i, delete t.dataset.tabIndex, void 0 !== e.className && t.classList.remove(e.className)
        })
    }

    function H(t) {
        return Array.prototype.slice.call(t.querySelectorAll("[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled")).filter(function(t) {
            var e, i;
            return !(!(t.offsetWidth || t.offsetHeight || t.getClientRects().length) || (e = t, "none" === (i = window.getComputedStyle(e)).display || "hidden" === i.visibility))
        })
    }
    var B = {};

    function I(t, e) {
        e = e || {};
        var i = H(t),
            s = e.elementToFocus || t,
            r = i[0],
            o = i[i.length - 1];
        D(), B.focusin = function(e) {
            t !== e.target && !t.contains(e.target) && r && r === e.target && r.focus(), e.target !== t && e.target !== o && e.target !== r || document.addEventListener("keydown", B.keydown)
        }, B.focusout = function() {
            document.removeEventListener("keydown", B.keydown)
        }, B.keydown = function(e) {
            "Tab" !== e.code || (e.target !== o || e.shiftKey || (e.preventDefault(), r.focus()), (e.target === t || e.target === r) && e.shiftKey && (e.preventDefault(), o.focus()))
        }, document.addEventListener("focusout", B.focusout), document.addEventListener("focusin", B.focusin), M(s, e)
    }

    function D() {
        document.removeEventListener("focusin", B.focusin), document.removeEventListener("focusout", B.focusout), document.removeEventListener("keydown", B.keydown)
    }

    function O() {
        window.accessibility.lastElement && document.body.classList.contains("is-focused") && setTimeout(() => {
            var t;
            null === (t = window.accessibility.lastElement) || void 0 === t || t.focus()
        })
    }
    var F = Object.freeze({
        __proto__: null,
        forceFocus: M,
        focusHash: function(t) {
            t = t || {};
            var e = window.location.hash,
                i = document.getElementById(e.slice(1));
            if (i && t.ignore && i.matches(t.ignore)) return !1;
            e && i && M(i, t)
        },
        bindInPageLinks: function(t) {
            return t = t || {}, Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter(function(e) {
                if ("#" === e.hash || "" === e.hash || t.ignore && e.matches(t.ignore) || (i = e.hash.substr(1), null === document.getElementById(i))) return !1;
                var i, s = document.querySelector(e.hash);
                return !!s && (e.addEventListener("click", function() {
                    M(s, t)
                }), !0)
            })
        },
        focusable: H,
        trapFocus: I,
        removeTrapFocus: D,
        autoFocusLastElement: O,
        accessibleLinks: function(t, e) {
            if ("string" != typeof t) throw TypeError(t + " is not a String.");
            if (0 !== (t = document.querySelectorAll(t)).length) {
                (e = e || {}).messages = e.messages || {};
                var i, s, r, o = {
                        newWindow: e.messages.newWindow || "Opens in a new window.",
                        external: e.messages.external || "Opens external website.",
                        newWindowExternal: e.messages.newWindowExternal || "Opens external website in a new window."
                    },
                    n = e.prefix || "a11y",
                    a = {
                        newWindow: n + "-new-window-message",
                        external: n + "-external-message",
                        newWindowExternal: n + "-new-window-external-message"
                    };
                t.forEach(function(t) {
                    var e, i = t.getAttribute("target"),
                        s = t.getAttribute("rel"),
                        r = (e = t).hostname !== window.location.hostname,
                        o = "_blank" === i,
                        n = null === s || -1 === s.indexOf("noopener");
                    o && n && t.setAttribute("rel", null === s ? "noopener" : s + " noopener"), r && o ? t.setAttribute("aria-describedby", a.newWindowExternal) : r ? t.setAttribute("aria-describedby", a.external) : o && t.setAttribute("aria-describedby", a.newWindow)
                }), i = o, s = document.createElement("ul"), r = Object.keys(i).reduce(function(t, e) {
                    return t + "<li id=" + a[e] + ">" + i[e] + "</li>"
                }, ""), s.setAttribute("hidden", !0), s.innerHTML = r, document.body.appendChild(s)
            }
        }
    });
    let R = 'input[type="search"]',
        N = "hidden",
        z = class extends HTMLElement {
            toggleResetButton() {
                let t = this.resetButton.classList.contains(N);
                this.input.value.length > 0 && t ? this.resetButton.classList.remove(N) : 0 !== this.input.value.length || t || this.resetButton.classList.add(N)
            }
            onChange() {
                this.toggleResetButton()
            }
            shouldResetForm() {
                return !document.querySelector('[aria-selected="true"] a')
            }
            onFormReset(t) {
                t.preventDefault(), this.shouldResetForm() && (this.input.value = "", this.toggleResetButton(), t.target.querySelector(R).focus())
            }
            constructor() {
                super(), this.input = this.querySelector(R), this.resetButton = this.querySelector('button[type="reset"]'), this.input && (this.input.form.addEventListener("reset", this.onFormReset.bind(this)), this.input.addEventListener("input", g(t => {
                    this.onChange(t)
                }, 300).bind(this)))
            }
        };
    customElements.define("header-search-form", z);
    let W = '[aria-selected="true"]',
        U = '[aria-selected="true"] a',
        V = "[data-popout-toggle]",
        j = "[data-popout-option]",
        X = "popout-list--visible",
        G = "is-active",
        Y = "select-popout--top",
        J = "aria-expanded",
        Q = "aria-current",
        K = "data-value",
        Z = "data-popout-toggle-text",
        tt = class extends HTMLElement {
            connectedCallback() {
                this.popoutList = this.querySelector("[data-popout-list]"), this.popoutToggle = this.querySelector(V), this.popoutToggleText = this.querySelector("[data-popout-toggle-text]"), this.popoutInput = this.querySelector("[data-popout-input]"), this.popoutOptions = this.querySelectorAll(j), this.productGridItem = this.popoutList.closest("[data-grid-item]"), this.fireSubmitEvent = this.hasAttribute("submit"), this.popupToggleFocusoutEvent = t => this.onPopupToggleFocusout(t), this.popupListFocusoutEvent = t => this.onPopupListFocusout(t), this.popupToggleClickEvent = t => this.onPopupToggleClick(t), this.keyUpEvent = t => this.onKeyUp(t), this.bodyClickEvent = t => this.onBodyClick(t), this._connectOptions(), this._connectToggle(), this._onFocusOut(), this.popupListMaxWidth()
            }
            onPopupToggleClick(t) {
                let e = "true" === t.currentTarget.getAttribute(J);
                if (this.productGridItem) {
                    let i = this.productGridItem.querySelector("[data-product-image]");
                    i && i.classList.toggle("is-visible", !e), this.popoutList.style.maxHeight = `${Math.abs(this.popoutToggle.getBoundingClientRect().bottom-this.productGridItem.getBoundingClientRect().bottom)}px`
                }
                t.currentTarget.setAttribute(J, !e), this.popoutList.classList.toggle(X), this.popupListMaxWidth(), this.toggleListPosition(), document.body.addEventListener("click", this.bodyClickEvent)
            }
            onPopupToggleFocusout(t) {
                this.contains(t.relatedTarget) || this._hideList()
            }
            onPopupListFocusout(t) {
                let e = t.currentTarget.contains(t.relatedTarget);
                this.popoutList.classList.contains(X) && !e && this._hideList()
            }
            toggleListPosition() {
                let t = "true" === this.querySelector(V).getAttribute(J),
                    e = window.innerHeight,
                    i = this.popoutList.getBoundingClientRect().bottom,
                    s = () => {
                        this.classList.remove(Y), this.popoutList.removeEventListener("transitionend", s)
                    };
                t ? e < i && this.classList.add(Y) : this.popoutList.addEventListener("transitionend", s)
            }
            popupListMaxWidth() {
                this.popoutList.style.setProperty("--max-width", "100vw"), requestAnimationFrame(() => {
                    this.popoutList.style.setProperty("--max-width", `${parseInt(document.body.clientWidth-this.popoutList.getBoundingClientRect().left)}px`)
                })
            }
            popupOptionsClick(t) {
                if ("#" === t.target.closest(j).attributes.href.value) {
                    t.preventDefault();
                    let e = t.currentTarget.hasAttribute(K) ? t.currentTarget.getAttribute(K) : "";
                    if (this.popoutInput.value = e, this.popoutInput.disabled && this.popoutInput.removeAttribute("disabled"), this.fireSubmitEvent) this._submitForm(e);
                    else {
                        let i = t.currentTarget.parentElement,
                            s = this.popoutList.querySelector(`.${G}`),
                            r = this.popoutList.querySelector(`[${Q}]`);
                        this.popoutInput.dispatchEvent(new Event("change")), s && (s.classList.remove(G), i.classList.add(G)), "quantity" != this.popoutInput.name || i.nextSibling || this.classList.add(G), r && r.hasAttribute(`${Q}`) && (r.removeAttribute(`${Q}`), t.currentTarget.setAttribute(`${Q}`, "true")), "" !== e && (this.popoutToggleText.innerHTML = e, this.popoutToggleText.hasAttribute(Z) && "" !== this.popoutToggleText.getAttribute(Z) && this.popoutToggleText.setAttribute(Z, e)), this.onPopupToggleFocusout(t), this.onPopupListFocusout(t)
                    }
                }
            }
            onKeyUp(t) {
                "Escape" === t.code && (this._hideList(), this.popoutToggle.focus())
            }
            onBodyClick(t) {
                let e = this.contains(t.target);
                this.popoutList.classList.contains(X) && !e && this._hideList()
            }
            _connectToggle() {
                this.popoutToggle.addEventListener("click", this.popupToggleClickEvent)
            }
            _connectOptions() {
                this.popoutOptions.length && this.popoutOptions.forEach(t => {
                    t.addEventListener("click", t => this.popupOptionsClick(t))
                })
            }
            _onFocusOut() {
                this.addEventListener("keyup", this.keyUpEvent), this.popoutToggle.addEventListener("focusout", this.popupToggleFocusoutEvent), this.popoutList.addEventListener("focusout", this.popupListFocusoutEvent)
            }
            _submitForm() {
                let t = this.closest("form");
                t && t.submit()
            }
            _hideList() {
                this.popoutList.classList.remove(X), this.popoutToggle.setAttribute(J, !1), this.toggleListPosition(), document.body.removeEventListener("click", this.bodyClickEvent)
            }
            constructor() {
                super()
            }
        },
        te = class extends HTMLElement {
            connectedCallback() {
                this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
                    bubbles: !0
                }), this.buttonClickEvent = this.onButtonClick.bind(this), this.onQuantityChangeEvent = this.onQuantityChange.bind(this), this.input.addEventListener("change", this.onQuantityChangeEvent), this.querySelectorAll("button").forEach(t => t.addEventListener("click", this.buttonClickEvent))
            }
            onButtonClick(t) {
                t.preventDefault();
                let e = this.input.value,
                    i = "BUTTON" == t.target.nodeName ? t.target : t.target.closest("button");
                "increase" === i.name && this.input.stepUp(), "decrease" === i.name && this.input.stepDown(), e !== this.input.value && this.input.dispatchEvent(this.changeEvent)
            }
            async onQuantityChange() {
                let t = parseInt(this.input.getAttribute("data-qty")),
                    e = parseInt(this.input.getAttribute("data-price")),
                    i = parseInt(this.input.value);
                if (i > t) {
                    try {
                        let s = await fetchCart();
                        if (!s) return;
                        let r = s.item_count,
                            o = s.items_subtotal_price,
                            n = s.currency;
                        if (e) {
                            let a = o + e;
                            //if ((a > 13e3 && "GBP" === n) && (this.input.value = t), a > 13e3 && "GBP" === n) return void sizeVariantsdisplayCartError("Your order value exceeds GBP 135 and cannot be processed.");
                            if ((a > 58000 && "CAD" === n) && (this.input.value = t), a > 58000 && "CAD" === n) return void sizeVariantsdisplayCartError("Due to fulfillment challenges caused by the DHL Express strike, baskets are currently limited to 580 CAD.");
                            if (r >= 6) return void sizeVariantsdisplayCartError("Please note that you cannot order more than 6 items at once")
                        }
                    } catch (l) {
                        console.error("Error:", l), sizeVariantsdisplayCartError("An error occurred while adding the product to the cart.")
                    }
                    "updates[]" == this.input.name && this.updateCart()
                } else {
                    try {
                        let h = await fetchCart();
                        if (!h) return;
                        h.item_count;
                        let c = h.items_subtotal_price,
                            d = h.currency;
                        if (e) {
                            // if (c - e > 13e3 && "GBP" === d) {
                            //     let u = document.querySelector(".cart__aside"),
                            //         p = document.querySelector(".cart__buttons-wrapper .cart__checkout");
                            //     "" == document.querySelector("#cart-error") && u.insertAdjacentHTML("afterbegin", '<div id="cart-error" style="color: red;">Your order value exceeds GBP 135 and cannot be processed.</div>'), setTimeout(function() {
                            //         p.disabled = !0
                            //     }, 2e3)
                            // } else {
                            //     let m = document.querySelector("#cart-error"),
                            //         g = document.querySelector(".cart__buttons-wrapper .cart__checkout");
                            //     m && (m.remove(), g.disabled = !1)
                            // }
                            /*if (c - e > 58000 && "CAD" === d) {
                                let u = document.querySelector(".cart__aside"),
                                    p = document.querySelector(".cart__buttons-wrapper .cart__checkout");
                                "" == document.querySelector("#cart-error") && u.insertAdjacentHTML("afterbegin", '<div id="cart-error" style="color: red;">Due to fulfillment challenges caused by the DHL Express strike, baskets are currently limited to 580 CAD.</div>'), setTimeout(function() {
                                    p.disabled = !0
                                }, 2e3)
                            } else {
                                let m = document.querySelector("#cart-error"),
                                    g = document.querySelector(".cart__buttons-wrapper .cart__checkout");
                                m && (m.remove(), g.disabled = !1)
                            }*/
                        }
                    } catch (v) {
                        console.error("Error:", v), sizeVariantsdisplayCartError("An error occurred while adding the product to the cart.")
                    }
                    "updates[]" == this.input.name && this.updateCart()
                }
            }
            updateCart() {
                "" !== this.quantityValue && this.dispatchEvent(new CustomEvent("theme:cart:update", {
                    bubbles: !0,
                    detail: {
                        id: this.input.dataset.id,
                        quantity: this.input.value
                    }
                }))
            }
            constructor() {
                super()
            }
        },
        ti = "[data-aos]:not(.aos-animate)",
        ts = "[data-aos-anchor]",
        tr = "aos-animate",
        to = [],
        tn = new IntersectionObserver((t, e) => {
            t.forEach(t => {
                t.isIntersecting && (t.target.classList.add(tr), e.unobserve(t.target))
            })
        }, {
            root: null,
            rootMargin: "0px",
            threshold: [0, .1, .25, .5, .75, 1]
        }),
        ta = new IntersectionObserver((t, e) => {
            t.forEach(t => {
                if (t.intersectionRatio) {
                    let i = t.target.querySelectorAll(ti);
                    i.length && i.forEach(t => {
                        t.classList.add(tr)
                    }), e.unobserve(t.target)
                }
            })
        }, {
            root: null,
            rootMargin: "0px",
            threshold: [.1, .25, .5, .75, 1]
        });

    function tl(t) {
        t.length && t.forEach(t => {
            let e = t.dataset.aosAnchor;
            if (e && -1 === to.indexOf(e)) {
                let i = document.querySelector(e);
                i && (ta.observe(i), to.push(e))
            }
        })
    }
    let th = "srcset",
        tc = class extends HTMLElement {
            connectedCallback() {
                if (this.isRendered) return;
                let t = new IntersectionObserver(e => {
                    e.forEach(e => {
                        if (e.intersectionRatio > 0) {
                            let i = this.querySelector("template"),
                                s = null == i ? void 0 : i.content.firstElementChild.cloneNode(!0);
                            this.appendChild(s), this.reloadSrcset(this), t.disconnect()
                        }
                    })
                }, {
                    threshold: [.01, .25, .5, .75, 1]
                });
                t.observe(this), this.isRendered = !0
            }
            reloadSrcset(t) {
                t && t.querySelectorAll("img").forEach(t => {
                    let e = t.getAttribute(th);
                    t.setAttribute(th, ""), t.setAttribute(th, e)
                })
            }
            constructor() {
                super(), this.isRendered = !1
            }
        },
        td = '[data-host="youtube"]',
        tu = '[data-host="vimeo"]',
        tp = "video",
        tm = "loaded",
        tg = class extends HTMLElement {
            connectedCallback() {
                this.productGridItem && (this.section.addEventListener("mouseover", this.mouseOverEvent, {
                    once: !0
                }), this.addEventListener("mouseenter", this.mouseEnterEvent), this.addEventListener("mouseleave", this.mouseLeaveEvent))
            }
            disconnectedCallback() {
                this.productGridItem && (this.section.removeEventListener("mouseover", this.mouseOverEvent, {
                    once: !0
                }), this.removeEventListener("mouseenter", this.mouseEnterEvent), this.removeEventListener("mouseleave", this.mouseLeaveEvent))
            }
            mouseEnterActions() {
                this.hovered = !0, this.videoActions(), this.getAttribute(tm) || this.loadContent()
            }
            mouseLeaveActions() {
                this.hovered = !1, this.videoActions()
            }
            videoActions() {
                if (this.getAttribute(tm)) {
                    let t = this.querySelector(td),
                        e = this.querySelector(tu),
                        i = t || e,
                        s = this.querySelector(tp);
                    if (i) {
                        let r = this.hovered ? "playVideo" : "pauseVideo",
                            o = `{"event":"command","func":"${r}","args":""}`;
                        e && (o = `{"method":"${r=this.hovered?"play":"pause"}"}`), i.contentWindow.postMessage(o, "*"), i.addEventListener("load", t => {
                            this.videoActions()
                        })
                    } else s && (this.hovered ? s.play() : s.pause())
                }
            }
            loadContent(t = !0) {
                if (this.pauseAllMedia(), !this.getAttribute(tm)) {
                    let e = document.createElement("div"),
                        i = this.querySelector("template").content.firstElementChild.cloneNode(!0);
                    e.appendChild(i), this.setAttribute(tm, !0);
                    let s = this.appendChild(e.querySelector("video, model-viewer, iframe"));
                    t && s.focus(), "VIDEO" == s.nodeName && s.getAttribute("autoplay") && s.play(), this.productGridItem && this.videoActions()
                }
            }
            pauseAllMedia() {
                document.querySelectorAll(td).forEach(t => {
                    t.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
                }), document.querySelectorAll(tu).forEach(t => {
                    t.contentWindow.postMessage('{"method":"pause"}', "*")
                }), document.querySelectorAll(tp).forEach(t => t.pause()), document.querySelectorAll("product-model").forEach(t => {
                    t.modelViewerUI && t.modelViewerUI.pause()
                })
            }
            constructor() {
                super();
                let t = this.querySelector("[data-deferred-media-button]");
                null == t || t.addEventListener("click", this.loadContent.bind(this)), this.section = this.closest(".shopify-section"), this.productGridItem = this.closest("[data-grid-item]"), this.hovered = !1, this.mouseEnterEvent = () => this.mouseEnterActions(), this.mouseLeaveEvent = () => this.mouseLeaveActions()
            }
        },
        tv = "is-visible";
    class tf {
        init() {
            var t;
            let e = {
                root: this.container,
                threshold: [.01, .5, .75, .99]
            };
            this.observer = new IntersectionObserver(t => {
                t.forEach(t => {
                    t.intersectionRatio >= .99 ? t.target.classList.add(tv) : t.target.classList.remove(tv)
                })
            }, e), null === (t = this.container.querySelectorAll(this.itemSelector)) || void 0 === t || t.forEach(t => {
                this.observer.observe(t)
            })
        }
        destroy() {
            this.observer.disconnect()
        }
        constructor(t, e) {
            t && e && (this.observer = null, this.container = t, this.itemSelector = e, this.init())
        }
    }
    let ty = "is-dragging",
        tb = "is-enabled",
        tS = "is-scrolling";
    class tL {
        handleMouseDown(t) {
            t.preventDefault(), this.isDown = !0, this.startX = t.pageX - this.slider.offsetLeft, this.scrollLeft = this.slider.scrollLeft, this.cancelMomentumTracking()
        }
        handleMouseLeave() {
            this.isDown && (this.isDown = !1, this.beginMomentumTracking())
        }
        handleMouseUp() {
            this.isDown = !1, this.beginMomentumTracking()
        }
        handleMouseMove(t) {
            if (!this.isDown) return;
            t.preventDefault();
            let e = 1 * (t.pageX - this.slider.offsetLeft - this.startX),
                i = this.slider.scrollLeft;
            this.slider.classList.add(ty, tS), this.slider.scrollLeft = this.scrollLeft - e, this.slider.scrollLeft !== i && (this.velX = this.slider.scrollLeft - i || (e > 0 ? 1 : -1))
        }
        handleMouseWheel() {
            this.cancelMomentumTracking(), this.slider.classList.remove(tS)
        }
        beginMomentumTracking() {
            this.isScrolling = !1, this.slider.classList.remove(ty), this.cancelMomentumTracking(), this.scrollToSlide()
        }
        cancelMomentumTracking() {
            cancelAnimationFrame(this.scrollAnimation)
        }
        scrollToSlide() {
            if (!this.velX && !this.isScrolling) return;
            let t = this.slider.querySelector("[data-grid-item].is-visible");
            if (!t) return;
            let e = parseInt(window.getComputedStyle(t).marginRight) || 0,
                i = t.offsetWidth + e,
                s = t.offsetLeft,
                r = this.velX > 0 ? 1 : -1,
                o = Math.floor(Math.abs(this.velX) / 100) || 1;
            this.startPosition = this.slider.scrollLeft, this.distance = s - this.startPosition, this.startTime = performance.now(), this.isScrolling = !0, r < 0 && this.velX < i && (this.distance -= i * o), r > 0 && this.velX < i && (this.distance += i * o), this.scrollAnimation = requestAnimationFrame(this.scrollStep)
        }
        scrollStep() {
            let t = performance.now() - this.startTime,
                e = parseFloat(this.easeOutCubic(Math.min(t, this.duration))).toFixed(1);
            this.slider.scrollLeft = e, t < this.duration ? this.scrollAnimation = requestAnimationFrame(this.scrollStep) : (this.slider.classList.remove(tS), this.velX = 0, this.isScrolling = !1)
        }
        easeOutCubic(t) {
            return t /= this.duration, t--, this.distance * (t * t * t + 1) + this.startPosition
        }
        destroy() {
            this.slider.classList.remove(tb), this.slider.removeEventListener("mousedown", this.handleMouseDown), this.slider.removeEventListener("mouseleave", this.handleMouseLeave), this.slider.removeEventListener("mouseup", this.handleMouseUp), this.slider.removeEventListener("mousemove", this.handleMouseMove), this.slider.removeEventListener("wheel", this.handleMouseWheel)
        }
        constructor(t) {
            this.slider = t, this.isDown = !1, this.startX = 0, this.scrollLeft = 0, this.velX = 0, this.scrollAnimation = null, this.isScrolling = !1, this.duration = 800, this.scrollStep = this.scrollStep.bind(this), this.scrollToSlide = this.scrollToSlide.bind(this), this.handleMouseDown = this.handleMouseDown.bind(this), this.handleMouseLeave = this.handleMouseLeave.bind(this), this.handleMouseUp = this.handleMouseUp.bind(this), this.handleMouseMove = this.handleMouseMove.bind(this), this.handleMouseWheel = this.handleMouseWheel.bind(this), this.slider.addEventListener("mousedown", this.handleMouseDown), this.slider.addEventListener("mouseleave", this.handleMouseLeave), this.slider.addEventListener("mouseup", this.handleMouseUp), this.slider.addEventListener("mousemove", this.handleMouseMove), this.slider.addEventListener("wheel", this.handleMouseWheel, {
                passive: !0
            }), this.slider.classList.add(tb)
        }
    }
    let tE = "[data-button-arrow]",
        tw = "[data-grid-item]",
        tk = "data-button-prev",
        t$ = "data-button-next",
        tA = "slider__arrows",
        tC = "is-visible";
    class tT extends HTMLElement {
        connectedCallback() {
            this.init(), this.addEventListener("theme:grid-slider:init", this.init)
        }
        init() {
            this.slider = this.querySelector("[data-grid-slider]"), this.slides = this.querySelectorAll(tw), this.buttons = this.querySelectorAll(tE), this.toggleSlider(), document.addEventListener("theme:resize:width", this.toggleSlider)
        }
        toggleSlider() {
            this.slider.clientWidth < this.getSlidesWidth() && (y() || !window.theme.touch) ? this.isInitialized || (this.slidesObserver = new tf(this.slider, tw), this.initArrows(), this.isInitialized = !0, this.draggableSlider = new tL(this.slider)) : this.destroy()
        }
        initArrows() {
            if (!this.buttons.length) {
                let t = document.createElement("div");
                t.classList.add(tA), t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next, this.append(t), this.buttons = this.querySelectorAll(tE), this.buttonPrev = this.querySelector(`[${tk}]`), this.buttonNext = this.querySelector(`[${t$}]`)
            }
            this.toggleArrowsObserver(), this.hasAttribute("align-arrows") && (this.positionArrows(), this.arrowsResizeObserver()), this.buttons.forEach(t => {
                t.addEventListener("click", this.onButtonArrowClick)
            })
        }
        buttonArrowClickEvent(t) {
            t.preventDefault();
            let e = this.slider.querySelector(`${tw}.${tC}`),
                i = null;
            t.target.hasAttribute(tk) && (i = null == e ? void 0 : e.previousElementSibling), t.target.hasAttribute(t$) && (i = null == e ? void 0 : e.nextElementSibling), this.goToSlide(i)
        }
        removeArrows() {
            var t;
            null === (t = this.querySelector(`.${tA}`)) || void 0 === t || t.remove()
        }
        goToSlide(t) {
            t && this.slider.scrollTo({
                top: 0,
                left: t.offsetLeft,
                behavior: "smooth"
            })
        }
        getSlidesWidth() {
            var t;
            return (null === (t = this.slider.querySelector(tw)) || void 0 === t ? void 0 : t.clientWidth) * this.slider.querySelectorAll(tw).length
        }
        toggleArrowsObserver() {
            if (this.buttonPrev && this.buttonNext) {
                let t = this.slides.length,
                    e = this.slides[0],
                    i = this.slides[t - 1],
                    s = {
                        attributes: !0,
                        childList: !1,
                        subtree: !1
                    },
                    r = t => {
                        for (let s of t)
                            if ("attributes" === s.type) {
                                let r = s.target,
                                    o = Boolean(r.classList.contains(tC));
                                r == e && (this.buttonPrev.disabled = o), r == i && (this.buttonNext.disabled = o)
                            }
                    };
                e && i && (this.firstLastSlidesObserver = new MutationObserver(r), this.firstLastSlidesObserver.observe(e, s), this.firstLastSlidesObserver.observe(i, s))
            }
        }
        positionArrows() {
            let t = this.slider.querySelector("[data-product-image]") || this.slider.querySelector("[data-collection-image]") || this.slider.querySelector("[data-column-image]") || this.slider;
            t && this.style.setProperty("--button-position", t.clientHeight / 2 + "px")
        }
        arrowsResizeObserver() {
            document.addEventListener("theme:resize:width", this.positionArrows)
        }
        disconnectedCallback() {
            this.destroy(), document.removeEventListener("theme:resize:width", this.toggleSlider)
        }
        destroy() {
            var t, e;
            this.isInitialized = !1, null === (t = this.draggableSlider) || void 0 === t || t.destroy(), this.draggableSlider = null, null === (e = this.slidesObserver) || void 0 === e || e.destroy(), this.slidesObserver = null, this.removeArrows(), document.removeEventListener("theme:resize:width", this.positionArrows)
        }
        constructor() {
            super(), this.isInitialized = !1, this.draggableSlider = null, this.positionArrows = this.positionArrows.bind(this), this.onButtonArrowClick = t => this.buttonArrowClickEvent(t), this.slidesObserver = null, this.firstLastSlidesObserver = null, this.isDragging = !1, this.toggleSlider = this.toggleSlider.bind(this)
        }
    }
    let tq = class extends HTMLElement {
            connectedCallback() {
                isNaN(this.endDate) || this.endDate <= Date.now() ? this.onComplete() : this.interval = setInterval(this.update, 1e3)
            }
            disconnectedCallback() {
                this.stopTimer()
            }
            convertTime(t) {
                let e = this.formatDigits(parseInt(t / this.daysInMs, 10));
                t -= e * this.daysInMs;
                let i = this.formatDigits(parseInt(t / this.hoursInMs, 10));
                t -= i * this.hoursInMs;
                let s = this.formatDigits(parseInt(t / this.minutesInMs, 10));
                return t -= s * this.minutesInMs, {
                    days: e,
                    hours: i,
                    minutes: s,
                    seconds: this.formatDigits(parseInt(t / this.secondsInMs, 10))
                }
            }
            formatDigits(t) {
                return t < 10 && (t = "0" + t), t
            }
            render(t) {
                this.days.textContent = t.days, this.hours.textContent = t.hours, this.minutes.textContent = t.minutes, this.seconds.textContent = t.seconds
            }
            stopTimer() {
                clearInterval(this.interval)
            }
            onComplete() {
                var t, e;
                this.render({
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0
                }), this.shouldHideOnComplete && (null === (t = this.shopifySection) || void 0 === t || t.classList.add("hidden")), this.shouldShowMessage && (null === (e = this.classList) || void 0 === e || e.add("show-message"))
            }
            update() {
                let t = new Date().getTime(),
                    e = this.endDate - t;
                e <= 0 && (this.stopTimer(), this.onComplete());
                let i = this.convertTime(e);
                this.render(i)
            }
            constructor() {
                super(), this.shopifySection = this.closest(".shopify-section"), this.expirationBehavior = this.getAttribute("data-expiration-behavior"), this.time = this.querySelector("time"), this.days = this.querySelector("[data-days]"), this.hours = this.querySelector("[data-hours]"), this.minutes = this.querySelector("[data-minutes]"), this.seconds = this.querySelector("[data-seconds]"), this.endDate = Date.parse(this.time.dateTime), this.daysInMs = 864e5, this.hoursInMs = this.daysInMs / 24, this.minutesInMs = this.hoursInMs / 60, this.secondsInMs = this.minutesInMs / 60, this.shouldHideOnComplete = "hide-section" === this.expirationBehavior, this.shouldShowMessage = "show-message" === this.expirationBehavior, this.update = this.update.bind(this)
            }
        },
        tx;
    window.requestIdleCallback = window.requestIdleCallback || function(t) {
        var e = Date.now();
        return setTimeout(function() {
            t({
                didTimeout: !1,
                timeRemaining: function() {
                    return Math.max(0, 50 - (Date.now() - e))
                }
            })
        }, 1)
    }, window.cancelIdleCallback = window.cancelIdleCallback || function(t) {
        clearTimeout(t)
    }, window.theme.settings.enableAnimations && (function() {
        let t = document.querySelectorAll("[data-aos]:not([data-aos-anchor]):not(.aos-animate)");
        t.length && t.forEach(t => {
            tn.observe(t)
        })
    }(), function() {
        let t = document.querySelectorAll(ts);
        t.length && tl(t)
    }(), new MutationObserver(t => {
        for (let e of t)
            if ("childList" === e.type) {
                let i = e.target,
                    s = i.querySelectorAll(ti),
                    r = i.querySelectorAll(ts);
                s.length && s.forEach(t => {
                    tn.observe(t)
                }), r.length && tl(r)
            }
    }).observe(document.body, {
        attributes: !1,
        childList: !0,
        subtree: !0
    }), document.addEventListener("shopify:section:unload", t => {
        var e;
        let i = "#" + (null === (e = t.target.querySelector("[data-section-id]")) || void 0 === e ? void 0 : e.id),
            s = to.indexOf(i); - 1 !== s && to.splice(s, 1)
    })), window.addEventListener("resize", g(function() {
        document.dispatchEvent(new CustomEvent("theme:resize", {
            bubbles: !0
        })), S !== v() && (document.dispatchEvent(new CustomEvent("theme:resize:width", {
            bubbles: !0
        })), S = v()), L !== f() && (document.dispatchEvent(new CustomEvent("theme:resize:height", {
            bubbles: !0
        })), L = f())
    }, 50)), window.addEventListener("scroll", function() {
        tx && window.cancelAnimationFrame(tx), tx = window.requestAnimationFrame(function() {
            ! function() {
                let t = window.scrollY;
                t > E ? (k = !0, w = !1) : t < E ? (k = !1, w = !0) : (w = null, k = null), E = t, document.dispatchEvent(new CustomEvent("theme:scroll", {
                    detail: {
                        up: w,
                        down: k,
                        position: t
                    },
                    bubbles: !1
                })), w && !$ && document.dispatchEvent(new CustomEvent("theme:scroll:up", {
                    detail: {
                        position: t
                    },
                    bubbles: !1
                })), k && !A && document.dispatchEvent(new CustomEvent("theme:scroll:down", {
                    detail: {
                        position: t
                    },
                    bubbles: !1
                })), A = k, $ = w
            }()
        })
    }, {
        passive: !0
    }), window.addEventListener("theme:scroll:lock", function e(i) {
        setTimeout(() => {
            C && clearTimeout(C), t.disablePageScroll(i.detail, {
                allowTouchMove: t => "TEXTAREA" === t.tagName
            }), document.documentElement.setAttribute("data-scroll-locked", "")
        })
    }), window.addEventListener("theme:scroll:unlock", function t(e) {
        let i = e.detail;
        i ? C = setTimeout(T, i) : T()
    }), "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? (document.documentElement.className = document.documentElement.className.replace("no-touch", "supports-touch"), window.theme.touch = !0) : window.theme.touch = !1, d(), document.addEventListener("load", t => {
        "img" == t.target.tagName.toLowerCase() && t.target.classList.contains(P) && (t.target.classList.remove(P), t.target.parentNode.classList.remove(P), t.target.parentNode.parentNode.classList.contains(P) && t.target.parentNode.parentNode.classList.remove(P))
    }, !0), window.addEventListener("DOMContentLoaded", () => {
        c(), _(document), a(document), x(document), document.querySelectorAll("img.is-loading").forEach(t => {
            t.complete && (t.classList.remove(P), t.parentNode.classList.remove(P), t.parentNode.parentNode.classList.contains(P) && t.parentNode.parentNode.classList.remove(P))
        }), document.body.classList.add("is-loaded"), requestIdleCallback(() => {
            Shopify.visualPreviewMode && document.documentElement.classList.add("preview-mode")
        })
    }), document.addEventListener("shopify:section:load", t => {
        let e = t.target;
        a(e), x(e), _(document), c()
    }), customElements.get("popout-select") || customElements.define("popout-select", tt), customElements.get("quantity-counter") || customElements.define("quantity-counter", te), customElements.get("predictive-search") || customElements.define("predictive-search", class extends z {
        connectedCallback() {
            this.input.addEventListener("focus", this.onFocus.bind(this)), this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.addEventListener("keyup", this.onKeyup.bind(this)), this.addEventListener("keydown", this.onKeydown.bind(this))
        }
        getQuery() {
            return this.input.value.trim()
        }
        onChange() {
            var t;
            super.onChange();
            let e = this.getQuery();
            this.searchTerm && e.startsWith(this.searchTerm) || null === (t = this.querySelector("[data-search-results-groups-wrapper]")) || void 0 === t || t.remove(), this.updateSearchForTerm(this.searchTerm, e), this.searchTerm = e, this.searchTerm.length ? this.getSearchResults(this.searchTerm) : this.reset()
        }
        onFormSubmit(t) {
            this.getQuery().length && !this.querySelector(U) || t.preventDefault()
        }
        onFormReset(t) {
            super.onFormReset(t), super.shouldResetForm() && (this.searchTerm = "", this.abortController.abort(), this.abortController = new AbortController, this.closeResults(!0))
        }
        shouldResetForm() {
            return !document.querySelector(U)
        }
        onFocus() {
            let t = this.getQuery();
            t.length && (this.searchTerm !== t ? this.onChange() : "true" === this.getAttribute("results") ? this.open() : this.getSearchResults(this.searchTerm))
        }
        onFocusOut() {
            setTimeout(() => {
                this.contains(document.activeElement) || this.close()
            })
        }
        onKeyup(t) {
            switch (this.getQuery().length || this.close(!0), t.preventDefault(), t.code) {
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "Enter":
                    this.selectOption()
            }
        }
        onKeydown(t) {
            "ArrowUp" !== t.code && "ArrowDown" !== t.code || t.preventDefault()
        }
        updateSearchForTerm(t, e) {
            let i = this.querySelector("[data-predictive-search-search-for-text]"),
                s = null == i ? void 0 : i.innerText;
            if (s) {
                var r;
                if ((null === (r = s.match(RegExp(t, "g"))) || void 0 === r ? void 0 : r.length) > 1) return;
                let o = s.replace(t, e);
                i.innerText = o
            }
        }
        switchOption(t) {
            if (!this.getAttribute("open")) return;
            let e = "up" === t,
                i = this.querySelector(W),
                s = Array.from(this.querySelectorAll('[role="option"]')).filter(t => null !== t.offsetParent),
                r = 0;
            if (e && !i) return;
            let o = -1,
                n = 0;
            for (; - 1 === o && n <= s.length;) s[n] === i && (o = n), n++;
            if (this.statusElement.textContent = "", !e && i ? r = o === s.length - 1 ? 0 : o + 1 : e && (r = 0 === o ? s.length - 1 : o - 1), r === o) return;
            let a = s[r];
            a.setAttribute("aria-selected", !0), i && i.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", a.id)
        }
        selectOption() {
            let t = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
            t && t.click()
        }
        getSearchResults(t) {
            let e = t.replace(" ", "-").toLowerCase();
            this.setLiveRegionLoadingState(), this.cachedResults[e] ? this.renderSearchResults(this.cachedResults[e]) : fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(t)}&section_id=predictive-search`, {
                signal: this.abortController.signal
            }).then(t => {
                if (!t.ok) {
                    var e = Error(t.status);
                    throw this.close(), e
                }
                return t.text()
            }).then(t => {
                let i = new DOMParser().parseFromString(t, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
                this.allPredictiveSearchInstances.forEach(t => {
                    t.cachedResults[e] = i
                }), this.renderSearchResults(i)
            }).catch(t => {
                if (20 !== (null == t ? void 0 : t.code)) throw this.close(), t
            })
        }
        setLiveRegionLoadingState() {
            this.statusElement = this.statusElement || this.querySelector("[data-predictive-search-status]"), this.loadingText = this.loadingText || this.getAttribute("data-loading-text"), this.setLiveRegionText(this.loadingText), this.setAttribute("loading", !0)
        }
        setLiveRegionText(t) {
            this.statusElement.setAttribute("aria-hidden", "false"), this.statusElement.textContent = t, setTimeout(() => {
                this.statusElement.setAttribute("aria-hidden", "true")
            }, 1e3)
        }
        renderSearchResults(t) {
            this.predictiveSearchResults.innerHTML = t, this.setAttribute("results", !0), this.setLiveRegionResults(), this.open()
        }
        setLiveRegionResults() {
            this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent)
        }
        open() {
            this.setAttribute("open", !0), this.input.setAttribute("aria-expanded", !0), this.isOpen = !0
        }
        close(t = !1) {
            this.closeResults(t), this.isOpen = !1
        }
        closeResults(t = !1) {
            var e;
            t && (this.input.value = "", this.removeAttribute("results"));
            let i = this.querySelector(W);
            i && i.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", ""), this.removeAttribute("loading"), this.removeAttribute("open"), this.input.setAttribute("aria-expanded", !1), null === (e = this.predictiveSearchResults) || void 0 === e || e.removeAttribute("style")
        }
        reset() {
            this.predictiveSearchResults.innerHTML = "", this.input.val = "", this.a11y.removeTrapFocus(), this.popularSearches && (this.input.dispatchEvent(new Event("blur", {
                bubbles: !1
            })), this.a11y.trapFocus(this.searchPopdown, {
                elementToFocus: this.input
            }))
        }
        constructor() {
            var t;
            super(), this.a11y = F, this.abortController = new AbortController, this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search"), this.cachedResults = {}, this.input = this.querySelector('input[type="search"]'), this.isOpen = !1, this.predictiveSearchResults = this.querySelector("[data-predictive-search-results]"), this.searchPopdown = this.closest("[data-popdown]"), this.popularSearches = null === (t = this.searchPopdown) || void 0 === t ? void 0 : t.querySelector("[data-popular-searches]"), this.searchTerm = ""
        }
    }), customElements.get("deferred-image") || customElements.define("deferred-image", tc), customElements.get("deferred-media") || customElements.define("deferred-media", tg), customElements.get("grid-slider") || customElements.define("grid-slider", tT), customElements.get("countdown-timer") || customElements.define("countdown-timer", tq);
    let t_ = (t, e = !1, i = "block") => {
        t && (e ? t.style.removeProperty("display") : t.style.display = i)
    };
    Shopify.Products = function() {
        let t = {
                howManyToShow: 4,
                howManyToStoreInMemory: 10,
                wrapperId: "recently-viewed-products",
                section: null,
                onComplete: null
            },
            e = [],
            i = null,
            s = null,
            r = new Date,
            o = new Date;
        o.setTime(r.getTime() + 7776e6);
        let n = {
                configuration: {
                    expires: o.toGMTString(),
                    path: "/",
                    domain: window.location.hostname,
                    sameSite: "none",
                    secure: !0
                },
                name: "shopify_recently_viewed",
                write: function(t) {
                    let e = t.join(" ");
                    document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`
                },
                read: function() {
                    let t = [],
                        e = null;
                    return -1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find(t => t.startsWith(this.name)) && (e = document.cookie.split("; ").find(t => t.startsWith(this.name)).split("=")[1]), null !== e && (t = e.split(" ")), t
                },
                destroy: function() {
                    document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`
                },
                remove: function(t) {
                    let e = this.read(),
                        i = e.indexOf(t); - 1 !== i && (e.splice(i, 1), this.write(e))
                }
            },
            a = (e, i, r, o) => {
                i.length && e < t.howManyToShow ? fetch(`${window.theme.routes.root}products/${i[0]}?section_id=api-product-grid-item`).then(t => t.text()).then(t => {
                    let s = 100 * e,
                        n = r.id ? `#${r.id}` : "",
                        l = document.createElement("div"),
                        h = t;
                    h = (h = h.includes("||itemAnimationDelay||") ? h.replaceAll("||itemAnimationDelay||", s) : h).includes("||itemAnimationAnchor||") ? h.replaceAll("||itemAnimationAnchor||", n) : h, l.innerHTML = h, r.innerHTML += l.querySelector("[data-api-content]").innerHTML, i.shift(), a(++e, i, r, o)
                }).catch(() => {
                    n.remove(i[0]), i.shift(), a(e, i, r, o)
                }) : ((e, i) => {
                    t_(e, !0);
                    let r = n.read().length;
                    if (Shopify.recentlyViewed && s && r && r < s && e.children.length) {
                        let o = [],
                            a = [],
                            l = 0;
                        for (let h in Shopify.recentlyViewed) {
                            l += 1;
                            let c = Shopify.recentlyViewed[h].split(" "),
                                d = parseInt(h.split("_")[1]);
                            o = [...o, ...c], n.read().length !== d && (l !== Object.keys(Shopify.recentlyViewed).length || a.length) || (a = [...a, ...c])
                        }
                        for (let u = 0; u < e.children.length; u++) {
                            let p = e.children[u];
                            o.length && p.classList.remove(...o), a.length && p.classList.add(...a)
                        }
                    }
                    if (t.onComplete) try {
                        t.onComplete(e, i)
                    } catch (m) {
                        console.log(m)
                    }
                })(r, o)
            };
        return {
            showRecentlyViewed: function(r) {
                Object.assign(t, r || {}), e = n.read(), i = document.querySelector(`#${t.wrapperId}`), s = t.howManyToShow, t.howManyToShow = Math.min(e.length, t.howManyToShow), t.howManyToShow && i && a(0, e, i, t.section)
            },
            getConfig: function() {
                return t
            },
            clearList: function() {
                n.destroy()
            },
            recordRecentlyViewed: function(e) {
                Object.assign(t, e || {});
                let i = n.read();
                if (-1 !== window.location.pathname.indexOf("/products/")) {
                    let s = decodeURIComponent(window.location.pathname).match(/\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/)[0].split("/products/")[1];
                    t.handle && (s = t.handle);
                    let r = i.indexOf(s); - 1 === r ? (i.unshift(s), i = i.splice(0, t.howManyToStoreInMemory)) : (i.splice(r, 1), i.unshift(s)), n.write(i)
                }
            },
            hasProducts: n.read().length > 0
        }
    }();
    let tP = (t, e = [], i = !1) => {
        let s = Object.keys(t).map(s => {
            let r = t[s];
            if ("[object Object]" === Object.prototype.toString.call(r) || Array.isArray(r)) return Array.isArray(t) ? e.push("") : e.push(s), tP(r, e, Array.isArray(r));
            {
                let o = s;
                return e.length > 0 && (o = (i ? e : [...e, s]).reduce((t, e) => "" === t ? e : `${t}[${e}]`, "")), i ? `${o}[]=${r}` : `${o}=${r}`
            }
        }).join("&");
        return e.pop(), s
    };

    function tM(t) {
        this.status = t.status || null, this.headers = t.headers || null, this.json = t.json || null, this.body = t.body || null
    }
    tM.prototype = Error.prototype;
    let tH = "is-focused";
    window.accessibility = new class {
        init() {
            this.a11y = F, this.html = document.documentElement, this.body = document.body, this.inPageLink = document.querySelector("[data-skip-content]"), this.linkesWithOnlyHash = document.querySelectorAll('a[href="#"]'), this.a11y.focusHash(), this.a11y.bindInPageLinks(), this.clickEvents(), this.focusEvents()
        }
        clickEvents() {
            this.inPageLink && this.inPageLink.addEventListener("click", t => {
                t.preventDefault()
            }), this.linkesWithOnlyHash && this.linkesWithOnlyHash.forEach(t => {
                t.addEventListener("click", t => {
                    t.preventDefault()
                })
            })
        }
        focusEvents() {
            document.addEventListener("mousedown", () => {
                this.body.classList.remove(tH)
            }), document.addEventListener("keyup", t => {
                "Tab" === t.code && this.body.classList.add(tH)
            })
        }
        constructor() {
            this.init()
        }
    };
    let tB = (t, e) => {
            let i, s;
            return function r(...o) {
                let n = Date.now();
                s = clearTimeout(s), !i || n - i >= e ? (t.apply(null, o), i = n) : s = setTimeout(r.bind(null, ...o), e - (n - i))
            }
        },
        tI = "is-animated",
        tD = "is-added",
        tO = "is-disabled",
        t8 = "is-hiding",
        t9 = "is-loading",
        tF = "is-open",
        tR = "is-visible",
        tN = "is-expanded",
        tz = "is-updated",
        tW = "[data-animation]",
        tU = "[data-item-remove]",
        t0 = "[data-cart-acceptance-checkbox]",
        tV = "[data-cart-total]",
        tj = "[data-cart-errors-container]",
        t1 = "[data-form-wrapper]",
        t3 = "[data-free-shipping]",
        tX = "[data-item]",
        t2 = "[data-quick-add-holder]",
        t4 = 'input[name="updates[]"]',
        tG = "[data-terms-error-message]",
        tY = "data-cart-total",
        t5 = "disabled",
        tJ = "data-free-shipping",
        t6 = "data-item-index",
        t7 = "data-item-title",
        tQ = "open",
        tK = "data-quick-add-holder",
        tZ = class extends HTMLElement {
            connectedCallback() {
                this.cartPage = document.querySelector("[data-cart-page]"), this.cartForm = document.querySelector("[data-cart-form]"), this.cartDrawer = document.querySelector("cart-drawer"), this.cartEmpty = document.querySelector("[data-cart-empty]"), this.cartTermsCheckbox = document.querySelector(t0), this.cartCheckoutButtonWrapper = document.querySelector("[data-cart-checkout-buttons]"), this.cartCheckoutButton = document.querySelector("[data-cart-checkout-button]"), this.checkoutButotns = document.querySelector("[data-checkout-buttons]"), this.itemsHolder = document.querySelector("[data-items-holder]"), this.priceHolder = document.querySelector("[data-cart-price-holder]"), this.items = document.querySelectorAll(tX), this.cartTotal = document.querySelector(tV), this.freeShipping = document.querySelectorAll(t3), this.cartErrorHolder = document.querySelector("[data-cart-errors]"), this.cartCloseErrorMessage = document.querySelector("[data-cart-error-close]"), this.headerWrapper = document.querySelector("[data-header-wrapper]"), this.navDrawer = document.querySelector("[data-drawer]"), this.upsellProductsHolder = document.querySelector("[data-upsell-products]"), this.subtotal = window.theme.subtotal, this.cart = this.cartDrawer || this.cartPage, this.animateItems = this.animateItems.bind(this), this.addToCart = this.addToCart.bind(this), this.cartAddEvent = this.cartAddEvent.bind(this), this.updateProgress = this.updateProgress.bind(this), this.onCartDrawerClose = this.onCartDrawerClose.bind(this), document.addEventListener("theme:cart:add", this.cartAddEvent), document.addEventListener("theme:cart-drawer:open", this.animateItems), document.addEventListener("theme:cart-drawer:close", this.onCartDrawerClose), document.addEventListener("theme:announcement:init", this.updateProgress), this.skipUpsellProductsArray = [], this.skipUpsellProductEvent(), this.checkSkippedUpsellProductsFromStorage(), this.toggleCartUpsellWidgetVisibility(), this.circumference = 28 * Math.PI, this.freeShippingLimit = this.freeShipping.length ? 100 * Number(this.freeShipping[0].getAttribute("data-free-shipping-limit")) * window.Shopify.currency.rate : 0, this.freeShippingMessageHandle(this.subtotal), this.updateProgress(), this.cart && (this.build = this.build.bind(this), this.updateCart = this.updateCart.bind(this), this.productAddCallback = this.productAddCallback.bind(this), this.formSubmitHandler = tB(this.formSubmitHandler.bind(this), 50), this.cartPage && this.animateItems(), this.hasItemsInCart = this.hasItemsInCart.bind(this), this.cartCount = this.getCartItemCount(), this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this), this.totalItems = this.items.length, this.cartUpdateFailed = !1, this.cartEvents(), this.cartRemoveEvents(), this.cartUpdateEvents(), document.addEventListener("theme:product:add", this.productAddCallback), document.addEventListener("theme:product:add-error", this.productAddCallback), document.dispatchEvent(new CustomEvent("theme:cart:load", {
                    bubbles: !0
                })))
            }
            disconnectedCallback() {
                document.removeEventListener("theme:cart:add", this.cartAddEvent), document.removeEventListener("theme:announcement:init", this.updateProgress), document.removeEventListener("theme:product:add", this.productAddCallback), document.removeEventListener("theme:product:add-error", this.productAddCallback), document.dispatchEvent(new CustomEvent("theme:cart:unload", {
                    bubbles: !0
                })), document.documentElement.hasAttribute("data-scroll-locked") && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                    bubbles: !0
                }))
            }
            onCartDrawerClose() {
                var t;
                this.resetAnimatedItems(), (null === (t = this.cartDrawer) || void 0 === t ? void 0 : t.classList.contains(tF)) && this.cart.classList.remove(tz), this.cartEmpty.classList.remove(tz), this.cartErrorHolder.classList.remove(tN), this.cart.querySelectorAll(tW).forEach(t => {
                    let e = () => {
                        t.classList.remove(t8), t.removeEventListener("animationend", e)
                    };
                    t.classList.add(t8), t.addEventListener("animationend", e)
                })
            }
            cartUpdateEvents() {
                this.items = document.querySelectorAll(tX), this.items.forEach(t => {
                    t.addEventListener("theme:cart:update", e => {
                        this.updateCart({
                            id: e.detail.id,
                            quantity: e.detail.quantity
                        }, t)
                    })
                })
            }
            cartRemoveEvents() {
                document.querySelectorAll(tU).forEach(t => {
                    let e = t.closest(tX);
                    t.addEventListener("click", i => {
                        i.preventDefault(), t.classList.contains(tO) || this.updateCart({
                            id: t.dataset.id,
                            quantity: 0
                        }, e)
                    })
                }), this.cartCloseErrorMessage && this.cartCloseErrorMessage.addEventListener("click", t => {
                    t.preventDefault(), this.cartErrorHolder.classList.remove(tN)
                })
            }
            cartAddEvent(t) {
                const button = t.detail.button;
                const form = t.detail.form || button.closest("form");
            
                let formData = new FormData();
            
                if (form) {
                    formData = new FormData(form);
                } else {
                    // fallback: manual append
                    formData.append("id", button.getAttribute("data-varientid"));
                    formData.append("quantity", "1");
                    formData.append("productHandle", button.getAttribute("data-handel"));
                }
            
                this.addToCart(formData, button);
            }
            cartEvents() {
                this.cartTermsCheckbox && (this.cartTermsCheckbox.removeEventListener("change", this.formSubmitHandler), this.cartCheckoutButtonWrapper.removeEventListener("click", this.formSubmitHandler), this.cartForm.removeEventListener("submit", this.formSubmitHandler), this.cartTermsCheckbox.addEventListener("change", this.formSubmitHandler), this.cartCheckoutButtonWrapper.addEventListener("click", this.formSubmitHandler), this.cartForm.addEventListener("submit", this.formSubmitHandler))
            }
            formSubmitHandler() {
                let t = document.querySelector(t0).checked,
                    e = document.querySelector(tG);
                if (t) e.classList.remove(tN), this.cartCheckoutButton.removeAttribute(t5);
                else {
                    if (document.querySelector(tG).length > 0) return;
                    e.innerText = theme.strings.cartAcceptanceError, this.cartCheckoutButton.setAttribute(t5, !0), e.classList.add(tN)
                }
            }
            formErrorsEvents(t) {
                let e = t.querySelector("[data-close-error]");
                null == e || e.addEventListener("click", e => {
                    e.preventDefault(), t && t.classList.remove(tR)
                })
            }
            getCart() {
                fetch(theme.routes.cart_url + "?section_id=api-cart-items").then(this.cartErrorsHandler).then(t => t.text()).then(t => {
                    //console.log(t);
                    let e = document.createElement("div");
                    e.innerHTML = t;
                    let i = e.querySelector("[data-api-content]");
                    this.build(i)
                }).catch(t => console.log(t))
            }
            async addToCart(formData, button) {
              let productHandle = "";
              let variantId = "";
          
              // Extract productHandle and variantId from formData
              for (let [key, value] of formData.entries()) {
                  if (key === "productHandle") productHandle = value;
                  if (key === "id") variantId = value;
              }
          
              try {
                  const cart = await fetchCart();
                  if (!cart) return;
          
                  const itemCount = cart.item_count;
                  const subtotal = cart.items_subtotal_price;
                  const currency = cart.currency;
          
                  const { variantId: resolvedVariantId, productHandle: resolvedHandle } = getProductDetails(productHandle, variantId);
                  const product = await fetchProduct(resolvedHandle);
                  if (!product) return;
          
                  const variant = product.variants.find(v => v.id == resolvedVariantId);
                  if (!variant) return;
          
                  const variantPrice = parseInt(variant.price, 10);
          
                  // Check subtotal and item count limits
                //   if (currency === "GBP" && subtotal + variantPrice > 13000) {
                //       displayCartError("Your order value exceeds GBP 135 and cannot be processed.");
                //       return;
                //   }
                  /*if (currency === "CAD" && subtotal + variantPrice > 58000) {
                      displayCartError("Due to fulfillment challenges caused by the DHL Express strike, baskets are currently limited to 580 CAD.");
                      return;
                  }*/
          
                  if (itemCount >= 6) {
                      displayCartError("Please note that you cannot order more than 6 items at once");
                      return;
                  }
          
                  // Show loader
                  const target = button?.closest(".available");
                  const sizeVariants = target?.closest(".size_variants");
                  const loaderElement = sizeVariants?.querySelector(".loader_variant_add");
          
                  if (loaderElement) {
                      const loaderHTML = '<img src="https://cdn.shopify.com/s/files/1/2635/7800/files/giftools.gif?v=1713423496" alt="Loading...">';
                      loaderElement.style.display = "block";
                      loaderElement.innerHTML = loaderHTML;
                  }
          
                  // Handle UI state before request
                  const wrapper = button?.closest(t2);
                  if (this.cart) this.cart.classList.add(t9);
                  if (button) {
                      button.classList.add(t9);
                      button.disabled = true;
                  }
                  if (wrapper) wrapper.classList.add(tR);
          
                  // Send the add-to-cart request
                  const response = await fetch(theme.routes.cart_add_url, {
                      method: "POST",
                      headers: {
                          "X-Requested-With": "XMLHttpRequest",
                          Accept: "application/javascript"
                      },
                      body: formData
                  }).then(res => res.json());
          
                  // Handle error response
                  if (response.status) {
                      this.addToCartError(response, button);
                      if (button) {
                          button.classList.remove(t9);
                          button.disabled = false;
                      }
                      return;
                  }
          
                  // Handle success response
                  if (this.cart) {
                      if (button) {
                          button.classList.remove(t9);
                          button.classList.add(tD);
                          button.dispatchEvent(new CustomEvent("theme:product:add", {
                              detail: {
                                  response: response,
                                  button: button
                              },
                              bubbles: true
                          }));
          
                          // Show success feedback
                          const originalText = button.textContent;
                          const addedText = document.documentElement.lang === "en" ? "ADDED" : "Hinzugefügt";
                          button.innerHTML = `${addedText} <span><img src="https://cdn.shopify.com/s/files/1/2635/7800/files/correct.png?v=1729158972" alt="Checkmark"></span>`;
                          button.disabled = true;
          
                          setTimeout(() => {
                              button.textContent = originalText;
                              button.disabled = false;
          
                              // Hide loader
                              if (loaderElement) {
                                  loaderElement.style.display = "none";
                                  loaderElement.innerHTML = "";
                              }
                          }, 5000);
                      }
          
                      this.getCart(); // Refresh cart UI
                  } else {
                      window.location = theme.routes.cart_url;
                  }
              } catch (error) {
                  console.error("Error:", error);
                  displayCartError("An error occurred while adding the product to the cart.");
                  this.enableCartButtons();
              }
          }


            
            updateCart(t = {}, e = null) {
                this.cart.classList.add(t9);
                let i = t.quantity;
                null !== e && (i ? e.classList.add(t9) : e.classList.add("is-removed")), this.disableCartButtons();
                let s = this.cart.querySelector(`[data-item="${t.id}"]`) || e,
                    r = (null == s ? void 0 : s.hasAttribute(t6)) ? parseInt(s.getAttribute(t6)) : 0,
                    o = (null == s ? void 0 : s.hasAttribute(t7)) ? s.getAttribute(t7) : null;
                0 !== r && fetch(theme.routes.cart_change_url, {
                    method: "post",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    },
                    body: JSON.stringify({
                        line: r,
                        quantity: i
                    })
                }).then(t => t.text()).then(t => {
                    if (JSON.parse(t).errors) return this.cartUpdateFailed = !0, this.updateErrorText(o), this.toggleErrorMessage(), this.resetLineItem(e), void this.enableCartButtons();
                    this.getCart()
                }).catch(t => {
                    console.log(t), this.enableCartButtons()
                })
            }
            resetLineItem(t) {
                let e = t.querySelector(t4),
                    i = e.getAttribute("value");
                e.value = i, t.classList.remove(t9)
            }
            disableCartButtons() {
                let t = this.cart.querySelectorAll("input"),
                    e = this.cart.querySelectorAll(`button, ${tU}`);
                t.length && t.forEach(t => {
                    t.classList.add(tO), t.blur(), t.disabled = !0
                }), e.length && e.forEach(t => {
                    t.setAttribute(t5, !0)
                })
            }
            enableCartButtons() {
                let t = this.cart.querySelectorAll("input"),
                    e = this.cart.querySelectorAll(`button, ${tU}`);
                t.length && t.forEach(t => {
                    t.classList.remove(tO), t.disabled = !1
                }), e.length && e.forEach(t => {
                    t.removeAttribute(t5)
                }), this.cart.classList.remove(t9)
            }
            updateErrorText(t) {
                this.cartErrorHolder.querySelector("[data-error-message]").innerText = t
            }
            toggleErrorMessage() {
                this.cartErrorHolder && (this.cartErrorHolder.classList.toggle(tN, this.cartUpdateFailed), this.cartUpdateFailed = !1)
            }
            cartErrorsHandler(t) {
                return t.ok ? t : t.json().then(function(e) {
                    throw new tM({
                        status: t.statusText,
                        headers: t.headers,
                        json: e
                    })
                })
            }
            addToCartError(t, e) {
                var i;
                if (this.cartDrawer && this.closeCartDrawer(), null !== e) {
                    let s = e.closest("[data-section-id]") || e.closest(t2) || e.closest("[data-quick-add-modal]"),
                        r = null == s ? void 0 : s.querySelector(tj),
                        o = e.closest(t2);
                    o && o.querySelector(tj) && (r = o.querySelector(tj)), r && (r.innerHTML = `<div class="errors">${t.message}: ${t.description}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`, r.classList.add(tR), this.formErrorsEvents(r)), e.dispatchEvent(new CustomEvent("theme:product:add-error", {
                        detail: {
                            response: t,
                            button: e
                        },
                        bubbles: !0
                    }))
                }
                let n = null == e ? void 0 : e.closest(t2);
                n && n.dispatchEvent(new CustomEvent("theme:cart:error", {
                    bubbles: !0,
                    detail: {
                        message: t.message,
                        description: t.description,
                        holder: n
                    }
                })), null === (i = this.cart) || void 0 === i || i.classList.remove(t9)
            }
            productAddCallback(t) {
                let e = [],
                    i = null,
                    s = "theme:product:add-error" == t.type,
                    r = t.detail.button,
                    o = document.querySelector("[data-add-to-cart-bar]");
                e.push(r), i = r.closest(t2), o && e.push(o), e.forEach(t => {
                    t.classList.remove(t9), s || t.classList.add(tD)
                }), setTimeout(() => {
                    e.forEach(t => {
                        var e, i;
                        t.classList.remove(tD), (null === (e = t.closest(t1)) || void 0 === e ? void 0 : e.classList.contains("variant--soldout")) || (null === (i = t.closest(t1)) || void 0 === i ? void 0 : i.classList.contains("variant--unavailable")) || (t.disabled = !1)
                    }), null == i || i.classList.remove(tR)
                }, 1e3)
            }
            toggleClassesOnContainers() {
                let t = this.hasItemsInCart();
                this.cart.classList.toggle("is-empty", !t), t || setTimeout(() => {
                    I(this.cartDrawer, {
                        elementToFocus: this.cartDrawer.querySelector("[data-cart-drawer-close]")
                    })
                }, 100)
            }
            build(t) {
                var e;
                let s = t.querySelector("[data-api-line-items]"),
                    r = t.querySelector("[data-api-upsell-items]"),
                    o = Boolean(null === s && null === r),
                    n = t.querySelector("[data-api-cart-price]"),
                    a = t.querySelector(tV);
                this.priceHolder && n && (this.priceHolder.innerHTML = n.innerHTML), o ? (this.itemsHolder.innerHTML = t.innerHTML, this.upsellProductsHolder && (this.upsellProductsHolder.innerHTML = "")) : (this.itemsHolder.innerHTML = s.innerHTML, this.upsellProductsHolder && (this.upsellProductsHolder.innerHTML = r.innerHTML), this.skipUpsellProductEvent(), this.checkSkippedUpsellProductsFromStorage(), this.toggleCartUpsellWidgetVisibility()), this.newTotalItems = s && s.querySelectorAll(tX).length ? s.querySelectorAll(tX).length : 0, this.subtotal = a && a.hasAttribute(tY) ? parseInt(a.getAttribute(tY)) : 0, this.cartCount = this.getCartItemCount(), document.dispatchEvent(new CustomEvent("theme:cart:change", {
                    bubbles: !0,
                    detail: {
                        cartCount: this.cartCount
                    }
                })), this.cartTotal.innerHTML = 0 === this.subtotal ? window.theme.strings.free : i.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat), this.cart.classList.remove(t9), this.totalItems !== this.newTotalItems && (this.totalItems = this.newTotalItems, this.toggleClassesOnContainers()), (null === (e = this.cartDrawer) || void 0 === e ? void 0 : e.classList.contains(tF)) && this.cart.classList.add(tz), this.hasItemsInCart() || this.cartEmpty.querySelectorAll(tW).forEach(t => {
                    t.classList.remove(tI)
                }), this.freeShippingMessageHandle(this.subtotal), this.cartRemoveEvents(), this.cartUpdateEvents(), this.toggleErrorMessage(), this.enableCartButtons(), this.updateProgress(), this.animateItems(), document.dispatchEvent(new CustomEvent("theme:product:added", {
                    bubbles: !0
                }))
            }
            getCartItemCount() {
                return Array.from(this.cart.querySelectorAll(t4)).reduce((t, e) => t + parseInt(e.value), 0)
            }
            hasItemsInCart() {
                return this.totalItems > 0
            }
            freeShippingMessageHandle(t) {
                this.freeShipping.length && this.freeShipping.forEach(e => {
                    let i = e.hasAttribute(tJ) && "true" === e.getAttribute(tJ) && t >= 0;
                    e.classList.toggle("is-success", i && t >= this.freeShippingLimit)
                })
            }
            updateProgress() {
                if (this.freeShipping = document.querySelectorAll(t3), !this.freeShipping.length) return;
                let t = isNaN(this.subtotal / this.freeShippingLimit) ? 100 : this.subtotal / this.freeShippingLimit,
                    e = Math.min(100 * t, 100),
                    s = this.circumference - e / 100 * this.circumference / 2,
                    r = i.formatMoney(this.freeShippingLimit - this.subtotal, theme.moneyFormat);
                this.freeShipping.forEach(t => {
                    let i = t.querySelector("[data-progress-bar]"),
                        o = t.querySelector("[data-progress-graph]"),
                        n = t.querySelector("[data-left-to-spend]");
                    n && (n.innerHTML = r.replace(".00", "")), i && (i.value = e), o && o.style.setProperty("--stroke-dashoffset", `${s}`)
                })
            }
            skipUpsellProductEvent() {
                if (null === this.upsellProductsHolder) return;
                let t = this.upsellProductsHolder.querySelectorAll("[data-skip-upsell-product]");
                t.length && t.forEach(t => {
                    t.addEventListener("click", e => {
                        e.preventDefault();
                        let i = t.closest(t2).getAttribute(tK);
                        this.skipUpsellProductsArray.includes(i) || this.skipUpsellProductsArray.push(i), window.sessionStorage.setItem("skip_upsell_products", this.skipUpsellProductsArray), this.removeUpsellProduct(i), this.toggleCartUpsellWidgetVisibility()
                    })
                })
            }
            checkSkippedUpsellProductsFromStorage() {
                let t = window.sessionStorage.getItem("skip_upsell_products");
                t && t.split(",").forEach(t => {
                    this.skipUpsellProductsArray.includes(t) || this.skipUpsellProductsArray.push(t), this.removeUpsellProduct(t)
                })
            }
            removeUpsellProduct(t) {
                if (!this.upsellProductsHolder) return;
                let e = this.upsellProductsHolder.querySelector(`[${tK}="${t}"]`);
                e && e.parentNode.remove()
            }
            toggleCartUpsellWidgetVisibility() {
                if (!this.upsellProductsHolder) return;
                let t = this.upsellProductsHolder.querySelectorAll(t2),
                    e = this.upsellProductsHolder.closest("[data-upsell-widget]");
                if (e && (e.classList.toggle("is-hidden", !t.length), t.length && !e.hasAttribute(tQ) && e.hasAttribute("data-upsell-auto-open"))) {
                    e.setAttribute(tQ, !0);
                    let i = e.querySelector("[data-collapsible-body]");
                    i && (i.style.height = "auto")
                }
            }
            resetAnimatedItems() {
                this.cart.querySelectorAll(tW).forEach(t => {
                    t.classList.remove(tI), t.classList.remove(t8)
                })
            }
            animateItems() {
                requestAnimationFrame(() => {
                    var t;
                    null === (t = this.cart) || void 0 === t || t.querySelectorAll(tW).forEach(t => {
                        t.classList.add(tI)
                    })
                })
            }
            constructor() {
                super()
            }
        };
    customElements.get("cart-items") || customElements.define("cart-items", tZ);
    const cart = new tZ();
    /*document.body.appendChild(cart);*/
    
    document.body.addEventListener("click", function(event) {
        const target = event.target.closest(".size_variants .available");
        if (!target) return;
    
        const variantId = target.getAttribute("data-varientid");
        const productHandle = target.getAttribute("data-handel");
    
        if (!variantId) {
            console.error("Variant ID not found");
            return;
        }

        // Create a <form> dynamically or assume the variant buttons are inside a valid form
        let form = target.closest("form");
    
        // If there's no real <form>, create one temporarily
        if (!form) {
            form = document.createElement("form");
            const inputId = document.createElement("input");
            inputId.name = "id";
            inputId.value = variantId;
            form.appendChild(inputId);
    
            const inputQty = document.createElement("input");
            inputQty.name = "quantity";
            inputQty.value = "1";
            form.appendChild(inputQty);
    
            const inputHandle = document.createElement("input");
            inputHandle.name = "productHandle";
            inputHandle.value = productHandle;
            form.appendChild(inputHandle);
        }
    
        // Dispatch the custom event that your `cartAddEvent()` listens for
        document.dispatchEvent(new CustomEvent("theme:cart:add", {
            bubbles: true,
            detail: {
                button: target,
                form: form
            }
        }));
        
    });

    let et = class extends HTMLElement {
        connectedCallback() {
            document.addEventListener("theme:cart:change", this.onCartChangeCallback)
        }
        disconnectedCallback() {
            document.addEventListener("theme:cart:change", this.onCartChangeCallback)
        }
        onCartChange(t) {
            this.cartCount = t.detail.cartCount, this.update()
        }
        update() {
            if (null !== this.cartCount) {
                this.setAttribute("data-cart-count", this.cartCount);
                let t = this.cartCount;
                this.limit && this.cartCount >= this.limit && (t = "9+"), this.innerText = t
            }
        }
        constructor() {
            super(), this.cartCount = null, this.limit = this.getAttribute("data-limit"), this.onCartChangeCallback = this.onCartChange.bind(this)
        }
    };

    function ee(t) {
        return new Promise(e => {
            null == t || t.addEventListener("animationend", function i(s) {
                s.target == t && (t.removeEventListener("animationend", i), e())
            })
        })
    }
    customElements.get("cart-count") || customElements.define("cart-count", et);
    let ei = "is-open",
        es = "is-closing",
        er = {
            cartDrawerClose: "[data-cart-drawer-close]",
            cartDrawerSection: '[data-section-type="cart-drawer"]',
            cartDrawerInner: "[data-cart-drawer-inner]"
        },
        eo = class extends HTMLElement {
            connectedCallback() {
                this.addEventListener("theme:cart-drawer:show", this.openCartDrawer), document.addEventListener("theme:cart:toggle", this.toggleCartDrawer), document.addEventListener("theme:quick-add:open", this.closeCartDrawer), document.addEventListener("theme:product:added", this.openCartDrawerOnProductAdded), document.addEventListener("shopify:block:select", this.openCartDrawerOnSelect), document.addEventListener("shopify:section:select", this.openCartDrawerOnSelect), document.addEventListener("shopify:section:deselect", this.closeCartDrawerOnDeselect)
            }
            disconnectedCallback() {
                document.removeEventListener("theme:product:added", this.openCartDrawerOnProductAdded), document.removeEventListener("theme:cart:toggle", this.toggleCartDrawer), document.removeEventListener("theme:quick-add:open", this.closeCartDrawer), document.removeEventListener("shopify:block:select", this.openCartDrawerOnSelect), document.removeEventListener("shopify:section:select", this.openCartDrawerOnSelect), document.removeEventListener("shopify:section:deselect", this.closeCartDrawerOnDeselect)
            }
            openCartDrawerOnProductAdded() {
                this.cartDrawerIsOpen || this.openCartDrawer()
            }
            openCartDrawerOnSelect(t) {
                (t.target.querySelector(er.cartDrawerSection) || t.target.closest(er.cartDrawerSection)) && this.openCartDrawer()
            }
            closeCartDrawerOnDeselect() {
                this.cartDrawerIsOpen && this.closeCartDrawer()
            }
            openCartDrawer() {
                this.cartDrawerIsOpen = !0, this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this), document.body.addEventListener("click", this.onBodyClickEvent), document.dispatchEvent(new CustomEvent("theme:cart-drawer:open", {
                    bubbles: !0
                })), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                    bubbles: !0
                })), this.classList.add(ei), this.observeAdditionalCheckoutButtons(), ee(this.cartDrawerInner).then(() => {
                    I(this, {
                        elementToFocus: this.querySelector(er.cartDrawerClose)
                    })
                })
            }
            closeCartDrawer() {
                this.classList.contains(ei) && (this.classList.add(es), this.classList.remove(ei), this.cartDrawerIsOpen = !1, document.dispatchEvent(new CustomEvent("theme:cart-drawer:close", {
                    bubbles: !0
                })), D(), O(), document.body.removeEventListener("click", this.onBodyClickEvent), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                    bubbles: !0
                })), ee(this.cartDrawerInner).then(() => {
                    this.classList.remove(es)
                }))
            }
            toggleCartDrawer() {
                this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer()
            }
            closeCartEvents() {
                this.cartDrawerClose.addEventListener("click", t => {
                    t.preventDefault(), this.closeCartDrawer()
                }), this.addEventListener("keyup", t => {
                    "Escape" === t.code && this.closeCartDrawer()
                })
            }
            onBodyClick(t) {
                t.target.hasAttribute("data-drawer-underlay") && this.closeCartDrawer()
            }
            observeAdditionalCheckoutButtons() {
                let t = this.querySelector(er.additionalCheckoutButtons);
                if (t) {
                    let e = new MutationObserver(() => {
                        I(this, {
                            elementToFocus: this.querySelector(er.cartDrawerClose)
                        }), e.disconnect()
                    });
                    e.observe(t, {
                        subtree: !0,
                        childList: !0
                    })
                }
            }
            constructor() {
                super(), this.cartDrawerIsOpen = !1, this.cartDrawerClose = this.querySelector(er.cartDrawerClose), this.cartDrawerInner = this.querySelector(er.cartDrawerInner), this.openCartDrawer = this.openCartDrawer.bind(this), this.closeCartDrawer = this.closeCartDrawer.bind(this), this.toggleCartDrawer = this.toggleCartDrawer.bind(this), this.openCartDrawerOnProductAdded = this.openCartDrawerOnProductAdded.bind(this), this.openCartDrawerOnSelect = this.openCartDrawerOnSelect.bind(this), this.closeCartDrawerOnDeselect = this.closeCartDrawerOnDeselect.bind(this), this.closeCartEvents()
            }
        };
    customElements.get("cart-drawer") || customElements.define("cart-drawer", eo);
    let en = "[data-collapsible]",
        ea = "[data-collapsible-trigger]",
        el = "[data-collapsible-body]",
        eh = "[data-collapsible-content]",
        ec = "open",
        ed = class extends HTMLElement {
            connectedCallback() {
                this.collapsibles.forEach(t => {
                    let e = t.querySelector(ea),
                        i = t.querySelector(el);
                    e.addEventListener("click", t => this.onCollapsibleClick(t)), i.addEventListener("transitionend", e => {
                        e.target === i && ("true" == t.getAttribute(ec) && this.setBodyHeight(i, "auto"), "false" == t.getAttribute(ec) && (t.removeAttribute(ec), this.setBodyHeight(i, "")))
                    })
                })
            }
            open(t) {
                if ("true" == t.getAttribute("open")) return;
                let e = t.querySelector(el),
                    i = t.querySelector(eh);
                t.setAttribute("open", !0), this.setBodyHeight(e, i.offsetHeight)
            }
            close(t) {
                if (!t.hasAttribute("open")) return;
                let e = t.querySelector(el),
                    i = t.querySelector(eh);
                this.setBodyHeight(e, i.offsetHeight), t.setAttribute("open", !1), requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        this.setBodyHeight(e, 0)
                    })
                })
            }
            setBodyHeight(t, e) {
                t.style.height = "auto" !== e && "" !== e ? `${e}px` : e
            }
            onCollapsibleClick(t) {
                t.preventDefault();
                let e = (t.target.matches(ea) ? t.target : t.target.closest(ea)).closest(en);
                this.single && this.collapsibles.forEach(t => {
                    t.hasAttribute(ec) && t != e && requestAnimationFrame(() => {
                        this.close(t)
                    })
                }), e.hasAttribute(ec) ? this.close(e) : this.open(e), e.dispatchEvent(new CustomEvent("theme:form:sticky", {
                    bubbles: !0,
                    detail: {
                        element: "accordion"
                    }
                }))
            }
            constructor() {
                super(), this.collapsibles = this.querySelectorAll(en), this.single = this.hasAttribute("single")
            }
        };
    customElements.get("collapsible-elements") || customElements.define("collapsible-elements", ed);
    let eu = "is-open",
        ep = class extends HTMLElement {
            connectedCallback() {
                this.popdown.addEventListener("transitionend", this.popdownTransitionCallback), this.popdownContainer.addEventListener("keyup", t => "ESCAPE" === t.code.toUpperCase() && this.close()), this.popdownContainer.addEventListener("toggle", this.detailsToggleCallback), this.popdownClose.addEventListener("click", this.close.bind(this))
            }
            detailsToggleCallback(t) {
                t.target.hasAttribute("open") && this.open()
            }
            popdownTransitionCallback(t) {
                t.target === this.popdown && (this.classList.contains(eu) ? "transform" === t.propertyName && this.a11y.trapFocus(this.popdown, {
                    elementToFocus: this.popdown.querySelector('input:not([type="hidden"])')
                }) : (this.popdownContainer.removeAttribute("open"), this.a11y.removeTrapFocus()))
            }
            onBodyClick(t) {
                this.contains(t.target) && !t.target.hasAttribute("data-popdown-underlay") || this.close()
            }
            open() {
                this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this), document.body.addEventListener("click", this.onBodyClickEvent), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                    bubbles: !0
                })), requestAnimationFrame(() => {
                    this.classList.add(eu)
                })
            }
            close() {
                this.classList.remove(eu), document.body.removeEventListener("click", this.onBodyClickEvent), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                    bubbles: !0
                }))
            }
            constructor() {
                super(), this.popdown = this.querySelector("[data-popdown]"), this.popdownContainer = this.querySelector("details"), this.popdownClose = this.querySelector("[data-popdown-close]"), this.popdownTransitionCallback = this.popdownTransitionCallback.bind(this), this.detailsToggleCallback = this.detailsToggleCallback.bind(this), this.a11y = F
            }
        };
    customElements.define("header-search-popdown", ep), customElements.define("main-search", class extends z {
        setupEventListeners() {
            let t = [];
            this.allSearchInputs.forEach(e => t.push(e.form)), this.input.addEventListener("focus", this.onInputFocus.bind(this)), t.length < 2 || (t.forEach(t => t.addEventListener("reset", this.onFormReset.bind(this))), this.allSearchInputs.forEach(t => t.addEventListener("input", this.onInput.bind(this))))
        }
        onFormReset(t) {
            super.onFormReset(t), super.shouldResetForm() && this.keepInSync("", this.input)
        }
        onInput(t) {
            let e = t.target;
            this.keepInSync(e.value, e)
        }
        onInputFocus() {
            y() || this.scrollIntoView({
                behavior: "smooth"
            })
        }
        keepInSync(t, e) {
            this.allSearchInputs.forEach(i => {
                i !== e && (i.value = t)
            })
        }
        constructor() {
            super(), this.allSearchInputs = document.querySelectorAll('input[type="search"]'), this.setupEventListeners()
        }
    });
    let em = "#address_zip",
        eg = "data-default",
        ev = "is-hidden",
        ef = "center",
        ey = "disabled",
        eb = class extends HTMLElement {
            connectedCallback() {
                let t = document.querySelector("html"),
                    i = "en";
                if (t.hasAttribute("lang") && "" !== t.getAttribute("lang") && (i = t.getAttribute("lang")), this.fieldsContainer && e.AddressForm(this.fieldsContainer, i, {
                        shippingCountriesOnly: !0
                    }), this.selectCountry && this.selectCountry.hasAttribute(eg) && this.selectProvince && this.selectProvince.hasAttribute(eg) && this.selectCountry.addEventListener("change", this.onCountryChangeEvent), this.getRatesButton && (this.getRatesButton.addEventListener("click", this.onButtonClickEvent), theme.settings.customerLoggedIn && this.getRatesButton.classList.contains("get-rates--trigger"))) {
                    let s = document.querySelector(em);
                    s && s.value && this.getRatesButton.dispatchEvent(new Event("click"))
                }
            }
            disconnectedCallback() {
                this.selectCountry && this.selectCountry.hasAttribute(eg) && this.selectProvince && this.selectProvince.hasAttribute(eg) && this.selectCountry.removeEventListener("change", this.onCountryChangeEvent), this.getRatesButton && this.getRatesButton.removeEventListener("click", this.onButtonClickEvent)
            }
            onCountryChange() {
                this.selectCountry.removeAttribute(eg), this.selectProvince.removeAttribute(eg)
            }
            onButtonClick() {
                for (this.disableButtons(); this.wrapper.firstChild;) this.wrapper.removeChild(this.wrapper.firstChild);
                this.wrapper.classList.add(ev);
                let t = {},
                    e = this.selectCountry.value,
                    i = this.selectProvince.value,
                    s = this.selectCountry.getAttribute(eg);
                "" === e && s && "" !== s && (e = s);
                let r = this.selectProvince.getAttribute(eg);
                "" === i && r && "" !== r && (i = r), t.zip = document.querySelector(em).value || "", t.country = e || "", t.province = i || "", this.getCartShippingRatesForDestination(t)
            }
            formatRate(t) {
                return "0.00" === t ? window.theme.strings.free : i.formatMoney(t, theme.moneyFormat)
            }
            render(t) {
                if (this.template && this.wrapper) {
                    this.wrapper.innerHTML = "";
                    let e = "",
                        i = "",
                        s = `error ${ef}`,
                        r = this.template.innerHTML,
                        o = /[^[\]]+(?=])/g;
                    if (t.rates && t.rates.length) {
                        let n = o.exec(r)[0];
                        t.rates.forEach(t => {
                            let i = n;
                            e += i = (i = i.replace(/\|\|rateName\|\|/, t.name)).replace(/\|\|ratePrice\|\|/, this.formatRate(t.price))
                        })
                    }
                    if (t.success) {
                        s = `success ${ef}`;
                        let a = document.createElement("div");
                        a.innerHTML = this.template.innerHTML;
                        let l = a.querySelector("[data-template-no-shipping]");
                        t.rates.length < 1 && l && (i = l.getAttribute("data-template-no-shipping"))
                    } else i = t.errorFeedback;
                    r = (r = (r = (r = r.replace(o, "").replace("[]", "")).replace(/\|\|ratesList\|\|/g, e)).replace(/\|\|successClass\|\|/g, s)).replace(/\|\|ratesText\|\|/g, i), this.wrapper.innerHTML += r, this.wrapper.classList.remove(ev)
                }
            }
            enableButtons() {
                this.getRatesButton.removeAttribute("disabled"), this.getRatesButton.classList.remove(ey), this.getRatesButton.textContent = theme.strings.shippingCalcSubmitButton
            }
            disableButtons() {
                this.getRatesButton.setAttribute("disabled", "disabled"), this.getRatesButton.classList.add(ey), this.getRatesButton.textContent = theme.strings.shippingCalcSubmitButtonDisabled
            }
            getCartShippingRatesForDestination(t) {
                let e = encodeURI(tP({
                        shipping_address: t
                    })),
                    i = `${theme.routes.cart_url}/shipping_rates.json?${e}`;
                fetch(i).then(this.handleErrors).then(t => t.text()).then(e => {
                    let i = JSON.parse(e).shipping_rates;
                    this.onCartShippingRatesUpdate(i, t)
                }).catch(t => {
                    this.onError(t.json)
                })
            }
            fullMessagesFromErrors(t) {
                let e = [];
                for (let i in t)
                    for (let s of t[i]) e.push(s);
                return e
            }
            handleErrors(t) {
                return t.ok ? t : t.json().then(function(e) {
                    throw new tM({
                        status: t.statusText,
                        headers: t.headers,
                        json: e
                    })
                })
            }
            onError(t) {
                this.enableButtons();
                let e = "";
                "Error : country is not supported." == (e = t.message ? t.message + "(" + t.status + "): " + t.description : "Error : " + this.fullMessagesFromErrors(t).join("; ")) && (e = "We do not ship to this destination."), this.render({
                    rates: [],
                    errorFeedback: e,
                    success: !1
                })
            }
            onCartShippingRatesUpdate(t, e) {
                this.enableButtons();
                let i = "";
                e.zip && (i += e.zip + ", "), e.province && (i += e.province + ", "), i += e.country, this.render({
                    rates: t,
                    address: i,
                    success: !0
                })
            }
            constructor() {
                super(), this.getRatesButton = this.querySelector(".get-rates"), this.fieldsContainer = this.querySelector("#address_container"), this.selectCountry = this.querySelector("#address_country"), this.selectProvince = this.querySelector("#address_province"), this.template = this.querySelector("#shipping-calculator-response-template"), this.wrapper = this.querySelector("#wrapper-response"), this.onCountryChangeEvent = () => this.onCountryChange(), this.onButtonClickEvent = () => this.onButtonClick()
            }
        };
    customElements.get("shipping-calculator") || customElements.define("shipping-calculator", eb);
    let eS = class extends HTMLElement {
        connectedCallback() {
            this.setHeight(this.initialHeight), this.trigger.addEventListener("click", () => {
                this.setHeight(this.content.offsetHeight), this.classList.add("is-open")
            }), this.setHeight(this.initialHeight), this.toggleActions(), document.addEventListener("theme:resize", this.toggleActions)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize", this.toggleActions)
        }
        setHeight(t) {
            this.style.setProperty("--height", `${t}px`)
        }
        toggleActions() {
            this.classList.toggle("is-enabled", this.content.offsetHeight + this.actions.offsetHeight > this.initialHeight)
        }
        constructor() {
            super(), this.initialHeight = this.getAttribute("data-height"), this.content = this.querySelector("[data-content]"), this.trigger = this.querySelector("[data-button]"), this.actions = this.querySelector("[data-actions]"), this.toggleActions = this.toggleActions.bind(this)
        }
    };
    customElements.get("toggle-ellipsis") || customElements.define("toggle-ellipsis", eS);
    let eL = "data-form-id",
        eE = "hidden",
        ew = document.querySelector(".template-addresses");
    ew && new class {
        init() {
            if (this.addressNewForm) {
                let t = this.section,
                    e = this.addressNewForm;
                this.customerAddresses();
                let i = t.querySelectorAll(".address-new-toggle");
                i.length && i.forEach(t => {
                    t.addEventListener("click", function() {
                        e.classList.toggle(eE)
                    })
                });
                let s = t.querySelectorAll(".address-edit-toggle");
                s.length && s.forEach(e => {
                    e.addEventListener("click", function() {
                        let e = this.getAttribute(eL);
                        t.querySelector(`#EditAddress_${e}`).classList.toggle(eE)
                    })
                });
                let r = t.querySelectorAll(".address-delete");
                r.length && r.forEach(t => {
                    t.addEventListener("click", function() {
                        let t = this.getAttribute(eL),
                            e = this.getAttribute("data-confirm-message");
                        confirm(e) && Shopify.postLink(window.theme.routes.addresses_url + "/" + t, {
                            parameters: {
                                _method: "delete"
                            }
                        })
                    })
                })
            }
        }
        customerAddresses() {
            Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
                hideElement: "AddressProvinceContainerNew"
            }), this.section.querySelectorAll(".address-country-option").forEach(t => {
                let e = t.getAttribute(eL),
                    i = `AddressCountry_${e}`,
                    s = `AddressProvince_${e}`,
                    r = `AddressProvinceContainer_${e}`;
                new Shopify.CountryProvinceSelector(i, s, {
                    hideElement: r
                })
            })
        }
        constructor(t) {
            this.section = t, this.addressNewForm = this.section.querySelector("#AddressNewForm"), this.init()
        }
    }(ew);
    let ek = ".account-sidebar--mobile",
        e$ = document.querySelector(".customer-logged-in");
    e$ && new class {
        init() {
            this.section.querySelector(".account") && this.accountMobileSidebar()
        }
        accountMobileSidebar() {
            this.section.querySelector(ek) && this.section.querySelector(ek).addEventListener("click", function() {
                let t = this.nextElementSibling;
                t && "UL" === t.tagName && t.classList.toggle("visible")
            })
        }
        constructor(t) {
            this.section = t, this.init()
        }
    }(e$);
    let eA = "#recover",
        eC = "is-hidden",
        eT = document.querySelector("[data-account-form]");
    eT && new class {
        init() {
            window.location.hash == eA || this.recoverSuccess ? this.showRecoverPasswordForm() : this.hideRecoverPasswordForm(), this.showButton.addEventListener("click", (function(t) {
                t.preventDefault(), this.showRecoverPasswordForm()
            }).bind(this), !1), this.hideButton.addEventListener("click", (function(t) {
                t.preventDefault(), this.hideRecoverPasswordForm()
            }).bind(this), !1)
        }
        showRecoverPasswordForm() {
            return this.login.classList.add(eC), this.recover.classList.remove(eC), window.location.hash = eA, !1
        }
        hideRecoverPasswordForm() {
            return this.recover.classList.add(eC), this.login.classList.remove(eC), window.location.hash = "", !1
        }
        constructor(t) {
            this.form = t, this.showButton = t.querySelector("[data-show-reset]"), this.hideButton = t.querySelector("[data-hide-reset]"), this.recover = t.querySelector("[data-recover-password]"), this.recoverSuccess = t.querySelector("[data-recover-success]"), this.login = t.querySelector("[data-login-form]"), this.init()
        }
    }(eT), window.Shopify = window.Shopify || {}, window.Shopify.theme = window.Shopify.theme || {}, window.Shopify.theme.sections = window.Shopify.theme.sections || {}, window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}, window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
    let eq = window.Shopify.theme.sections.registered,
        ex = window.Shopify.theme.sections.instances,
        e_ = "data-section-id",
        eP = "data-section-type",
        eM = class {
            callFunctions(t, e = null) {
                this.callStack[t].forEach(t => {
                    let i = {
                        id: this.id,
                        type: this.type,
                        container: this.container
                    };
                    e ? t.call(i, e) : t.call(i)
                })
            }
            onLoad() {
                this.callFunctions("onLoad")
            }
            onUnload() {
                this.callFunctions("onUnload")
            }
            onSelect(t) {
                this.callFunctions("onSelect", t)
            }
            onDeselect(t) {
                this.callFunctions("onDeselect", t)
            }
            onBlockSelect(t) {
                this.callFunctions("onBlockSelect", t)
            }
            onBlockDeselect(t) {
                this.callFunctions("onBlockDeselect", t)
            }
            onReorder(t) {
                this.callFunctions("onReorder", t)
            }
            constructor(t, e) {
                this.container = function(t) {
                    if (!(t instanceof Element)) throw TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
                    if (null === t.getAttribute(e_)) throw Error("Theme Sections: The section container provided does not have an id assigned to the " + e_ + " attribute.");
                    return t
                }(t), this.id = t.getAttribute(e_), this.type = e.type, this.callStack = e.getStack();
                try {
                    this.onLoad()
                } catch (i) {
                    console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(i)
                }
            }
        };

    function eH(t, e) {
        if ("string" != typeof t) throw TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== eq[t]) throw Error('Theme Sections: A section of type "' + t + '" has already been registered. You cannot register the same section type twice');
        Array.isArray(e) || (e = [e]);
        let i = new class {
            getStack() {
                return this.callStack
            }
            constructor(t = null, e = []) {
                this.type = t, this.components = function(t) {
                    if (void 0 !== t && "object" != typeof t || null === t) throw TypeError("Theme Sections: The components object provided is not a valid");
                    return t
                }(e), this.callStack = {
                    onLoad: [],
                    onUnload: [],
                    onSelect: [],
                    onDeselect: [],
                    onBlockSelect: [],
                    onBlockDeselect: [],
                    onReorder: []
                }, e.forEach(t => {
                    for (let [e, i] of Object.entries(t)) {
                        let s = this.callStack[e];
                        Array.isArray(s) && "function" == typeof i ? s.push(i) : (console.warn(`Unregisted function: '${e}' in component: '${this.type}'`), console.warn(i))
                    }
                })
            }
        }(t, e);
        return eq[t] = i, eq
    }

    function eB(t, e) {
        t = eO(t), void 0 === e && (e = document.querySelectorAll("[" + eP + "]")), e = e8(e), t.forEach(function(t) {
            let i = eq[t];
            void 0 !== i && (e = e.filter(function(e) {
                return !(eI(e).length > 0 || null === e.getAttribute(eP) || e.getAttribute(eP) === t && (ex.push(new eM(e, i)), 1))
            }))
        })
    }

    function eI(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
        return t instanceof Element || i instanceof Element ? e8(t).forEach(function(t) {
            e = e.concat(ex.filter(function(e) {
                return e.container === t
            }))
        }) : "string" != typeof t && "string" != typeof i || eO(t).forEach(function(t) {
            e = e.concat(ex.filter(function(e) {
                return e.type === t
            }))
        }), e
    }

    function eD(t) {
        for (var e, i = 0; i < ex.length; i++)
            if (ex[i].id === t) {
                e = ex[i];
                break
            } return e
    }

    function eO(t) {
        return "*" === t ? t = Object.keys(eq) : "string" == typeof t ? t = [t] : t.constructor === eM ? t = [t.prototype.type] : Array.isArray(t) && t[0].constructor === eM && (t = t.map(function(t) {
            return t.type
        })), t.map(function(t) {
            return t.toLowerCase()
        })
    }

    function e8(t) {
        return NodeList.prototype.isPrototypeOf(t) && t.length > 0 ? t = Array.prototype.slice.call(t) : NodeList.prototype.isPrototypeOf(t) && 0 === t.length || null === t ? t = [] : !Array.isArray(t) && t instanceof Element && (t = [t]), t
    }
    window.Shopify.designMode && (document.addEventListener("shopify:section:load", function(t) {
        var e = t.detail.sectionId,
            i = t.target.querySelector("[" + e_ + '="' + e + '"]');
        null !== i && eB(i.getAttribute(eP), i)
    }), document.addEventListener("shopify:section:reorder", function(t) {
        var e = t.detail.sectionId,
            i = t.target.querySelector("[" + e_ + '="' + e + '"]');
        "object" == typeof eI(i)[0] && eI(i).forEach(function(t) {
            t.onReorder()
        })
    }), document.addEventListener("shopify:section:unload", function(t) {
        var e = t.detail.sectionId,
            i = t.target.querySelector("[" + e_ + '="' + e + '"]');
        "object" == typeof eI(i)[0] && eI(i).forEach(function(t) {
            var e = ex.map(function(t) {
                return t.id
            }).indexOf(t.id);
            ex.splice(e, 1), t.onUnload()
        })
    }), document.addEventListener("shopify:section:select", function(t) {
        var e = eD(t.detail.sectionId);
        "object" == typeof e && e.onSelect(t)
    }), document.addEventListener("shopify:section:deselect", function(t) {
        var e = eD(t.detail.sectionId);
        "object" == typeof e && e.onDeselect(t)
    }), document.addEventListener("shopify:block:select", function(t) {
        var e = eD(t.detail.sectionId);
        "object" == typeof e && e.onBlockSelect(t)
    }), document.addEventListener("shopify:block:deselect", function(t) {
        var e = eD(t.detail.sectionId);
        "object" == typeof e && e.onBlockDeselect(t)
    }));
    let e9 = "data-tooltip",
        eF = "data-tooltip-stop-mouseenter",
        eR = "is-visible",
        eN = "is-hiding",
        ez = {},
        eW = class {
            init() {
                if (!document.querySelector(`.${this.class}`)) {
                    let t = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`,
                        e = document.createElement("div");
                    e.className = this.class, e.innerHTML = t, document.body.appendChild(e)
                }
                this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent), this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent), this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent), document.addEventListener("theme:tooltip:close", this.removePinEvent)
            }
            addPin(t = !1) {
                let e = document.querySelector(`.${this.class}`);
                if (this.label && e && (t && !this.tooltip.hasAttribute(eF) || !t)) {
                    let i = e.querySelector(`.${this.class}__arrow`),
                        s = e.querySelector(`.${this.class}__inner`);
                    e.querySelector(`.${this.class}__text`).textContent = this.label;
                    let r = s.offsetWidth,
                        o = this.tooltip.getBoundingClientRect(),
                        n = o.top,
                        a = o.width,
                        l = n + o.height + window.scrollY,
                        h = o.left - r / 2 + a / 2,
                        c = h + r - v();
                    c > 0 && (h -= c), h < 0 && (h = 0), i.style.left = `${o.left+a/2}px`, e.style.setProperty("--tooltip-top", `${l}px`), s.style.transform = `translateX(${h}px)`, e.classList.remove(eN), e.classList.add(eR), document.addEventListener("theme:scroll", this.removePinEvent)
                }
            }
            removePin(t, e = !1, i = !1) {
                let s = document.querySelector(`.${this.class}`),
                    r = s.classList.contains(eR);
                s && (e && !this.tooltip.hasAttribute(eF) || !e) && (r && (i || t.detail.hideTransition) && (s.classList.add(eN), this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout), this.hideTransitionTimeout = setTimeout(() => {
                    s.classList.remove(eN)
                }, this.transitionSpeed)), s.classList.remove(eR), document.removeEventListener("theme:scroll", this.removePinEvent))
            }
            unload() {
                this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent), this.tooltip.removeEventListener("mouseleave", this.removePinMouseEvent), this.tooltip.removeEventListener("theme:tooltip:init", this.addPinEvent), document.removeEventListener("theme:tooltip:close", this.removePinEvent), document.removeEventListener("theme:scroll", this.removePinEvent)
            }
            constructor(t, e = {}) {
                this.tooltip = t, this.tooltip.hasAttribute(e9) && (this.label = this.tooltip.getAttribute(e9), this.class = e.class || "tooltip-default", this.transitionSpeed = e.transitionSpeed || 200, this.hideTransitionTimeout = 0, this.addPinEvent = () => this.addPin(), this.addPinMouseEvent = () => this.addPin(!0), this.removePinEvent = t => tB(this.removePin(t), 50), this.removePinMouseEvent = t => this.removePin(t, !0, !0), this.init())
            }
        },
        eU = {
            onLoad() {
                ez[this.id] = [], this.container.querySelectorAll(`[${e9}]`).forEach(t => {
                    ez[this.id].push(new eW(t))
                })
            },
            onUnload: function() {
                ez[this.id].forEach(t => {
                    "function" == typeof t.unload && t.unload()
                })
            }
        };
    var e0 = {};
    let eV = {
        onLoad() {
            e0[this.id] = [], this.container.querySelectorAll("[data-parallax-wrapper]").forEach(t => {
                let e = t.querySelector("[data-parallax-img]");
                e0[this.id].push(new s(e, {
                    center: !0,
                    round: !0,
                    frame: t
                }))
            }), window.addEventListener("load", () => {
                e0[this.id].forEach(t => {
                    "function" == typeof t.refresh && t.refresh()
                })
            })
        },
        onUnload: function() {
            e0[this.id].forEach(t => {
                "function" == typeof t.destroy && t.destroy()
            })
        }
    };
    eH("article", [eU, eV]);
    let ej = "[data-slide]",
        e1 = "[data-slider]",
        e3 = "[data-slider-thumb]",
        eX = {
            arrowPositionMiddle: "data-arrow-position-middle",
            slideIndex: "data-slide-index",
            sliderOptions: "data-options",
            slideTextColor: "data-slide-text-color"
        },
        e2 = "aos-animate",
        e4 = "is-loading",
        eG = "is-selected",
        eY = {},
        e5 = class {
            init() {
                this.slideshow.classList.add(e4);
                let t = ej,
                    e = y(),
                    i = `${ej}:not(.mobile)`,
                    s = `${ej}:not(.desktop)`;
                (this.slideshow.querySelectorAll(s).length || this.slideshow.querySelectorAll(i).length) && (t = e ? i : s), this.slideshow.querySelectorAll(t).length <= 1 && (this.slideshow.classList.add("single-slide"), this.slideshow.classList.remove(e4)), this.sliderOptions = {
                    cellSelector: t,
                    contain: !0,
                    wrapAround: !0,
                    adaptiveHeight: !0,
                    ...this.customOptions,
                    on: {
                        ready: () => {
                            requestAnimationFrame(() => {
                                this.slideshow.classList.add("is-initialized"), this.slideshow.classList.remove(e4), this.slideshow.parentNode.dispatchEvent(new CustomEvent("theme:slider:loaded", {
                                    bubbles: !0,
                                    detail: {
                                        slider: this
                                    }
                                }))
                            }), this.slideActions(), this.sliderOptions.prevNextButtons && this.positionArrows()
                        },
                        change: t => {
                            let e = this.slideshowSlides[t];
                            if (!e || this.sliderOptions.groupCells) return;
                            let i = e.querySelectorAll("[data-aos]");
                            i.length && i.forEach(t => {
                                t.classList.remove(e2), requestAnimationFrame(() => {
                                    setTimeout(() => {
                                        t.classList.add(e2)
                                    }, 0)
                                })
                            })
                        },
                        resize: () => {
                            this.sliderOptions.prevNextButtons && this.positionArrows()
                        }
                    }
                }, this.sliderOptions.fade && (this.flkty = new o(this.slideshow, this.sliderOptions)), this.sliderOptions.fade || (this.flkty = new r(this.slideshow, this.sliderOptions)), this.flkty.on("change", () => this.slideActions(!0)), this.sliderThumbs.length && this.sliderThumbs.forEach(t => {
                    t.addEventListener("click", e => {
                        e.preventDefault();
                        let i = [...t.parentElement.children].indexOf(t);
                        this.flkty.select(i)
                    })
                }), this.flkty && this.flkty.isActive || this.slideshow.classList.remove(e4)
            }
            slideActions(t = !1) {
                let e = this.slideshow.querySelector(`.${eG}`),
                    i = e.getAttribute(eX.slideTextColor),
                    s = e.querySelector("a:not(.btn)"),
                    r = this.slideshow.querySelectorAll(`${ej} a, ${ej} button`);
                if (document.body.classList.contains("is-focused") && s && this.sliderOptions.groupCells && t && s.focus(), r.length && r.forEach(t => {
                        let e = t.closest(ej);
                        if (e) {
                            let i = e.classList.contains(eG) ? 0 : -1;
                            t.setAttribute("tabindex", i)
                        }
                    }), "rgba(0,0,0,0)" !== i && "" !== i && this.slideshow.style.setProperty("--text", i), this.sliderThumbs.length && this.sliderThumbs.length === this.slideshowSlides.length && e.hasAttribute(eX.slideIndex)) {
                    let o = parseInt(e.getAttribute(eX.slideIndex)),
                        n = this.container.querySelector(`${e3}.${eG}`);
                    n && n.classList.remove(eG), this.sliderThumbs[o].classList.add(eG)
                }
            }
            positionArrows() {
                if (this.slideshow.hasAttribute(eX.arrowPositionMiddle) && this.sliderOptions.prevNextButtons) {
                    let t = this.slideshow.querySelector(".collection-item__image") || this.slideshow.querySelector(".product-item__image") || this.slideshow.querySelector("[data-column-image]");
                    t && (this.slideshow.querySelector(".flickity-button.previous").style.top = t.clientHeight / 2 + "px", this.slideshow.querySelector(".flickity-button.next").style.top = t.clientHeight / 2 + "px")
                }
            }
            onUnload() {
                this.slideshow && this.flkty && (this.flkty.options.watchCSS = !1, this.flkty.destroy())
            }
            onBlockSelect(t) {
                if (!this.slideshow) return;
                let e = this.slideshow.querySelector(`[data-slide="${t.detail.blockId}"]`);
                if (!e) return;
                let i = parseInt(e.getAttribute(eX.slideIndex));
                this.multipleSlides && !this.slideshow.classList.contains("js-slider--initialized") && (i = 0), this.slideshow.classList.add(eG), this.flkty && this.slideshow.classList.contains("flickity-enabled") && (this.flkty.selectCell(i), this.flkty.stopPlayer())
            }
            onBlockDeselect() {
                this.slideshow && (this.slideshow.classList.remove(eG), this.flkty && this.sliderOptions.hasOwnProperty("autoPlay") && this.sliderOptions.autoPlay && this.flkty.playPlayer())
            }
            constructor(t, e = null) {
                this.container = t, this.slideshow = e || this.container.querySelector(e1), this.slideshow && (this.slideshowSlides = this.slideshow.querySelectorAll(ej), this.slideshowSlides.length <= 1 || (this.sliderThumbs = this.container.querySelectorAll(e3), this.multipleSlides = this.slideshow.hasAttribute(eX.slidesLargeDesktop), this.slideshow.hasAttribute(eX.sliderOptions) && (this.customOptions = JSON.parse(decodeURIComponent(this.slideshow.getAttribute(eX.sliderOptions)))), this.flkty = null, this.init()))
            }
        },
        eJ = {
            onLoad() {
                eY[this.id] = [], this.container.querySelectorAll(e1).forEach(t => {
                    eY[this.id].push(new e5(this.container, t))
                })
            },
            onUnload() {
                eY[this.id].forEach(t => {
                    "function" == typeof t.onUnload && t.onUnload()
                })
            },
            onBlockSelect(t) {
                eY[this.id].forEach(e => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
                })
            },
            onBlockDeselect(t) {
                eY[this.id].forEach(e => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
                })
            }
        };
    eH("blog-section", [eJ]), eH("hero", eV), eH("double", eJ);
    let e6 = t => {
            let {
                stickyHeaderHeight: e
            } = h();
            window.scrollTo({
                top: t + window.scrollY - e,
                left: 0,
                behavior: "smooth"
            })
        },
        e7 = class {
            write() {
                (-1 === document.cookie.indexOf("; ") || document.cookie.split("; ").find(t => t.startsWith(this.name))) && -1 !== document.cookie.indexOf("; ") || (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`)
            }
            read() {
                return !(-1 === document.cookie.indexOf("; ") || !document.cookie.split("; ").find(t => t.startsWith(this.name))) && document.cookie.split("; ").find(t => t.startsWith(this.name)).split("=")[1]
            }
            destroy() {
                document.cookie.split("; ").find(t => t.startsWith(this.name)) && (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`)
            }
            constructor(t, e, i = 7) {
                let s = new Date,
                    r = new Date;
                r.setTime(s.getTime() + 864e5 * i), this.configuration = {
                    expires: r.toGMTString(),
                    path: "/",
                    domain: window.location.hostname,
                    sameSite: "none",
                    secure: !0
                }, this.name = t, this.value = e
            }
        },
        eQ = "has-success",
        eK = "has-error",
        eZ = "hidden",
        it = {},
        ie = {
            onLoad() {
                it[this.id] = [], this.container.querySelectorAll("[data-newsletter-form]").forEach(t => {
                    it[this.id].push(new class {
                        init() {
                            this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage()
                        }
                        newsletterSubmitEvent(t) {
                            this.stopSubmit && (t.preventDefault(), t.stopImmediatePropagation(), this.removeStorage(), this.writeStorage(), this.stopSubmit = !1, this.newsletter.submit())
                        }
                        checkForChallengePage() {
                            this.isChallengePage = "/challenge" === window.location.pathname
                        }
                        writeStorage() {
                            void 0 !== this.sessionStorage && this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id)
                        }
                        readStorage() {
                            this.formID = this.sessionStorage.getItem("newsletter_form_id")
                        }
                        removeStorage() {
                            this.sessionStorage.removeItem("newsletter_form_id")
                        }
                        showMessage() {
                            if (this.readStorage(), this.newsletter.id === this.formID) {
                                let t = document.getElementById(this.formID),
                                    e = t.parentElement.querySelector("[data-newsletter-heading]"),
                                    i = -1 !== window.location.search.indexOf("?customer_posted=true"),
                                    s = -1 !== window.location.search.indexOf("accepts_marketing");
                                i ? (t.classList.remove(eK), t.classList.add(eQ), e && (e.classList.add(eZ), t.classList.remove(eZ)), this.popup && this.cookie.write()) : s && (t.classList.remove(eQ), t.classList.add(eK), e && (e.classList.add(eZ), t.classList.remove(eZ))), (i || s) && window.addEventListener("load", () => {
                                    this.scrollToForm(t)
                                })
                            }
                        }
                        scrollToForm(t) {
                            let e = t.getBoundingClientRect();
                            e.top >= 0 && e.left >= 0 && e.bottom <= f() && e.right <= v() || setTimeout(() => {
                                e6(t.getBoundingClientRect().top)
                            }, 500)
                        }
                        unload() {
                            this.newsletter.removeEventListener("submit", this.newsletterSubmit)
                        }
                        constructor(t) {
                            this.sessionStorage = window.sessionStorage, this.newsletter = t, this.popup = this.newsletter.closest("[data-newsletter]"), this.popup && (this.cookie = new e7(this.popup.getAttribute("data-cookie-name"), "user_has_closed", null)), this.stopSubmit = !0, this.isChallengePage = !1, this.formID = null, this.checkForChallengePage(), this.newsletterSubmit = t => this.newsletterSubmitEvent(t), this.isChallengePage || this.init()
                        }
                    }(t))
                })
            },
            onUnload() {
                it[this.id].forEach(t => {
                    "function" == typeof t.unload && t.unload()
                })
            }
        };
    eH("footer", [eV, ie]);
    let ii = "[data-collection-sidebar]",
        is = "input",
        ir = "[data-field-price-min]",
        io = "[data-field-price-max]",
        ia = "[data-se-min-value]",
        il = "[data-se-max-value]",
        ih = "data-se-min-value",
        ic = "data-se-max-value",
        id = "data-se-min",
        iu = "data-se-max",
        ip = "[data-show-more]",
        im = "[data-products-grid]",
        ig = "data-active-filters-count",
        iv = "[data-results-count]",
        iy = "hidden",
        ib = "is-loading",
        iS = "is-active",
        iL = class extends HTMLElement {
            connectedCallback() {
                this.sort && this.sortLinks.length && this.sortLinks.forEach(t => {
                    t.addEventListener("click", this.onSortButtonClickEvent)
                }), this.collectionSidebar && this.form && (this.collectionSidebar.addEventListener("input", this.updatePriceEvent), this.collectionSidebar.addEventListener("theme:range:update", this.updateRangeEvent)), this.showMoreOptions.length && this.showMoreOptions.forEach(t => {
                    t.addEventListener("click", this.showMoreEvent)
                }), (this.collectionSidebar || this.sort) && window.addEventListener("popstate", this.submitFormEvent), this.filterUrlButtons.length && this.filterUrlButtons.forEach(t => {
                    t.addEventListener("click", this.filterUpdateFromUrlEvent)
                }), this.collectionSidebarCloseButtons.length && this.collectionSidebarCloseButtons.forEach(t => {
                    t.addEventListener("click", this.collectionSidebarCloseEvent)
                })
            }
            collectionSidebarClose(t) {
                t.preventDefault(), this.container.dispatchEvent(new CustomEvent("theme:filter:close", {
                    bubbles: !1
                }))
            }
            onSortButtonClick(t) {
                t.preventDefault(), this.sortButton && this.sortButton.dispatchEvent(new Event("click")), this.sortActions(t, t.currentTarget)
            }
            sortActions(t, e, i = !0) {
                let s = this.sort.querySelector("[data-sort-button-text]"),
                    r = this.sort.querySelector(`.${iS}`);
                if (s) {
                    let o = e ? e.textContent.trim() : "";
                    s.textContent = o
                }
                r && r.classList.remove(iS), this.sort.classList.toggle(iS, e), e && (e.parentElement.classList.add(iS), i && this.submitForm(t))
            }
            onSortCheck(t) {
                let e = null;
                if (window.location.search.includes("sort_by")) {
                    let i = new window.URL(window.location.href).searchParams;
                    for (let [s, r] of i.entries()) {
                        let o = this.sort.querySelector(`[data-value="${r}"]`);
                        if (s.includes("sort_by") && o) {
                            e = o;
                            break
                        }
                    }
                }
                this.sortActions(t, e, !1)
            }
            showMore(t) {
                t.preventDefault();
                let e = t.target.matches(ip) ? t.target : t.target.closest(ip);
                e.parentElement.classList.add(iy), e.parentElement.previousElementSibling.querySelectorAll("[data-link-hidden]").forEach((t, e) => {
                    t.classList.remove(iy);
                    let i = t.querySelector(is);
                    0 === e && document.body.classList.contains("is-focused") && i && (this.collectionSidebarSlideOut || b() ? (this.a11y.removeTrapFocus(), this.a11y.trapFocus(this.collectionSidebar, {
                        elementToFocus: i
                    })) : i.focus())
                })
            }
            updatePrice(t) {
                let e = t.type,
                    i = t.target;
                if ((e === is || "select" === e || "label" === e || "textarea" === e) && this.form && "function" == typeof this.form.submit) {
                    let s = this.form.querySelector(ir),
                        r = this.form.querySelector(io);
                    s && r && (i.hasAttribute("data-field-price-min") && !r.value ? r.value = r.placeholder : i.hasAttribute("data-field-price-max") && !s.value && (s.value = s.placeholder)), this.submitForm(t)
                }
            }
            updateRange(t) {
                if (this.form && "function" == typeof this.form.submit) {
                    let e = this.form.querySelector(ia),
                        i = this.form.querySelector(il),
                        s = this.form.querySelector(ir),
                        r = this.form.querySelector(io);
                    if (e && i && s && r && e.hasAttribute(ih) && i.hasAttribute(ic)) {
                        let o = parseInt(s.placeholder),
                            n = parseInt(r.placeholder),
                            a = parseInt(e.getAttribute(ih)),
                            l = parseInt(i.getAttribute(ic));
                        o === a && n === l || (s.value = a, r.value = l, this.submitForm(t))
                    }
                }
            }
            filterUpdateFromUrl(t) {
                t.preventDefault(), this.submitForm(t, t.currentTarget.getAttribute("href"))
            }
            submitForm(t, e = "") {
                if (!t || t && "popstate" !== t.type) {
                    if ("" === e) {
                        let i = new window.URL(window.location.href).searchParams,
                            s = Object.fromEntries(i),
                            r = i.toString();
                        if (r.includes("filter.") || r.includes("page=") || r.includes("sort_by="))
                            for (let o in s)(o.includes("filter.") || "page" === o || "sort_by" === o) && i.delete(o);
                        if (this.form) {
                            let n = new FormData(this.form),
                                a = new URLSearchParams(n),
                                l = this.form.querySelector(ia),
                                h = this.form.querySelector(il),
                                c = l && l.hasAttribute(id) ? l.getAttribute(id) : "",
                                d = h && h.hasAttribute(iu) ? h.getAttribute(iu) : "",
                                u = 0;
                            for (let [p, m] of a.entries())(p.includes("filter.") && m || p.includes("sort_by") && m) && (i.append(p, m), (m === c && "filter.v.price.gte" === p || m === d && "filter.v.price.lte" === p) && (u += 1));
                            2 === u && (i.delete("filter.v.price.gte"), i.delete("filter.v.price.lte"))
                        }
                        let g = i.toString(),
                            v = g ? `?${g}` : location.pathname;
                        window.history.pushState(null, "", v)
                    } else window.history.pushState(null, "", e)
                } else this.sort && this.onSortCheck(t);
                this.productsContainer && (this.productsContainer.classList.add(ib), fetch(`${window.location.pathname}${window.location.search}`).then(t => t.text()).then(t => {
                    let e = new DOMParser().parseFromString(t, "text/html"),
                        i = this.container.querySelector(iv);
                    if (i) {
                        let s = e.querySelector(iv);
                        i.innerHTML = s.innerHTML
                    }
                    if (this.productsContainer.innerHTML = e.querySelector(im).innerHTML, this.collectionSidebar) {
                        this.collectionSidebar.innerHTML = e.querySelector(ii).innerHTML;
                        let r = this.collectionSidebar.querySelector(`[${ig}]`),
                            o = this.container.querySelectorAll("[data-active-filters]");
                        if (r && o.length) {
                            let n = parseInt(r.getAttribute(ig));
                            o.forEach(t => {
                                t.textContent = n, t.classList.toggle(iy, n < 1)
                            })
                        }
                    }
                    this.collectionNav && e6(this.productsContainer.getBoundingClientRect().top - this.collectionNav.offsetHeight), setTimeout(() => {
                        this.productsContainer.classList.remove(ib)
                    }, 500)
                }).catch(t => {
                    console.log(t)
                }))
            }
            disconnectedCallback() {
                this.collectionSidebar && this.form && (this.collectionSidebar.removeEventListener("input", this.updatePriceEvent), this.collectionSidebar.removeEventListener("theme:range:update", this.updateRangeEvent)), this.showMoreOptions.length && this.showMoreOptions.forEach(t => {
                    t.removeEventListener("click", this.showMoreEvent)
                }), this.sort && this.sortLinks.length && this.sortLinks.forEach(t => {
                    t.removeEventListener("click", this.onSortButtonClickEvent)
                }), (this.collectionSidebar || this.sort) && window.removeEventListener("popstate", this.submitFormEvent), this.filterUrlButtons.length && this.filterUrlButtons.forEach(t => {
                    t.removeEventListener("click", this.filterUpdateFromUrlEvent)
                }), this.collectionSidebarCloseButtons.length && this.collectionSidebarCloseButtons.forEach(t => {
                    t.removeEventListener("click", this.collectionSidebarCloseEvent)
                })
            }
            constructor() {
                super(), this.container = this.closest("[data-section-type]"), this.collectionSidebar = this.container.querySelector(ii), this.collectionSidebarSlideOut = this.container.querySelector("[data-collection-sidebar-slide-out]"), this.form = this.querySelector("[data-collection-filters-form]"), this.productsContainer = this.container.querySelector(im), this.collectionNav = this.container.querySelector("[data-collection-nav]"), this.sort = this.container.querySelector("[data-sort-enabled]"), this.sortButton = this.container.querySelector("[data-popout-toggle]"), this.sortLinks = this.container.querySelectorAll("[data-sort-link]"), this.filterUrlButtons = this.container.querySelectorAll("[data-filter-update-url]"), this.collectionSidebarCloseButtons = this.container.querySelectorAll("[data-collection-sidebar-close]"), this.showMoreOptions = this.querySelectorAll(ip), this.a11y = F, this.updatePriceEvent = g(t => this.updatePrice(t), 500), this.updateRangeEvent = t => this.updateRange(t), this.showMoreEvent = t => this.showMore(t), this.onSortButtonClickEvent = t => this.onSortButtonClick(t), this.submitFormEvent = t => this.submitForm(t), this.collectionSidebarCloseEvent = t => this.collectionSidebarClose(t), this.filterUpdateFromUrlEvent = t => this.filterUpdateFromUrl(t)
            }
        },
        iE = "data-se-min-value",
        iw = "data-se-max-value",
        ik = "data-se-step",
        i$ = class extends HTMLElement {
            connectedCallback() {
                let t = this.min;
                this.hasAttribute(iE) && (t = parseFloat(this.getAttribute(iE)));
                let e = this.max;
                this.hasAttribute(iw) && (e = parseFloat(this.getAttribute(iw))), t < this.min && (t = this.min), e > this.max && (e = this.max), t > e && (t = e), this.getAttribute(ik) && (this.step = Math.abs(parseFloat(this.getAttribute(ik)))), this.reset(), this.maxX = this.offsetWidth - this.touchRight.offsetWidth, this.selectedTouch = null, this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact, this.setMinValue(t), this.setMaxValue(e), this.touchLeft.addEventListener("mousedown", this.onStartEvent), this.touchRight.addEventListener("mousedown", this.onStartEvent), this.touchLeft.addEventListener("touchstart", this.onStartEvent, {
                    passive: !0
                }), this.touchRight.addEventListener("touchstart", this.onStartEvent, {
                    passive: !0
                }), this.classList.add("is-initialized")
            }
            reset() {
                this.touchLeft.style.left = "0px", this.touchRight.style.left = this.offsetWidth - this.touchLeft.offsetWidth + "px", this.lineSpan.style.marginLeft = "0px", this.lineSpan.style.width = this.offsetWidth - this.touchLeft.offsetWidth + "px", this.startX = 0, this.x = 0
            }
            setMinValue(t) {
                let e = (t - this.min) / (this.max - this.min);
                this.touchLeft.style.left = Math.ceil(e * (this.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px", this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.setAttribute(iE, t)
            }
            setMaxValue(t) {
                let e = (t - this.min) / (this.max - this.min);
                this.touchRight.style.left = Math.ceil(e * (this.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + "px", this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.setAttribute(iw, t)
            }
            onStart(t) {
                let e = t;
                t.touches && (e = t.touches[0]), t.currentTarget === this.touchLeft ? this.x = this.touchLeft.offsetLeft : t.currentTarget === this.touchRight && (this.x = this.touchRight.offsetLeft), this.startX = e.pageX - this.x, this.selectedTouch = t.currentTarget, document.addEventListener("mousemove", this.onMoveEvent), document.addEventListener("mouseup", this.onStopEvent), document.addEventListener("touchmove", this.onMoveEvent, {
                    passive: !0
                }), document.addEventListener("touchend", this.onStopEvent, {
                    passive: !0
                })
            }
            onMove(t) {
                let e = t;
                t.touches && (e = t.touches[0]), this.x = e.pageX - this.startX, this.selectedTouch === this.touchLeft ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 ? this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 : this.x < 0 && (this.x = 0), this.selectedTouch.style.left = this.x + "px") : this.selectedTouch === this.touchRight && (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 ? this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 : this.x > this.maxX && (this.x = this.maxX), this.selectedTouch.style.left = this.x + "px"), this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.calculateValue(), this.getAttribute("on-change") && Function("min, max", this.getAttribute("on-change"))(this.getAttribute(iE), this.getAttribute(iw)), this.onChange(this.getAttribute(iE), this.getAttribute(iw))
            }
            onStop() {
                document.removeEventListener("mousemove", this.onMoveEvent), document.removeEventListener("mouseup", this.onStopEvent), document.removeEventListener("touchmove", this.onMoveEvent), document.removeEventListener("touchend", this.onStopEvent), this.selectedTouch = null, this.calculateValue(), this.onChanged(this.getAttribute(iE), this.getAttribute(iw))
            }
            onChange(t, e) {
                let i = this.closest("[data-range-holder]");
                if (i) {
                    let s = i.querySelector("[data-field-price-min]"),
                        r = i.querySelector("[data-field-price-max]");
                    s && r && (s.value = t, r.value = e)
                }
            }
            onChanged(t, e) {
                this.hasAttribute("data-range-filter-update") && this.dispatchEvent(new CustomEvent("theme:range:update", {
                    bubbles: !0
                }))
            }
            calculateValue() {
                let t = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue,
                    e = this.lineSpan.offsetLeft / this.initialValue,
                    i = e + t;
                if (e = e * (this.max - this.min) + this.min, i = i * (this.max - this.min) + this.min, 0 !== this.step) {
                    let s = Math.floor(e / this.step);
                    e = this.step * s, s = Math.floor(i / this.step), i = this.step * s
                }
                this.selectedTouch === this.touchLeft && this.setAttribute(iE, e), this.selectedTouch === this.touchRight && this.setAttribute(iw, i)
            }
            onSidebarTransitionEnd(t) {
                t.target == this.sidebar && "min-width" == t.propertyName && (this.sidebar.removeEventListener("transitionend", this.sidebarTransitionEvent), this.connectedCallback())
            }
            disconnectedCallback() {
                this.sidebar.removeEventListener("transitionend", this.sidebarTransitionEvent), this.resizeEvent && document.removeEventListener("theme:resize:width", this.resizeEvent)
            }
            constructor() {
                super(), this.sidebar = this.closest("[data-collection-sidebar]"), this.sidebarTransitionEvent = t => this.onSidebarTransitionEnd(t), this.resizeEvent = () => {
                    this.connectedCallback(), this.sidebar.addEventListener("transitionend", this.sidebarTransitionEvent)
                }, this.onMoveEvent = t => this.onMove(t), this.onStopEvent = t => this.onStop(t), this.onStartEvent = t => this.onStart(t), this.startX = 0, this.x = 0, this.touchLeft = this.querySelector("[data-range-left]"), this.touchRight = this.querySelector("[data-range-right]"), this.lineSpan = this.querySelector("[data-range-line]"), this.min = parseFloat(this.getAttribute("data-se-min")), this.max = parseFloat(this.getAttribute("data-se-max")), this.step = 0, this.normalizeFact = 26, document.addEventListener("theme:resize:width", this.resizeEvent)
            }
        },
        iA = "[data-collection-sidebar-slide-out]",
        iC = "drawer--animated",
        iT = "expanded",
        iq = {};
    eH("collection", [eJ, eV, {
        onLoad() {
            iq[this.id] = new class {
                init() {
                    null !== this.groupTagsButton && (document.addEventListener("theme:resize:width", this.sidebarResizeEvent), this.groupTagsButton.addEventListener("click", this.groupTagsButtonClickEvent), this.collectionSidebar && setTimeout(() => {
                        this.collectionSidebar.classList.remove("no-mobile-animation")
                    }, 1e3), new MutationObserver(t => {
                        for (let e of t) "attributes" === e.type && "true" == e.target.getAttribute("aria-expanded") && this.showSidebarCallback()
                    }).observe(this.groupTagsButton, {
                        attributes: !0,
                        childList: !1,
                        subtree: !1
                    })), this.container.addEventListener("keyup", (function(t) {
                        "Escape" === t.code && this.hideSidebar()
                    }).bind(this)), this.collectionSidebar && (this.collectionSidebar.addEventListener("transitionend", () => {
                        this.collectionSidebar.classList.contains(iT) || this.collectionSidebar.classList.remove(iC)
                    }), this.toggleSidebarSlider(), this.container.addEventListener("theme:filter:close", this.collectionSidebarCloseEvent))
                }
                showSidebarCallback() {
                    let t = this.container.querySelector(iA),
                        e = document.documentElement.hasAttribute("data-scroll-locked"),
                        i = b();
                    this.collectionSidebar.classList.add(iC), null === t && !i && e && (this.a11y.removeTrapFocus(), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    }))), (i || null !== t) && (t && this.a11y.trapFocus(this.collectionSidebar, {
                        elementToFocus: this.collectionSidebar.querySelector("[data-collection-sidebar-close]")
                    }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                        bubbles: !0
                    })))
                }
                hideSidebar() {
                    let t = this.container.querySelector(iA),
                        e = document.documentElement.hasAttribute("data-scroll-locked");
                    this.groupTagsButton.setAttribute("aria-expanded", "false"), this.collectionSidebar.classList.remove(iT), t && this.a11y.removeTrapFocus(), e && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    }))
                }
                toggleSidebarSlider() {
                    b() ? this.hideSidebar() : this.collectionSidebar.classList.contains(iT) && this.showSidebarCallback()
                }
                collectionSidebarClose(t) {
                    t.preventDefault(), this.hideSidebar(), document.body.classList.contains("is-focused") && this.groupTagsButton && this.groupTagsButton.focus()
                }
                groupTagsButtonClick() {
                    document.documentElement.hasAttribute("data-scroll-locked") && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    }))
                }
                onUnload() {
                    null !== this.groupTagsButton && (document.removeEventListener("theme:resize:width", this.sidebarResizeEvent), this.groupTagsButton.removeEventListener("click", this.groupTagsButtonClickEvent)), this.collectionSidebar && this.container.removeEventListener("theme:filter:close", this.collectionSidebarCloseEvent)
                }
                constructor(t) {
                    this.container = t.container, this.collectionSidebar = this.container.querySelector("[data-collection-sidebar]"), this.groupTagsButton = this.container.querySelector("[data-aria-toggle]"), this.a11y = F, this.groupTagsButtonClickEvent = t => this.groupTagsButtonClick(t), this.sidebarResizeEvent = () => this.toggleSidebarSlider(), this.collectionSidebarCloseEvent = t => this.collectionSidebarClose(t), this.init()
                }
            }(this)
        },
        onUnload() {
            iq[this.id].onUnload()
        }
    }, eU, ]), customElements.get("collection-filters-form") || customElements.define("collection-filters-form", iL), customElements.get("range-slider") || customElements.define("range-slider", i$);
    let ix = "[data-ticker-text]",
        i_ = "data-clone",
        iP = "speed",
        iM = "ticker--animated",
        iH = class extends HTMLElement {
            connectedCallback() {
                this.checkWidth(), this.addEventListener("theme:ticker:refresh", this.checkWidthEvent), screen.orientation.addEventListener("change", this.checkWidthEvent), document.addEventListener("theme:resize:width", this.checkWidthEvent)
            }
            disconnectedCallback() {
                document.removeEventListener("theme:resize:width", this.checkWidthEvent)
            }
            checkWidth() {
                let t = 2 * window.getComputedStyle(this).paddingLeft.replace("px", ""),
                    e = this.clientWidth - t < this.comparitor.clientWidth;
                if (e || this.autoplay) {
                    var i;
                    this.text.classList.remove(iM);
                    let s = this.scale.querySelectorAll(`[${i_}]`),
                        r = this.autoplay ? parseInt((window.innerWidth - t) / this.text.clientWidth) : 2;
                    if (null == s || s.forEach(t => {
                            t.remove()
                        }), this.autoplay || e)
                        for (let o = 0; o <= r; o++) {
                            let n = this.text.cloneNode(!0);
                            n.setAttribute(i_, ""), this.scale.appendChild(n)
                        }
                    let a = (this.text.clientWidth / 100 * Number(this.speed)).toFixed(2);
                    this.scale.style.setProperty("--animation-time", `${a}s`), null === (i = this.scale.querySelectorAll(ix)) || void 0 === i || i.forEach(t => {
                        t.classList.add(iM)
                    })
                } else {
                    this.text.classList.remove(iM);
                    let l = this.scale.querySelector(`[${i_}]`);
                    l && this.scale.removeChild(l), this.text.classList.remove(iM), document.querySelectorAll(".announcement__text[data-clone]").forEach(t => t.remove())
                }
            }
            constructor() {
                super(), this.autoplay = this.hasAttribute("autoplay"), this.scale = this.querySelector("[data-ticker-scale]"), this.text = this.querySelector(ix), this.speed = this.hasAttribute(iP) ? this.getAttribute(iP) : 1.63, this.comparitor = this.text.cloneNode(!0), this.comparitor.classList.add("ticker__comparitor"), this.appendChild(this.comparitor), this.scale.classList.remove("ticker--unloaded"), this.checkWidthEvent = this.checkWidth.bind(this)
            }
        },
        iB = {
            slide: "[data-slide]",
            slider: "[data-slider]"
        },
        iI = "data-target-referrer",
        iD = class extends HTMLElement {
            connectedCallback() {
                this.removeAnnouncement(), this.slider && this.initSliders(), this.addEventListener("theme:block:select", t => {
                    this.onBlockSelect(t)
                }), this.addEventListener("theme:block:deselect", t => {
                    this.onBlockDeselect(t)
                }), document.dispatchEvent(new CustomEvent("theme:announcement:init", {
                    bubbles: !0
                }))
            }
            removeAnnouncement() {
                for (let t = 0; t < this.slides.length; t++) {
                    let e = this.slides[t];
                    e.hasAttribute(iI) && (-1 !== this.locationPath.indexOf(e.getAttribute(iI)) || window.Shopify.designMode || e.parentNode.removeChild(e))
                }
            }
            initSliders() {
                this.initSlider(), document.addEventListener("theme:resize:width", this.initSliderEvent), this.addEventListener("theme:slider:loaded", () => {
                    var t;
                    null === (t = this.querySelectorAll(iB.tickerBar)) || void 0 === t || t.forEach(t => {
                        t.dispatchEvent(new CustomEvent("theme:ticker:refresh"))
                    })
                })
            }
            initSlider() {
                var t, e;
                let i = y(),
                    s = !i;
                (i && this.enableSlider || s && !this.enableSlider) && (null === (t = this.slider.flkty) || void 0 === t || t.destroy(), i && this.enableSlider ? this.enableSlider = !1 : s && !this.enableSlider && (this.enableSlider = !0), this.slider = new e5(this, this.querySelector(iB.slider)), null === (e = this.slider.flkty) || void 0 === e || e.reposition())
            }
            onBlockSelect(t) {
                this.slider && this.slider.onBlockSelect(t)
            }
            onBlockDeselect(t) {
                this.slider && this.slider.onBlockDeselect(t)
            }
            disconnectedCallback() {
                document.removeEventListener("theme:resize:width", this.initSliderEvent), document.removeEventListener("theme:resize:width", this.tickerResizeEvent), this.removeEventListener("theme:block:select", t => {
                    this.onBlockSelect(t)
                }), this.removeEventListener("theme:block:deselect", t => {
                    this.onBlockDeselect(t)
                })
            }
            constructor() {
                super(), this.locationPath = location.href, this.slides = this.querySelectorAll(iB.slide), this.slider = this.querySelector(iB.slider), this.enableSlider = y(), this.initSliderEvent = t => this.initSlider(t)
            }
        };
    customElements.get("announcement-bar") || customElements.define("announcement-bar", iD), customElements.get("ticker-bar") || customElements.define("ticker-bar", iH);
    let iO = "[data-drawer]",
        i8 = "drawer--animated",
        i9 = "is-open",
        iF = "is-closing",
        iR = {},
        iN = ".page-header",
        iz = "js__header__stuck",
        iW = {},
        iU = "is-visible",
        i0 = "meganav--visible",
        iV = "meganav--is-transitioning",
        ij = {},
        i1 = {},
        i3 = "data-sliderule-pane",
        iX = "data-animates",
        i2 = "is-visible",
        i4 = "is-hiding",
        iG = "is-hidden",
        iY = "is-scrolling",
        i5 = {},
        iJ = "js__show__mobile",
        i6 = {};
    eH("header", [{
        onLoad() {
            i6 = new class {
                initTicker(t = !1) {
                    this.tickerFrames.forEach(e => {
                        new iH(e, t)
                    }), this.tickerResizeEvent = t => this.onTickerResize(t), document.addEventListener("theme:resize:width", this.tickerResizeEvent)
                }
                listenWidth() {
                    "ResizeObserver" in window ? (this.resizeObserver = new ResizeObserver(this.checkWidth), this.resizeObserver.observe(this.wrapper)) : document.addEventListener("theme:resize", this.checkWidth)
                }
                killDeadLinks() {
                    this.deadLinks.forEach(t => {
                        t.onclick = t => {
                            t.preventDefault()
                        }
                    })
                }
                checkWidth() {
                    if (document.body.clientWidth < this.minWidth) {
                        this.wrapper.classList.add(iJ);
                        let {
                            headerHeight: t
                        } = h();
                        document.documentElement.style.setProperty("--header-height", `${t}px`)
                    } else this.wrapper.classList.remove(iJ)
                }
                getMinWidth() {
                    let t = this.wrapper.cloneNode(!0);
                    t.classList.add("js__header__clone"), document.body.appendChild(t);
                    let e = t.querySelectorAll("[data-takes-space-wrapper]"),
                        i = 0,
                        s = 0;
                    return e.forEach(t => {
                        var e, r;
                        let o = t.querySelectorAll("[data-child-takes-space]"),
                            n = 0,
                            a, l;
                        (n = 3 === o.length ? (a = [], (e = o).forEach(t => {
                            t.firstElementChild && a.push(t.firstElementChild.clientWidth)
                        }), a[0] > a[2] ? a[2] = a[0] : a[0] = a[2], a.reduce((t, e) => t + e)) : (l = 0, (r = o).forEach(t => {
                            l += t.clientWidth
                        }), l)) > i && (i = n, s = 20 * o.length)
                    }), document.body.removeChild(t), i + s
                }
                cartToggleEvent() {
                    var t;
                    "drawer" === theme.settings.cartType && (null === (t = this.wrapper.querySelectorAll("[data-cart-toggle]")) || void 0 === t || t.forEach(t => {
                        t.addEventListener("click", e => {
                            let i = document.querySelector("cart-drawer");
                            i && (e.preventDefault(), i.dispatchEvent(new CustomEvent("theme:cart-drawer:show")), window.accessibility.lastElement = t)
                        })
                    }))
                }
                toggleButtonClick(t) {
                    t.preventDefault(), document.dispatchEvent(new CustomEvent("theme:cart:toggle", {
                        bubbles: !0
                    }))
                }
                unload() {
                    var t;
                    "ResizeObserver" in window ? null === (t = this.resizeObserver) || void 0 === t || t.unobserve(this.wrapper) : document.removeEventListener("theme:resize", this.checkWidth)
                }
                constructor(t) {
                    this.wrapper = t, this.style = this.wrapper.dataset.style, this.desktop = this.wrapper.querySelector("[data-header-desktop]"), this.deadLinks = document.querySelectorAll('.navlink[href="#"]'), this.resizeObserver = null, this.checkWidth = this.checkWidth.bind(this), this.killDeadLinks(), "drawer" !== this.style && this.desktop && (this.minWidth = this.getMinWidth(), this.listenWidth()), this.cartToggleEvent();
                    let e = document.querySelector(".main-content > .shopify-section.section-overlay-header:first-of-type");
                    document.body.classList.toggle("has-header-transparent", this.wrapper.hasAttribute("data-header-transparent")), document.body.classList.toggle("has-first-section-overlay-header", e)
                }
            }(this.container)
        },
        onUnload() {
            "function" == typeof i6.unload && i6.unload()
        }
    }, {
        onLoad() {
            iR[this.id] = [], this.container.querySelectorAll(iO).forEach(t => {
                iR[this.id].push(new class {
                    connectToggle() {
                        this.buttons.forEach(t => {
                            t.addEventListener("click", () => {
                                this.drawer.dispatchEvent(new CustomEvent("theme:drawer:toggle", {
                                    bubbles: !1
                                }))
                            })
                        })
                    }
                    connectDrawer() {
                        this.drawer.addEventListener("theme:drawer:toggle", () => {
                            this.drawer.classList.contains(i9) ? this.drawer.dispatchEvent(new CustomEvent("theme:drawer:close", {
                                bubbles: !0
                            })) : this.drawer.dispatchEvent(new CustomEvent("theme:drawer:open", {
                                bubbles: !0
                            }))
                        }), document.addEventListener("theme:cart-drawer:open", this.hideDrawer), document.addEventListener("theme:drawer:close", this.hideDrawer), document.addEventListener("theme:drawer:open", this.showDrawer)
                    }
                    closers() {
                        this.wrapper.addEventListener("keyup", t => {
                            "Escape" === t.code && this.hideDrawer()
                        }), this.underlay.addEventListener("click", () => {
                            this.hideDrawer()
                        })
                    }
                    showDrawer() {
                        this.isAnimating || (this.isAnimating = !0, this.buttons.forEach(t => {
                            t.setAttribute("aria-expanded", !0)
                        }), this.drawer.classList.add(i9, i8), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                            bubbles: !0
                        })), this.drawerInner && this.drawerInner.querySelector(this.btnSelector) && (D(), ee(this.drawerInner).then(() => {
                            this.drawer.querySelector('button, [href], select, textarea, [tabindex]:not([tabindex="-1"])').focus(), this.isAnimating = !1, I(this.drawerInner, {
                                elementToFocus: this.drawerInner.querySelector(this.btnSelector)
                            })
                        })))
                    }
                    hideDrawer() {
                        this.drawer.classList.contains(i9) && !this.isAnimating && (this.isAnimating = !0, this.drawer.classList.add(iF), this.drawer.classList.remove(i9), D(), this.body.classList.contains("is-focused") && this.buttons.length && this.buttons[0].focus(), this.buttons.forEach(t => {
                            t.setAttribute("aria-expanded", !1)
                        }), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                            bubbles: !0
                        })), ee(this.drawerInner).then(() => {
                            this.drawer.classList.remove(iF, i8), this.isAnimating = !1, document.dispatchEvent(new CustomEvent("theme:sliderule:close", {
                                bubbles: !1
                            }))
                        }))
                    }
                    onUnload() {
                        document.removeEventListener("theme:cart-drawer:open", this.hideDrawer), document.removeEventListener("theme:drawer:close", this.hideDrawer), document.removeEventListener("theme:drawer:open", this.showDrawer)
                    }
                    constructor(t) {
                        this.isAnimating = !1, this.drawer = t, this.drawerWrapper = this.drawer.closest(iO), this.drawerInner = this.drawer.querySelector("[data-drawer-inner]"), this.underlay = this.drawer.querySelector("[data-drawer-underlay]"), this.wrapper = this.drawer.closest("[data-header-wrapper]"), this.key = this.drawer.dataset.drawer, this.btnSelector = `[data-drawer-toggle='${this.key}']`, this.buttons = document.querySelectorAll(this.btnSelector), this.staggers = this.drawer.querySelectorAll("[data-stagger-animation]"), this.body = document.querySelector("body"), this.showDrawer = this.showDrawer.bind(this), this.hideDrawer = this.hideDrawer.bind(this), this.connectToggle(), this.connectDrawer(), this.closers()
                    }
                }(t))
            })
        },
        onUnload() {
            iR[this.id].forEach(t => {
                "function" == typeof t.onUnload && t.onUnload()
            })
        }
    }, {
        onLoad() {
            i5[this.id] = [], this.container.querySelectorAll("[data-sliderule]").forEach(t => {
                i5[this.id].push(new class {
                    clickEvents() {
                        this.trigger.addEventListener("click", () => {
                            this.cachedButton = this.trigger, this.showSliderule()
                        }), this.exit.forEach(t => {
                            t.addEventListener("click", () => {
                                this.hideSliderule()
                            })
                        })
                    }
                    keyboardEvents() {
                        this.sliderule.addEventListener("keyup", t => {
                            t.stopPropagation(), "Escape" === t.code && this.hideSliderule()
                        })
                    }
                    trapFocusSliderule(t = !0) {
                        let e = t ? this.sliderule.querySelector(this.exitSelector) : this.cachedButton;
                        this.accessibility.removeTrapFocus(), e && this.drawerContent && this.accessibility.trapFocus(this.drawerContent, {
                            elementToFocus: document.body.classList.contains("is-focused") ? e : null
                        })
                    }
                    hideSliderule(t = !1) {
                        let e = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                        this.pane.setAttribute(i3, e), this.pane.classList.add(i4), this.sliderule.classList.add(i4);
                        let i = t ? `[${iX}].${iG}` : `[${iX}="${e}"]`,
                            s = this.pane.querySelectorAll(i);
                        s.length && s.forEach(t => {
                            t.classList.remove(iG)
                        });
                        let r = t ? this.pane.querySelectorAll(`.${i2}, .${i4}`) : this.children;
                        r.forEach((i, s) => {
                            let o = r.length - 1 == s;
                            i.classList.remove(i2), t && (i.classList.remove(i4), this.pane.classList.remove(i4));
                            let n = () => {
                                parseInt(this.pane.getAttribute(i3)) === e && this.sliderule.classList.remove(i2), this.sliderule.classList.remove(i4), this.pane.classList.remove(i4), o && (this.accessibility.removeTrapFocus(), t || this.trapFocusSliderule(!1)), i.removeEventListener("animationend", n)
                            };
                            window.theme.settings.enableAnimations ? i.addEventListener("animationend", n) : n()
                        })
                    }
                    showSliderule() {
                        let t = null,
                            e = this.sliderule.closest(`.${i2}`),
                            i = this.pane;
                        e && (i = e), i.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth"
                        }), i.classList.add(iY);
                        let s = () => {
                            i.scrollTop <= 0 ? (i.classList.remove(iY), t && cancelAnimationFrame(t)) : t = requestAnimationFrame(s)
                        };
                        t = requestAnimationFrame(s), this.sliderule.classList.add(i2);
                        let r = parseInt(this.pane.dataset.sliderulePane, 10);
                        this.pane.setAttribute(i3, r + 1);
                        let o = this.pane.querySelectorAll(`[${iX}="${r}"]`);
                        o.length && o.forEach((t, e) => {
                            let i = o.length - 1 == e;
                            t.classList.add(i4);
                            let s = () => {
                                t.classList.remove(i4), parseInt(this.pane.getAttribute(i3)) !== r && t.classList.add(iG), i && this.trapFocusSliderule(), t.removeEventListener("animationend", s)
                            };
                            window.theme.settings.enableAnimations ? t.addEventListener("animationend", s) : s()
                        })
                    }
                    closeSliderule() {
                        this.pane && this.pane.hasAttribute(i3) && parseInt(this.pane.getAttribute(i3)) > 0 && (this.hideSliderule(!0), parseInt(this.pane.getAttribute(i3)) > 0 && this.pane.setAttribute(i3, 0))
                    }
                    onUnload() {
                        document.removeEventListener("theme:sliderule:close", this.closeSliderule)
                    }
                    constructor(t) {
                        this.sliderule = t, this.key = this.sliderule.id;
                        let e = `[data-sliderule-open='${this.key}']`;
                        this.exitSelector = `[data-sliderule-close='${this.key}']`, this.trigger = document.querySelector(e), this.exit = document.querySelectorAll(this.exitSelector), this.pane = document.querySelector(`[${i3}]`), this.children = this.sliderule.querySelectorAll(":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope > * > .sliderule-grid  > *"), this.drawerContent = document.querySelector("[data-drawer-content]"), this.cachedButton = null, this.accessibility = F, this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.closeSliderule = this.closeSliderule.bind(this), this.clickEvents(), this.keyboardEvents(), document.addEventListener("theme:sliderule:close", this.closeSliderule)
                    }
                }(t))
            })
        },
        onUnload() {
            i5[this.id].forEach(t => {
                "function" == typeof t.onUnload && t.onUnload()
            })
        }
    }, {
        onLoad() {
            iW = new class {
                listen() {
                    document.addEventListener("theme:scroll", this.scrollEvent), document.addEventListener("shopify:section:load", this.updateHeaderOffset), document.addEventListener("shopify:section:unload", this.updateHeaderOffset)
                }
                onScroll(t) {
                    t.detail.down ? !this.isStuck && t.detail.position > this.headerOffset && this.stickSimple() : t.detail.position <= this.headerOffset && this.unstickSimple()
                }
                updateHeaderOffset(t) {
                    t.target.classList.contains("shopify-section-group-header-group") && setTimeout(() => {
                        var t;
                        this.headerOffset = null === (t = document.querySelector(iN)) || void 0 === t ? void 0 : t.offsetTop
                    })
                }
                stickOnLoad() {
                    window.scrollY > this.headerOffset && this.stickSimple()
                }
                stickSimple() {
                    this.cls.add(iz), document.querySelector('.header-sections').classList.add('sub-header-fixed'),
                    this.isStuck = !0
                }
                unstickSimple() {
                    document.documentElement.hasAttribute("data-scroll-locked") || (this.cls.remove(iz), document.querySelector('.header-sections').classList.remove('sub-header-fixed'), this.isStuck = !1)
                }
                unload() {
                    document.removeEventListener("theme:scroll", this.scrollEvent), document.removeEventListener("shopify:section:load", this.updateHeaderOffset), document.removeEventListener("shopify:section:unload", this.updateHeaderOffset)
                }
                constructor(t) {
                    var e;
                    this.wrapper = t, this.sticks = this.wrapper.hasAttribute("data-header-sticky"), document.body.classList.toggle("has-header-sticky", this.sticks), this.sticks && (this.isStuck = !1, this.cls = this.wrapper.classList, this.headerOffset = null === (e = document.querySelector(iN)) || void 0 === e ? void 0 : e.offsetTop, this.updateHeaderOffset = this.updateHeaderOffset.bind(this), this.scrollEvent = t => this.onScroll(t), this.listen(), this.stickOnLoad())
                }
            }(this.container)
        },
        onUnload: function() {
            "function" == typeof iW.unload && iW.unload()
        }
    }, {
        onLoad() {
            ij[this.id] = [], (i1 = this.container.querySelectorAll("[data-hover-disclosure]")).forEach(t => {
                ij[this.id].push(new class {
                    onBlockSelect(t) {
                        this.disclosure.contains(t.target) && this.showDisclosure(t)
                    }
                    onBlockDeselect(t) {
                        this.disclosure.contains(t.target) && this.hideDisclosure()
                    }
                    showDisclosure(t) {
                        t && t.type && "mouseenter" === t.type && this.wrapper.classList.add(iV), this.grandparent ? this.wrapper.classList.add(i0) : this.wrapper.classList.remove(i0), this.trigger.setAttribute("aria-expanded", !0), this.trigger.classList.add(iU), this.disclosure.classList.add(iU), this.transitionTimeout && clearTimeout(this.transitionTimeout), this.transitionTimeout = setTimeout(() => {
                            this.wrapper.classList.remove(iV)
                        }, 200)
                    }
                    hideDisclosure() {
                        this.disclosure.classList.remove(iU), this.trigger.classList.remove(iU), this.trigger.setAttribute("aria-expanded", !1), this.wrapper.classList.remove(i0, iV)
                    }
                    staggerChildAnimations() {
                        this.disclosure.querySelectorAll("[data-stagger]").forEach((t, e) => {
                            t.style.transitionDelay = 50 * e + 10 + "ms"
                        }), this.disclosure.querySelectorAll("[data-stagger-first]").forEach((t, e) => {
                            let i = 100 * e;
                            t.style.transitionDelay = `${i}ms`, t.parentElement.querySelectorAll("[data-stagger-second]").forEach((t, e) => {
                                t.style.transitionDelay = `${i+20*(e+1)}ms`
                            })
                        })
                    }
                    handleTablets() {
                        this.trigger.addEventListener("touchstart", (function(t) {
                            this.disclosure.classList.contains(iU) || (t.preventDefault(), this.showDisclosure(t))
                        }).bind(this), {
                            passive: !0
                        })
                    }
                    connectHoverToggle() {
                        this.trigger.addEventListener("mouseenter", t => this.showDisclosure(t)), this.link.addEventListener("focus", t => this.showDisclosure(t)), this.trigger.addEventListener("mouseleave", () => this.hideDisclosure()), this.trigger.addEventListener("focusout", t => {
                            this.trigger.contains(t.relatedTarget) || this.hideDisclosure()
                        }), this.disclosure.addEventListener("keyup", t => {
                            "Escape" === t.code && this.hideDisclosure()
                        })
                    }
                    constructor(t) {
                        this.disclosure = t, this.wrapper = t.closest("[data-header-wrapper]"), this.key = this.disclosure.id, this.trigger = document.querySelector(`[data-hover-disclosure-toggle='${this.key}']`), this.link = this.trigger.querySelector("[data-top-link]"), this.grandparent = this.trigger.classList.contains("grandparent"), this.transitionTimeout = 0, this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.connectHoverToggle(), this.handleTablets(), this.staggerChildAnimations()
                    }
                }(t))
            })
        },
        onBlockSelect(t) {
            ij[this.id].forEach(e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            })
        },
        onBlockDeselect(t) {
            ij[this.id].forEach(e => {
                "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
            })
        }
    }, ]), customElements.get("ticker-bar") || customElements.define("ticker-bar", iH);
    let i7 = {},
        iQ = {
            onLoad() {
                i7[this.id] = new class {
                    onBlockSelect(t) {
                        let e = this.container.querySelector("[data-block-scroll]");
                        if (e && !e.classList.contains("flickity-enabled")) {
                            let i = t.srcElement;
                            i && e.scrollTo({
                                top: 0,
                                left: i.offsetLeft,
                                behavior: "smooth"
                            })
                        }
                    }
                    constructor(t) {
                        this.container = t.container
                    }
                }(this)
            },
            onBlockSelect(t) {
                i7[this.id].onBlockSelect(t)
            }
        },
        iK = "is-animating",
        iZ = "is-open",
        st = "data-slider-thumb",
        se = {};

    function si() {
        this.entries = []
    }

    function ss(t) {
        if ("object" != typeof t) throw TypeError(t + " is not an object.");
        if (0 === Object.keys(t).length && t.constructor === Object) throw Error(t + " is empty.")
    }
    eH("look", [{
        onLoad() {
            se[this.id] = new class {
                init() {
                    this.slider && this.slides.length && this.thumbs.length && (this.popupContainer.addEventListener("transitionend", t => {
                        t.target == this.popupContainer && (this.popupContainer.classList.remove(iK), t.target.classList.contains(iZ) ? this.popupOpenCallback() : this.popupCloseCallback())
                    }), this.popupContainer.addEventListener("transitionstart", t => {
                        t.target == this.popupContainer && this.popupContainer.classList.add(iK)
                    }), this.popupClose.forEach(t => {
                        t.addEventListener("click", () => {
                            this.popupContainer.classList.remove(iZ), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                                bubbles: !0
                            }))
                        })
                    }), this.thumbs.forEach((t, e) => {
                      
                        t.addEventListener("click", i => {
                            i.preventDefault();
                            let s = t.hasAttribute(st) && "" !== t.getAttribute(st) ? parseInt(t.getAttribute(st)) : e,
                                r = this.slides[s];
                            if (b()) {
                                let o = parseInt(window.getComputedStyle(this.slider).paddingLeft);
                                this.slider.scrollTo({
                                    top: 0,
                                    left: r.offsetLeft - o,
                                    behavior: "auto"
                                }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                                    bubbles: !0
                                })), this.popupContainer.classList.add(iK, iZ)
                            } else {
                                let {
                                    stickyHeaderHeight: n
                                } = h(), a = r.getBoundingClientRect().top, l = r.offsetHeight / 2, c = window.innerHeight, d = this.container.querySelector("[data-slider-container]"), u = a + l - c / 2 + window.scrollY;
                                if (d) {
                                    let p = d.getBoundingClientRect().top + window.scrollY,
                                        m = p + d.offsetHeight;
                                    u < p ? u = p - n : u + c > m && (u = m - c)
                                }
                                window.scrollTo({
                                    top: u,
                                    left: 0,
                                    behavior: "smooth"
                                })
                            }
                        })
                    }))
                }
                popupCloseByEvent() {
                    this.popupContainer.classList.remove(iZ)
                }
                popupOpenCallback() {
                    document.addEventListener("theme:quick-add:open", this.popupCloseByEvent, {
                        once: !0
                    }), document.addEventListener("theme:product:added", this.popupCloseByEvent, {
                        once: !0
                    })
                }
                popupCloseCallback() {
                    document.removeEventListener("theme:quick-add:open", this.popupCloseByEvent, {
                        once: !0
                    }), document.removeEventListener("theme:product:added", this.popupCloseByEvent, {
                        once: !0
                    })
                }
                constructor(t) {
                    this.container = t.container, this.slider = this.container.querySelector("[data-slider-mobile]"), this.slides = this.container.querySelectorAll("[data-slide]"), this.thumbs = this.container.querySelectorAll("[data-slider-thumb]"), this.popupContainer = this.container.querySelector("[data-popup-container]"), this.popupClose = this.container.querySelectorAll("[data-popup-close]"), this.popupCloseByEvent = this.popupCloseByEvent.bind(this), this.init()
                }
            }(this)
        }
    }, iQ, ]), si.prototype.add = function(t, e, i) {
        this.entries.push({
            element: t,
            event: e,
            fn: i
        }), t.addEventListener(e, i)
    }, si.prototype.removeAll = function() {
        this.entries = this.entries.filter(function(t) {
            return t.element.removeEventListener(t.event, t.fn), !1
        })
    };
    var sr = '[name="selling_plan"]';
    let so = "data-scrollbar-slide-fullwidth",
        sn = "is-hidden",
        sa = class {
            init() {
                this.arrowNext && this.arrowPrev && (this.toggleNextArrow(), this.events())
            }
            listen() {
                document.addEventListener("theme:modal:open", () => {
                    this.toggleNextArrow()
                }), document.addEventListener("theme:resize", () => {
                    this.toggleNextArrow()
                })
            }
            events() {
                this.arrowNext.addEventListener("click", t => {
                    t.preventDefault(), this.goToNext()
                }), this.arrowPrev.addEventListener("click", t => {
                    t.preventDefault(), this.goToPrev()
                }), this.scrollbar.addEventListener("scroll", () => {
                    this.togglePrevArrow(), this.toggleNextArrow()
                })
            }
            goToNext() {
                let t = (this.scrollbar.hasAttribute(so) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2) + this.scrollbar.scrollLeft;
                this.move(t), this.arrowPrev.classList.remove(sn), this.toggleNextArrow()
            }
            goToPrev() {
                let t = this.scrollbar.hasAttribute(so) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2,
                    e = this.scrollbar.scrollLeft - t;
                this.move(e), this.arrowNext.classList.remove(sn), this.togglePrevArrow()
            }
            toggleNextArrow() {
                setTimeout(() => {
                    this.arrowNext.classList.toggle(sn, Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >= this.scrollbar.scrollWidth)
                }, 200)
            }
            togglePrevArrow() {
                setTimeout(() => {
                    this.arrowPrev.classList.toggle(sn, this.scrollbar.scrollLeft <= 0)
                }, 200)
            }
            scrollToVisibleElement() {
                [].forEach.call(this.scrollbar.children, t => {
                    t.addEventListener("click", e => {
                        e.preventDefault(), this.move(t.offsetLeft - t.clientWidth)
                    })
                })
            }
            move(t) {
                this.scrollbar.scrollTo({
                    top: 0,
                    left: t,
                    behavior: "smooth"
                })
            }
            constructor(t) {
                this.scrollbar = t, this.arrowNext = this.scrollbar.parentNode.querySelector("[data-scrollbar-arrow-next]"), this.arrowPrev = this.scrollbar.parentNode.querySelector("[data-scrollbar-arrow-prev]"), this.scrollbar.hasAttribute("data-scrollbar") && (this.init(), this.listen()), this.scrollbar.hasAttribute("data-scrollbar-slider") && this.scrollToVisibleElement()
            }
        },
        sl = "[data-swatch-button]",
        sh = "[data-swatch-link]",
        sc = "is-visible",
        sd = "no-events",
        su = "data-swatch-count",
        sp = "data-tooltip",
        sm = "data-variant-title",
        sg = "data-swatch-values",
        sv = class extends HTMLElement {
            connectedCallback() {
                this.hasAttribute(sp) && new eW(this)
            }
            constructor() {
                super()
            }
        },
        sf = class extends HTMLElement {
            connectedCallback() {
                this.handle = this.getAttribute("data-swatch-handle"), this.productItem = this.closest("[data-grid-item]"), this.productInfo = this.closest("[data-product-information]"), this.productImage = this.productItem.querySelector("[data-product-image]"), this.template = document.querySelector("[data-swatch-template]").innerHTML, this.swatchesJSON = this.getSwatchesJSON();
                let t = this.getAttribute("data-swatch-label").trim().toLowerCase();
                (function(t) {
                    let e = `${window.theme.routes.root}products/${t}.js`;
                    return window.fetch(e).then(t => t.json()).catch(t => {
                        console.error(t)
                    })
                })(this.handle).then(e => {
                    this.product = e, this.colorOption = e.options.find(function(e) {
                        return e.name.toLowerCase() === t || null
                    }), this.colorOption && (this.swatches = this.colorOption.values, this.init())
                })
            }
            init() {
                this.innerHTML = "", this.count = 0, this.swatches.forEach(t => {
                    var e, i;
                    let s = null,
                        r = !1,
                        o = "";
                    for (let n of this.product.variants) {
                        let a = n.options.includes(t);
                        if (!s && a && (s = n), a && n.featured_media) {
                            o = n.featured_media.preview_image.src, s = n;
                            break
                        }
                    }
                    for (let l of this.product.variants)
                        if (l.options.includes(t) && l.available) {
                            r = !0;
                            break
                        } if (s) {
                        let h = document.createElement("div");
                        h.innerHTML = this.template;
                        let c = h.querySelector(sl),
                            d = h.querySelector(sh),
                            u = h.querySelector("[data-swatch-text]"),
                            p = this.swatchesJSON[t],
                            m = s.title.replaceAll('"', "'");
                        c.style = `--animation-delay: ${100*this.count/1e3}s`, c.classList.add(`swatch-${p}`), c.dataset.tooltip = t, c.dataset.swatchVariant = s.id, c.dataset.swatchVariantName = m, c.dataset.swatchImage = o, c.dataset.variant = s.id, c.style.setProperty("--swatch", `var(--${p})`), d.href = (e = this.product.url, i = s.id, /variant=/.test(e) ? e.replace(/(variant=)[^&]+/, "$1" + i) : /\?/.test(e) ? e.concat("&variant=").concat(i) : e.concat("?variant=").concat(i)), d.dataset.swatch = t, d.disabled = !r, u.innerText = t, this.innerHTML += h.innerHTML, this.count++
                    }
                }), this.swatchCount = this.productInfo.querySelector(`[${su}]`), this.swatchElements = this.querySelectorAll(sh), this.swatchForm = this.productInfo.querySelector("[data-grid-swatch-form]"), this.hideSwatchesTimer = 0, this.swatchCount.hasAttribute(su) && (this.swatchCount.innerText = `${this.count} ${this.count>1?theme.strings.otherColor:theme.strings.oneColor}`, this.swatchCount.addEventListener("mouseenter", () => {
                    this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer), this.productInfo.classList.add(sd), this.swatchForm.classList.add(sc)
                }), this.productInfo.addEventListener("mouseleave", () => {
                    this.hideSwatchesTimer = setTimeout(() => {
                        this.productInfo.classList.remove(sd), this.swatchForm.classList.remove(sc)
                    }, 100)
                })), this.hasAttribute("data-scrollbar") && new sa(this), this.showDeferredImage(), this.bindSwatchButtonEvents()
            }
            showDeferredImage() {
                let t = this.productItem.querySelectorAll(`[${sm}]`);
                t.length && this.productItem.addEventListener("mouseenter", () => {
                    t.forEach(t => {
                        t.classList.remove("hidden")
                    })
                }, {
                    once: !0
                })
            }
            bindSwatchButtonEvents() {
                var t;
                null === (t = this.querySelectorAll(sl)) || void 0 === t || t.forEach(t => {
                    t.addEventListener("mouseenter", this.showVariantImageEvent), t.hasAttribute(sp) && new eW(t)
                }), this.productItem.addEventListener("mouseleave", this.productItemMouseLeaveEvent)
            }
            showVariantImage(t) {
                var e;
                let i = null === (e = t.target.getAttribute("data-swatch-variant-name")) || void 0 === e ? void 0 : e.replaceAll('"', "'"),
                    s = this.productImage.querySelectorAll(`[${sm}]`),
                    r = this.productImage.querySelector(`[${sm}="${i}"]`);
                null == s || s.forEach(t => {
                    t.classList.remove(sc)
                }), null == r || r.classList.add(sc)
            }
            hideVariantImages() {
                var t;
                null === (t = this.productImage.querySelectorAll(`[${sm}].${sc}`)) || void 0 === t || t.forEach(t => {
                    t.classList.remove(sc)
                })
            }
            getSwatchesJSON() {
                if (!this.hasAttribute(sg)) return {};
                let t = this.getAttribute(sg).split(","),
                    e = {};
                return null == t || t.forEach(t => {
                    let [i, s] = t.split(":");
                    e[i.trim()] = s.trim()
                }), e
            }
            constructor() {
                super(), this.productItemMouseLeaveEvent = () => this.hideVariantImages(), this.showVariantImageEvent = t => this.showVariantImage(t)
            }
        },
        sy = {
            productCutline: "[data-product-cutline]",
            productLink: "[data-product-link]",
            productGridItem: "[data-grid-item]",
            productInfo: "[data-product-information]",
            productImage: "[data-product-image-default]",
            productImageSibling: "[data-product-image-sibling]",
            productPrice: "[data-product-price]",
            siblingsInnerHolder: "[data-sibling-inner]",
            siblingCount: "[data-sibling-count]",
            siblingFieldset: "[data-sibling-fieldset]",
            siblingLink: "[data-sibling-link]",
            tooltip: "[data-tooltip]"
        },
        sb = "is-visible",
        sS = "is-fade",
        sL = "no-events",
        sE = "data-sibling-cutline",
        sw = "data-sibling-image",
        sk = "data-sibling-link",
        s$ = "data-sibling-price",
        sA = "data-product-link",
        sC = class extends HTMLElement {
            connectedCallback() {
                this.product = this.closest(sy.productGridItem), this.siblingScrollbar = this.querySelector(sy.siblingsInnerHolder), this.siblingCount = this.querySelector(sy.siblingCount), this.siblingFieldset = this.querySelector(sy.siblingFieldset), this.siblingLinks = this.querySelectorAll(sy.siblingLink), this.productInfo = this.closest(sy.productInfo), this.productLink = this.closest(sy.link), this.hideSwatchesTimer = 0, this.initScrollbar(), this.siblingCount && this.siblingFieldset && this.productInfo && (this.siblingCount.addEventListener("mouseenter", () => this.showSiblings()), this.productInfo.addEventListener("mouseleave", () => this.hideSiblings())), this.siblingLinks.length && new class {
                    init() {
                        this.cacheDefaultValues(), this.product.addEventListener("mouseleave", () => this.resetProductValues()), this.swatches.forEach(t => {
                            t.addEventListener("mouseenter", t => this.showSibling(t))
                        }), this.productLinks.length && this.swatches.forEach(t => {
                            t.addEventListener("click", () => {
                                this.productLinks[0].click()
                            })
                        })
                    }
                    cacheDefaultValues() {
                        this.productLinkValue = this.productLinks[0].hasAttribute(sA) ? this.productLinks[0].getAttribute(sA) : "", this.productPriceValue = this.productPrice.innerHTML, this.productCutline && (this.productCutlineValue = this.productCutline.innerHTML)
                    }
                    resetProductValues() {
                        this.product.classList.remove("is-active"), this.productLinkValue && this.productLinks.forEach(t => {
                            t.href = this.productLinkValue
                        }), this.productPrice && (this.productPrice.innerHTML = this.productPriceValue), this.productCutline && this.productCutline && (this.productCutline.innerHTML = this.productCutlineValue, this.productCutline.title = this.productCutlineValue), this.hideSiblingImage()
                    }
                    showSibling(t) {
                        let e = t.target,
                            i = e.hasAttribute(sk) ? e.getAttribute(sk) : "",
                            s = e.hasAttribute(s$) ? e.getAttribute(s$) : "",
                            r = e.hasAttribute(sE) ? e.getAttribute(sE) : "",
                            o = e.hasAttribute(sw) ? e.getAttribute(sw) : "";
                        i && this.productLinks.forEach(t => {
                            t.href = i
                        }), s && (this.productPrice.innerHTML = s), r ? (this.productCutline.innerHTML = r, this.productCutline.title = r) : (this.productCutline.innerHTML = "", this.productCutline.title = ""), o && this.showSiblingImage(o)
                    }
                    showSiblingImage(t) {
                        if (!this.productImageSibling) return;
                        let e = window.devicePixelRatio || 1,
                            i = this.productImage.offsetWidth * e,
                            s = n.getSizedImageUrl(t, `${180*Math.ceil(i/180)}x`),
                            r = this.productImageSibling.querySelector(`[src="${s}"]`),
                            o = () => {
                                this.productImageSibling.classList.add(sb), this.productImageSibling.querySelector(`[src="${s}"]`).classList.add(sS)
                            },
                            a = () => {
                                this.productImageSibling.querySelectorAll("img").forEach(t => {
                                    t.classList.remove(sS)
                                }), requestAnimationFrame(o)
                            };
                        if (r) a();
                        else {
                            let l = document.createElement("img");
                            l.src = s, this.productCutline && (l.alt = this.productCutline.innerText), l.addEventListener("load", () => {
                                this.productImageSibling.append(l), a()
                            })
                        }
                    }
                    hideSiblingImage() {
                        this.productImageSibling && (this.productImageSibling.classList.remove(sb), this.productImageSibling.querySelectorAll("img").forEach(t => {
                            t.classList.remove(sS)
                        }))
                    }
                    constructor(t, e) {
                        this.swatches = t, this.product = e, this.productLinks = this.product.querySelectorAll(sy.productLink), this.productCutline = this.product.querySelector(sy.productCutline), this.productPrice = this.product.querySelector(sy.productPrice), this.productImage = this.product.querySelector(sy.productImage), this.productImageSibling = this.product.querySelector(sy.productImageSibling), this.init()
                    }
                }(this.siblingLinks, this.product), this.querySelectorAll(sy.tooltip).forEach(t => {
                    new eW(t)
                })
            }
            showSiblings() {
                this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer), this.productLink && this.productLink.classList.add(sL), this.siblingFieldset.classList.add(sb)
            }
            hideSiblings() {
                this.hideSwatchesTimer = setTimeout(() => {
                    this.productLink && this.productLink.classList.remove(sL), this.siblingFieldset.classList.remove(sb)
                }, 100)
            }
            initScrollbar() {
                this.siblingScrollbar && new sa(this.siblingScrollbar)
            }
            constructor() {
                super()
            }
        },
        sT = "data-tab",
        sq = "data-tab-index",
        sx = "[data-tab]",
        s_ = ".tab-content",
        sP = "current",
        sM = "hidden",
        sH = "aos-animate",
        sB = "aos-no-transition",
        sI = {},
        sD = {
            onLoad() {
                sI[this.id] = [], this.container.querySelectorAll("[data-tabs-holder]").forEach(t => {
                    sI[this.id].push(new class {
                        init() {
                            let t = this.container.querySelectorAll(sx);
                            this.container.addEventListener("theme:tab:check", () => this.checkRecentTab()), this.container.addEventListener("theme:tab:hide", () => this.hideRelatedTab()), t.length && t.forEach(t => {
                                let e = parseInt(t.getAttribute(sT)),
                                    i = this.container.querySelector(`${s_}-${e}`);
                                t.addEventListener("click", () => {
                                    this.tabChange(t, i)
                                }), t.addEventListener("keyup", e => {
                                    ("Space" === e.code || "Enter" === e.code) && this.body.classList.contains("is-focused") && this.tabChange(t, i)
                                })
                            })
                        }
                        tabChange(t, e) {
                            if (t.classList.contains(sP)) return;
                            let i = this.container.querySelector(`${sx}.${sP}`),
                                s = this.container.querySelector(`${s_}.${sP}`);
                            null == i || i.classList.remove(sP), null == s || s.classList.remove(sP), t.classList.add(sP), e.classList.add(sP), t.classList.contains(sM) && e.classList.add(sM), this.accessibility.a11y.removeTrapFocus(), this.container.dispatchEvent(new CustomEvent("theme:tab:change", {
                                bubbles: !0
                            })), t.dispatchEvent(new CustomEvent("theme:form:sticky", {
                                bubbles: !0,
                                detail: {
                                    element: "tab"
                                }
                            })), this.animateItems(e)
                        }
                        animateItems(t, e = !0) {
                            let i = t.querySelectorAll("[data-aos]");
                            i.length && i.forEach(t => {
                                t.classList.remove(sH), e && (t.classList.add(sB), requestAnimationFrame(() => {
                                    t.classList.remove(sB), t.classList.add(sH)
                                }))
                            })
                        }
                        initNativeScrollbar() {
                            this.scrollbarHolder.length && this.scrollbarHolder.forEach(t => {
                                new sa(t)
                            })
                        }
                        checkRecentTab() {
                            let t = this.container.querySelector(".tab-link__recent");
                            if (t) {
                                t.classList.remove(sM);
                                let e = parseInt(t.getAttribute(sT)),
                                    i = this.container.querySelector(`${s_}[${sq}="${e}"]`);
                                i && (i.classList.remove(sM), this.animateItems(i, !1)), this.initNativeScrollbar()
                            }
                        }
                        hideRelatedTab() {
                            let t = this.container.querySelector("[data-related-section]");
                            if (!t) return;
                            let e = t.closest(`${s_}.${sP}`);
                            if (!e) return;
                            let i = parseInt(e.getAttribute(sq)),
                                s = this.container.querySelectorAll(sx);
                            if (s.length > i) {
                                let r = s[i].nextSibling;
                                r && (s[i].classList.add(sM), r.dispatchEvent(new Event("click")), this.initNativeScrollbar())
                            }
                        }
                        onBlockSelect(t) {
                            let e = this.container.querySelector(`.tab-link[data-block-id="${t.detail.blockId}"]`);
                            e && (e.dispatchEvent(new Event("click")), e.parentNode.scrollTo({
                                top: 0,
                                left: e.offsetLeft - e.clientWidth,
                                behavior: "smooth"
                            }))
                        }
                        constructor(t) {
                            this.container = t, this.body = document.querySelector("body"), this.accessibility = window.accessibility, this.container && (this.scrollbarHolder = this.container.querySelectorAll("[data-scrollbar]"), this.init(), this.initNativeScrollbar())
                        }
                    }(t))
                })
            },
            onBlockSelect(t) {
                sI[this.id].forEach(e => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
                })
            }
        };

    function sO() {
        let t = Boolean(document.querySelectorAll("dialog[open][data-scroll-lock-required]").length),
            e = Boolean(document.querySelectorAll(".drawer.is-open").length);
        return t || e
    }
    let s8 = {
            added: "is-added",
            animated: "is-animated",
            disabled: "is-disabled",
            error: "has-error",
            loading: "is-loading",
            open: "is-open",
            overlayText: "product-item--overlay-text",
            visible: "is-visible",
            siblingLinkCurrent: "sibling__link--current"
        },
        s9 = "[data-animation]",
        sF = "[data-add-to-cart]",
        sR = "cart-drawer",
        sN = "[data-quick-add-modal]",
        sz = "closing",
        sW = "data-product-id",
        sU = class extends HTMLElement {
            connectedCallback() {
                this.modalButton && this.modalButton.addEventListener("click", this.modalButtonClickEvent), this.buttonATC && this.cart && this.buttonATC.addEventListener("click", t => {
                    t.preventDefault(), window.accessibility.lastElement = this.buttonATC, document.dispatchEvent(new CustomEvent("theme:cart:add", {
                        detail: {
                            button: this.buttonATC
                        }
                    }))
                }), this.quickAddHolder && (this.quickAddHolder.addEventListener("animationend", this.quickAddLoadingToggle), this.errorHandler())
            }
            modalButtonClickEvent(t) {
                t.preventDefault();
                let e = this.modalButton.hasAttribute("data-sibling-swapper"),
                    i = this.modalButton.classList.contains(s8.siblingLinkCurrent);
                i || (this.modalButton.classList.add(s8.loading), this.modalButton.disabled = !0, e && !i && (this.currentModal = t.target.closest(sN), this.currentModal.classList.add(s8.loading)), this.renderModal())
            }
            modalCreate(t) {
                let e = document.querySelector(`${sN}[${sW}="${this.productId}"]`);
                if (e) this.modal = e, this.modalOpen();
                else {
                    let i = this.quickAddHolder.querySelector("[data-quick-add-modal-template]");
                    if (!i) return;
                    let s = document.createElement("div");
                    s.innerHTML = i.innerHTML, document.body.appendChild(s.querySelector(sN)), i.remove(), this.modal = document.querySelector(`${sN}[${sW}="${this.productId}"]`), this.modal.querySelector("[data-product-upsell-ajax]").innerHTML = new DOMParser().parseFromString(t, "text/html").querySelector("[data-api-content]").innerHTML, this.modalCreatedCallback()
                }
            }
            modalOpen() {
                this.currentModal && this.currentModal.dispatchEvent(new CustomEvent("theme:modal:close", {
                    bubbles: !1
                })), "function" == typeof this.modal.show && this.modal.show(), this.modal.setAttribute("open", !0), this.modal.removeAttribute("inert"), this.quickAddHolder.classList.add(s8.disabled), this.modalButton && (this.modalButton.classList.remove(s8.loading), this.modalButton.disabled = !1, window.accessibility.lastElement = this.modalButton), requestAnimationFrame(() => {
                    this.modal.querySelectorAll(s9).forEach(t => {
                        t.classList.add(s8.animated)
                    })
                }), document.dispatchEvent(new CustomEvent("theme:quick-add:open", {
                    bubbles: !0
                })), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                    bubbles: !0
                })), document.addEventListener("theme:product:added", this.modalCloseOnProductAdded, {
                    once: !0
                })
            }
            modalClose() {
                if (!this.isAnimating) {
                    if (!this.modal.hasAttribute(sz)) return this.modal.setAttribute(sz, ""), void(this.isAnimating = !0);
                    "function" == typeof this.modal.close ? this.modal.close() : this.modal.removeAttribute("open"), this.modal.removeAttribute(sz), this.modal.setAttribute("inert", ""), this.modal.classList.remove(s8.loading), this.modalButton && (this.modalButton.disabled = !1), this.quickAddHolder && this.quickAddHolder.classList.contains(s8.disabled) && this.quickAddHolder.classList.remove(s8.disabled), this.resetAnimatedItems(), sO() || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    })), document.removeEventListener("theme:product:added", this.modalCloseOnProductAdded), this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()
                }
            }
            modalEvents() {
                var t;
                null === (t = this.modal.querySelector("[data-quick-add-modal-close]")) || void 0 === t || t.addEventListener("click", t => {
                    t.preventDefault(), this.modalClose()
                }), this.modal.addEventListener("click", t => {
                    "DIALOG" === t.target.nodeName && "click" === t.type && this.modalClose()
                }), this.modal.addEventListener("keydown", t => {
                    "Escape" == t.code && (t.preventDefault(), this.modalClose())
                }), this.modal.addEventListener("theme:modal:close", () => {
                    this.modalClose()
                }), this.modal.addEventListener("animationend", t => {
                    t.target === this.modal && (this.isAnimating = !1, this.modal.hasAttribute(sz) ? this.modalClose() : setTimeout(() => {
                        this.a11y.trapFocus(this.modal);
                        let t = this.modal.querySelector("[autofocus]") || this.modal.querySelector('button, [href], select, textarea, [tabindex]:not([tabindex="-1"])');
                        null == t || t.focus()
                    }, 50))
                })
            }
            modalCloseOnProductAdded() {
                this.resetQuickAddButtons(), this.modal && this.modal.hasAttribute("open") && this.modalClose()
            }
            quickAddLoadingToggle(t) {
                t.target == this.quickAddHolder && this.quickAddHolder.classList.remove(s8.disabled)
            }
            errorHandler() {
                this.quickAddHolder.addEventListener("theme:cart:error", t => {
                    let e = t.detail.holder,
                        i = e.closest("[data-grid-item]");
                    if (!i) return;
                    let s = e.querySelector("[data-message-error]"),
                        r = i.classList.contains(s8.overlayText),
                        o = i.querySelector("[data-product-information]"),
                        n = e.querySelector(sF);
                    n && (n.classList.remove(s8.added, s8.loading), e.classList.add(s8.error)), s && (s.innerText = t.detail.description), r && o.classList.add(s8.hidden), setTimeout(() => {
                        this.resetQuickAddButtons(), r && o.classList.remove(s8.hidden)
                    }, 3e3)
                })
            }
            resetQuickAddButtons() {
                this.quickAddHolder && this.quickAddHolder.classList.remove(s8.visible, s8.error), this.buttonQuickAdd && (this.buttonQuickAdd.classList.remove(s8.added), this.buttonQuickAdd.disabled = !1)
            }
            renderModal() {
                this.modal ? this.modalOpen() : window.fetch(`${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`).then(this.upsellErrorsHandler).then(t => t.text()).then(t => {
                    this.modalCreate(t)
                })
            }
            modalCreatedCallback() {
                this.modalEvents(), this.modalOpen(), x(this.modal)
            }
            upsellErrorsHandler(t) {
                return t.ok ? t : t.json().then(function(e) {
                    throw new tM({
                        status: t.statusText,
                        headers: t.headers,
                        json: e
                    })
                })
            }
            resetAnimatedItems() {
                var t;
                null === (t = this.modal) || void 0 === t || t.querySelectorAll(s9).forEach(t => {
                    t.classList.remove(s8.animated)
                })
            }
            constructor() {
                var t;
                super(), this.container = this, this.cart = document.querySelector(sR) || document.querySelector("[data-cart-page]"), this.quickAddHolder = this.container.querySelector("[data-quick-add-holder]"), this.quickAddHolder && (this.modal = null, this.currentModal = null, this.productId = this.quickAddHolder.getAttribute("data-quick-add-holder"), this.modalButton = this.quickAddHolder.querySelector("[data-quick-add-modal-handle]"), this.handle = null === (t = this.modalButton) || void 0 === t ? void 0 : t.getAttribute("data-quick-add-modal-handle"), this.cartDrawer = document.querySelector(sR), this.buttonQuickAdd = this.quickAddHolder.querySelector("[data-quick-add-btn]"), this.buttonATC = this.quickAddHolder.querySelector(sF), this.button = this.modalButton || this.buttonATC, this.modalClose = this.modalClose.bind(this), this.modalCloseOnProductAdded = this.modalCloseOnProductAdded.bind(this), this.a11y = F, this.isAnimating = !1, this.modalButtonClickEvent = this.modalButtonClickEvent.bind(this), this.quickAddLoadingToggle = this.quickAddLoadingToggle.bind(this))
            }
        };
    eH("product-grid", [sD]), customElements.get("quick-add-product") || customElements.define("quick-add-product", sU), customElements.get("radio-swatch") || customElements.define("radio-swatch", sv), customElements.get("grid-swatch") || customElements.define("grid-swatch", sf), customElements.get("product-siblings") || customElements.define("product-siblings", sC);
    let s0 = "complementary-products",
        sV = "data-url",
        sj = class extends HTMLElement {
            connectedCallback() {
                new IntersectionObserver(((t, e) => {
                    t[0].isIntersecting && (e.unobserve(this), this.hasAttribute(sV) && "" !== this.getAttribute(sV) && fetch(this.getAttribute(sV)).then(t => t.text()).then(t => {
                        let e = document.createElement("div");
                        e.innerHTML = t;
                        let i = e.querySelector(s0);
                        i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML), e.querySelector(`${s0} quick-add-product`) && this.classList.add("is-loaded")
                    }).catch(t => {
                        console.error(t)
                    }))
                }).bind(this), {
                    rootMargin: "0px 0px 400px 0px"
                }).observe(this)
            }
            constructor() {
                super()
            }
        },
        s1 = class extends HTMLElement {
            connectedCallback() {
                this.fieldCheckbox && (this.fieldCheckbox.addEventListener("change", this.onChangeEvent), this.form && this.form.addEventListener("theme:product:add", () => {
                    this.fieldCheckbox.checked = !1, this.fieldCheckbox.dispatchEvent(new Event("change"))
                }))
            }
            clearInputValues() {
                this.fields.length && this.fields.forEach(t => {
                    t.value = ""
                })
            }
            onChange(t) {
                this.fieldEmail.required = Boolean(t.target.checked), t.target.checked || this.clearInputValues()
            }
            disconnectedCallback() {
                this.fieldCheckbox.removeEventListener("change", this.onChangeEvent)
            }
            constructor() {
                super(), this.fieldCheckbox = this.querySelector('input[type="checkbox"]'), this.fieldEmail = this.querySelector('input[type="email"]'), this.fields = this.querySelectorAll('input:not([type="checkbox"]):not([type="hidden"]), textarea'), this.form = this.closest("[data-form-wrapper]"), this.onChangeEvent = t => this.onChange(t)
            }
        },
        s3 = "[data-form-wrapper]",
        sX = "is-sticky";
    window.theme.variables = {
        productPageSticky: !1
    };
    let s2 = {},
        s4 = "data-section-type",
        sG = "is-visible",
        sY = class extends HTMLElement {
            init() {
                navigator.share ? this.shareButton.addEventListener("click", () => {
                    navigator.share({
                        url: this.urlToShare,
                        title: document.title
                    })
                }) : this.shareButton.addEventListener("click", this.copyToClipboard.bind(this))
            }
            updateShareLink() {
                "product" == this.container.getAttribute(s4) && this.container.addEventListener("theme:variant:change", t => {
                    t.detail.variant && (this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${t.detail.variant.id}`)
                })
            }
            copyToClipboard() {
                navigator.clipboard.writeText(this.urlToShare).then(() => {
                    this.shareMessage.classList.add(sG);
                    let t = () => {
                        this.shareMessage.classList.remove(sG), this.shareMessage.removeEventListener("animationend", t)
                    };
                    this.shareMessage.addEventListener("animationend", t)
                })
            }
            constructor() {
                super(), this.container = this.closest(`[${s4}]`), this.shareButton = this.querySelector("[data-share-button]"), this.shareMessage = this.querySelector("[data-share-message]"), this.urlToShare = this.shareButton.dataset.shareUrl ? this.shareButton.dataset.shareUrl : document.location.href, this.init(), this.updateShareLink()
            }
        },
        s5 = "[data-button-arrow]",
        sJ = "[data-image-id]",
        s6 = "slider__arrows",
        s7 = "is-dragging",
        sQ = "media--active",
        sK = "media--hidden",
        sZ = "media--hiding",
        rt = "data-button-prev",
        re = "data-button-next",
        ri = "data-media-id",
        rs = class extends HTMLElement {
            connectedCallback() {
                this.productMediaObserver(), this.toggleEvents(), this.listen(), this.setHeight()
            }
            disconnectedCallback() {
                this.unlisten()
            }
            listen() {
                document.addEventListener("theme:resize:width", this.toggleEvents), document.addEventListener("theme:resize:width", this.setHeight), this.addEventListener("theme:media:select", this.selectMediaEvent)
            }
            unlisten() {
                document.removeEventListener("theme:resize:width", this.toggleEvents), document.removeEventListener("theme:resize:width", this.setHeight), this.removeEventListener("theme:media:select", this.selectMediaEvent)
            }
            toggleEvents() {
                let t = b();
                t && this.hasAttribute("data-fader-mobile") || !t && this.hasAttribute("data-fader-desktop") ? this.bindEventListeners() : this.unbindEventListeners()
            }
            bindEventListeners() {
                this.initialized || (this.productMediaList.addEventListener("mousedown", this.handleMouseDown), this.productMediaList.addEventListener("mouseleave", this.handleMouseLeave), this.productMediaList.addEventListener("mouseup", this.handleMouseUp), this.productMediaList.addEventListener("mousemove", this.handleMouseMove), this.productMediaList.addEventListener("touchstart", this.handleMouseDown, {
                    passive: !0
                }), this.productMediaList.addEventListener("touchend", this.handleMouseUp, {
                    passive: !0
                }), this.productMediaList.addEventListener("touchmove", this.handleMouseMove, {
                    passive: !0
                }), this.productMediaList.addEventListener("keyup", this.handleKeyUp), this.initArrows(), this.resetScrollPosition(), this.initialized = !0)
            }
            unbindEventListeners() {
                this.initialized && (this.productMediaList.removeEventListener("mousedown", this.handleMouseDown), this.productMediaList.removeEventListener("mouseleave", this.handleMouseLeave), this.productMediaList.removeEventListener("mouseup", this.handleMouseUp), this.productMediaList.removeEventListener("mousemove", this.handleMouseMove), this.productMediaList.removeEventListener("touchstart", this.handleMouseDown), this.productMediaList.removeEventListener("touchend", this.handleMouseUp), this.productMediaList.removeEventListener("touchmove", this.handleMouseMove), this.productMediaList.removeEventListener("keyup", this.handleKeyUp), this.removeArrows(), this.initialized = !1)
            }
            handleMouseDown(t) {
                this.isDown = !0, this.startX = (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft, this.startY = (t.pageY || t.changedTouches[0].screenY) - this.offsetTop
            }
            handleMouseLeave() {
                this.isDown && (this.isDown = !1)
            }
            handleMouseUp(t) {
                let e = (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft,
                    i = (t.pageY || t.changedTouches[0].screenY) - this.offsetTop,
                    s = e - this.startX,
                    r = i - this.startY;
                Math.abs(s) > 10 && Math.abs(s) > Math.abs(r) && ((s > 0 ? 1 : -1) < 0 ? this.showNextImage() : this.showPreviousImage()), this.isDown = !1, requestAnimationFrame(() => {
                    this.classList.remove(s7)
                })
            }
            handleMouseMove() {
                this.isDown && this.classList.add(s7)
            }
            handleKeyUp(t) {
                "ArrowLeft" === t.code && this.showPreviousImage(), "ArrowRight" === t.code && this.showNextImage()
            }
            handleArrowsClickEvent() {
                var t;
                null === (t = this.querySelectorAll(s5)) || void 0 === t || t.forEach(t => {
                    t.addEventListener("click", t => {
                        t.preventDefault(), t.target.hasAttribute(rt) && this.showPreviousImage(), t.target.hasAttribute(re) && this.showNextImage()
                    })
                })
            }
            resetScrollPosition() {
                0 !== this.productMediaList.scrollLeft && (this.productMediaList.scrollLeft = 0)
            }
            initArrows() {
                if (!this.buttons.length) {
                    let t = document.createElement("div");
                    t.classList.add(s6), t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next, this.productMediaList.append(t), this.buttons = this.querySelectorAll(s5), this.buttonPrev = this.querySelector(`[${rt}]`), this.buttonNext = this.querySelector(`[${re}]`)
                }
                this.handleArrowsClickEvent(), this.preloadImageOnArrowHover()
            }
            removeArrows() {
                var t;
                null === (t = this.querySelector(`.${s6}`)) || void 0 === t || t.remove()
            }
            preloadImageOnArrowHover() {
                var t, e;
                null === (t = this.buttonPrev) || void 0 === t || t.addEventListener("mouseover", () => {
                    let t = this.getPreviousMediaId();
                    this.preloadImage(t)
                }), null === (e = this.buttonNext) || void 0 === e || e.addEventListener("mouseover", () => {
                    let t = this.getNextMediaId();
                    this.preloadImage(t)
                })
            }
            preloadImage(t) {
                var e;
                null === (e = this.querySelector(`[${ri}="${t}"] img`)) || void 0 === e || e.setAttribute("loading", "eager")
            }
            showMediaOnVariantSelect(t) {
                let e = t.detail.id;
                this.setActiveMedia(e)
            }
            getCurrentMedia() {
                return this.querySelector(`${sJ}.${sQ}`)
            }
            getNextMediaId() {
                let t = this.getCurrentMedia(),
                    e = (null == t ? void 0 : t.nextElementSibling.hasAttribute("data-image-id")) ? null == t ? void 0 : t.nextElementSibling : this.querySelector(sJ);
                return null == e ? void 0 : e.getAttribute(ri)
            }
            getPreviousMediaId() {
                let t = this.getCurrentMedia(),
                    e = this.productMediaItems.length - 1,
                    i = (null == t ? void 0 : t.previousElementSibling) || this.productMediaItems[e];
                return null == i ? void 0 : i.getAttribute(ri)
            }
            showNextImage() {
                let t = this.getNextMediaId();
                this.selectMedia(t)
            }
            showPreviousImage() {
                let t = this.getPreviousMediaId();
                this.selectMedia(t)
            }
            selectMedia(t) {
                this.dispatchEvent(new CustomEvent("theme:media:select", {
                    detail: {
                        id: t
                    }
                }))
            }
            setActiveMedia(t) {
                var e;
                if (!t) return;
                this.setAttribute("data-active-media", t);
                let i = this.querySelector(`${sJ}.${sQ}`),
                    s = this.querySelector(`[${ri}="${t}"]`),
                    r = null == s ? void 0 : s.querySelector("model-viewer, video, iframe, button, [href], input, [tabindex]"),
                    o = s.querySelector("deferred-media");
                null == i || i.classList.add(sZ), null == i || i.classList.remove(sQ), null == s || s.classList.remove(sZ, sK), null == s || s.classList.add(sQ), o && !0 !== o.getAttribute("loaded") && (null === (e = s.querySelector("[data-deferred-media-button]")) || void 0 === e || e.dispatchEvent(new Event("click", {
                    bubbles: !1
                }))), requestAnimationFrame(() => {
                    this.setHeight(), document.body.classList.contains("is-focused") && (null == r || r.focus())
                })
            }
            setHeight() {
                var t, e;
                let i = (null === (t = this.querySelector(`${sJ}.${sQ}`)) || void 0 === t ? void 0 : t.offsetHeight) || (null === (e = this.productMediaItems[0]) || void 0 === e ? void 0 : e.offsetHeight);
                this.style.setProperty("--height", `${i}px`)
            }
            productMediaObserver() {
                this.productMediaItems.forEach(t => {
                    t.addEventListener("transitionend", e => {
                        e.target == t && t.classList.contains(sZ) && (t.classList.remove(sZ), t.classList.add(sK))
                    }), t.addEventListener("transitioncancel", e => {
                        e.target == t && t.classList.contains(sZ) && (t.classList.remove(sZ), t.classList.add(sK))
                    })
                })
            }
            constructor() {
                super(), this.initialized = !1, this.buttons = !1, this.isDown = !1, this.startX = 0, this.startY = 0, this.scrollLeft = 0, this.onButtonArrowClick = t => this.buttonArrowClickEvent(t), this.container = this.closest("[data-section-type]"), this.handleMouseDown = this.handleMouseDown.bind(this), this.handleMouseLeave = this.handleMouseLeave.bind(this), this.handleMouseUp = this.handleMouseUp.bind(this), this.handleMouseMove = this.handleMouseMove.bind(this), this.handleKeyUp = this.handleKeyUp.bind(this), this.productMediaItems = this.querySelectorAll(sJ), this.productMediaList = this.querySelector("[data-product-media-list]"), this.setHeight = this.setHeight.bind(this), this.toggleEvents = this.toggleEvents.bind(this), this.selectMediaEvent = t => this.showMediaOnVariantSelect(t)
            }
        },
        rr = "data-option-position",
        ro = "sold-out",
        rn = "unavailable",
        ra = "sale",
        rl = "[data-add-to-cart]",
        rh = "[data-price-wrapper]",
        rc = "[data-product-unit]",
        rd = "data-group-toggle",
        ru = "[data-quick-add-modal]",
        rp = 'input[name="id"]',
        rm = "hidden",
        rg = "variant--soldout",
        rv = "variant--unavailable",
        rf = "product__price--sale",
        ry = "count-is-low",
        rb = "count-is-in",
        rS = "count-is-out",
        rL = "count-is-unavailable",
        rE = class extends HTMLElement {
            connectedCallback() {
                if (this.cartAddEvents(), this.container = this.closest("[data-section-type]") || this.closest(ru), !this.container) return;
                if (this.sectionId = this.container.dataset.sectionId, this.product = this.container.querySelector("[data-product]"), this.productForm = this.container.querySelector("[data-product-form]"), this.productImages = this.container.querySelector("product-images"), this.productMediaList = this.container.querySelector("[data-product-media-list]"), this.installmentForm = this.container.querySelector("[data-product-form-installment]"), this.sellout = null, this.priceOffWrap = this.container.querySelector("[data-price-off]"), this.priceOffAmount = this.container.querySelector("[data-price-off-amount]"), this.priceOffType = this.container.querySelector("[data-price-off-type]"), this.planDescription = this.container.querySelector("[data-plan-description]"), this.remainingWrapper = this.container.querySelector("[data-remaining-wrapper]"), this.remainingWrapper) {
                    let t = this.container.querySelector("[data-remaining-max]");
                    t && (this.remainingMaxInt = parseInt(t.getAttribute("data-remaining-max"), 10), this.remainingCount = this.container.querySelector("[data-remaining-count]"), this.remainingJSONWrapper = this.container.querySelector("[data-product-remaining-json]"), this.remainingJSON = null, this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML ? this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML) : console.warn("Missing product quantity JSON"))
                }
                this.enableHistoryState = "true" === this.container.getAttribute("data-enable-history-state"), this.hasUnitPricing = this.container.querySelector(rc), this.subSelectors = this.container.querySelector("[data-subscription-selectors]"), this.subPrices = this.container.querySelector("[data-subscription-watch-price]"), this.isPreOrder = this.container.querySelector("[data-product-preorder]");
                let e = null,
                    i = this.container.querySelector("[data-product-json]");
                i && (e = i.innerHTML), e ? (this.productJSON = JSON.parse(e), this.linkForm(), this.sellout = new class {
                    init() {
                        this.update()
                    }
                    update() {
                        this.getCurrentState(), this.optionElements.forEach(t => {
                            let e = t.closest(`[${rr}]`);
                            if (!e) return;
                            let i = t.value || t.getAttribute("data-value"),
                                s = e.getAttribute(rr),
                                r = parseInt(s, 10) - 1,
                                o = t.closest("[data-popout]"),
                                n = [...this.selections];
                            n[r] = i;
                            let a = this.productJSON.variants.find(t => {
                                let e = !0;
                                for (let i = 0; i < n.length; i++) t.options[i] !== n[i] && (e = !1);
                                return e
                            });
                            t.classList.remove(ro, rn), t.parentNode.classList.remove(ra), o && o.classList.remove(ro, rn, ra), void 0 === a ? (t.classList.add(rn), o && o.classList.add(rn)) : a && !1 === a.available && (t.classList.add(ro), o && o.classList.add(ro)), a && a.compare_at_price > a.price && theme.settings.variantOnSale && t.parentNode.classList.add(ra)
                        })
                    }
                    getCurrentState() {
                        this.selections = [];
                        let t = this.container.querySelectorAll('[name^="options"]:checked, [name^="options"][type="hidden"]');
                        t.length && t.forEach(t => {
                            let e = t.value;
                            e && "" !== e && this.selections.push(e)
                        })
                    }
                    constructor(t, e) {
                        this.container = t, this.productJSON = e, this.optionElements = this.container.querySelectorAll('[name^="options"], [data-popout-option]'), this.productJSON && this.optionElements.length && this.init()
                    }
                }(this.container, this.productJSON)) : console.error("Missing product JSON")
            }
            cartAddEvents() {
                this.buttonATC = this.querySelector(rl);
                let t = document.querySelector("cart-drawer") || document.querySelector("[data-cart-page]");
                this.buttonATC && t && this.buttonATC.addEventListener("click", t => {
                    t.preventDefault(), document.dispatchEvent(new CustomEvent("theme:cart:add", {
                        detail: {
                            button: this.buttonATC
                        },
                        bubbles: !1
                    })), this.closest(ru) || (window.accessibility.lastElement = this.buttonATC)
                })
            }
            destroy() {
                this.productForm.destroy()
            }
            linkForm() {
                this.productForm = new class {
                    destroy() {
                        this._listeners.removeAll()
                    }
                    options() {
                        return this._serializeInputValues(this.optionInputs, function(t) {
                            return t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2], t
                        })
                    }
                    variant() {
                        var t, e, i, s, r, o, n, a;
                        let l = this.options();
                        return l.length ? (t = this.product, e = l, ss(t), o = (i = t, s = e, ss(i), function(t) {
                            if (!Array.isArray(t)) throw TypeError(t + " is not an array.");
                            if (0 === t.length) throw Error(t + " is empty.");
                            if (!t[0].hasOwnProperty("name")) throw Error(t[0] + "does not contain name key.");
                            if ("string" != typeof t[0].name) throw TypeError("Invalid value type passed for name of option " + t[0].name + ". Value should be string.")
                        }(s), r = [], s.forEach(function(t) {
                            for (var e = 0; e < i.options.length; e++)
                                if ((i.options[e].name || i.options[e]).toLowerCase() === t.name.toLowerCase()) {
                                    r[e] = t.value;
                                    break
                                }
                        }), r), n = t, a = o, ss(n), function(t) {
                            if (Array.isArray(t) && "object" == typeof t[0]) throw Error(t + "is not a valid array of options.")
                        }(a), n.variants.filter(function(t) {
                            return a.every(function(e, i) {
                                return t.options[i] === e
                            })
                        })[0] || null) : this.product.variants[0]
                    }
                    plan(t) {
                        let e = {
                                allocation: null,
                                group: null,
                                detail: null
                            },
                            i = this.element.querySelector(`${sr}:checked`);
                        if (!i) return null;
                        let s = i.value,
                            r = s && "" !== s ? s : null;
                        return r && t && (e.allocation = t.selling_plan_allocations.find(function(t) {
                            return t.selling_plan_id.toString() === r.toString()
                        })), e.allocation && (e.group = this.product.selling_plan_groups.find(function(t) {
                            return t.id.toString() === e.allocation.selling_plan_group_id.toString()
                        })), e.group && (e.detail = e.group.selling_plans.find(function(t) {
                            return t.id.toString() === r.toString()
                        })), e && e.allocation && e.detail && e.allocation ? e : null
                    }
                    properties() {
                        return this._serializeInputValues(this.propertyInputs, function(t) {
                            return t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2], t
                        })
                    }
                    quantity() {
                        return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1
                    }
                    getFormState() {
                        let t = this.variant();
                        return {
                            options: this.options(),
                            variant: t,
                            properties: this.properties(),
                            quantity: this.quantity(),
                            plan: this.plan(t)
                        }
                    }
                    _setIdInputValue(t) {
                        t && t.id ? this.variantElement.value = t.id.toString() : this.variantElement.value = "", this.variantElement.dispatchEvent(new Event("change"))
                    }
                    _onSubmit(t, e) {
                        e.dataset = this.getFormState(), t.onFormSubmit && t.onFormSubmit(e)
                    }
                    _onOptionChange(t) {
                        this._setIdInputValue(t.dataset.variant)
                    }
                    _onFormEvent(t) {
                        return void 0 === t ? Function.prototype.bind() : (function(e) {
                            e.dataset = this.getFormState(), this._setIdInputValue(e.dataset.variant), t(e)
                        }).bind(this)
                    }
                    _initInputs(t, e) {
                        return Array.prototype.slice.call(this.element.querySelectorAll(t)).map((function(t) {
                            return this._listeners.add(t, "change", this._onFormEvent(e)), t
                        }).bind(this))
                    }
                    _serializeInputValues(t, e) {
                        return t.reduce(function(t, i) {
                            return (i.checked || "radio" !== i.type && "checkbox" !== i.type) && t.push(e({
                                name: i.name,
                                value: i.value
                            })), t
                        }, [])
                    }
                    _validateProductObject(t) {
                        if ("object" != typeof t) throw TypeError(t + " is not an object.");
                        if (void 0 === t.variants[0].options) throw TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                        return t
                    }
                    constructor(t, e, i) {
                        this.element = t, this.product = this._validateProductObject(e), this.variantElement = this.element.querySelector('[name="id"]'), i = i || {}, this._listeners = new si, this._listeners.add(this.element, "submit", this._onSubmit.bind(this, i)), this.optionInputs = this._initInputs('[name^="options"]', i.onOptionChange), this.planInputs = this._initInputs(sr, i.onPlanChange), this.quantityInputs = this._initInputs('[name="quantity"]', i.onQuantityChange), this.propertyInputs = this._initInputs('[name^="properties"]', i.onPropertyChange)
                    }
                }(this.container, this.productJSON, {
                    onOptionChange: this.onOptionChange.bind(this),
                    onPlanChange: this.onPlanChange.bind(this)
                }), this.pushState(this.productForm.getFormState(), !0), this.subsToggleListeners()
            }
            onOptionChange(t) {
                this.pushState(t.dataset), this.updateProductImage(t)
            }
            onPlanChange(t) {
                this.subPrices && this.pushState(t.dataset)
            }
            pushState(t, e = !1) {
                var i;
                this.productState = this.setProductState(t), this.updateAddToCartState(t), this.updateProductPrices(t), this.updateSaleText(t), this.updateSubscriptionText(t), this.updateRemaining(t), this.updateLegend(t), this.fireHookEvent(t), null === (i = this.sellout) || void 0 === i || i.update(t), this.enableHistoryState && !e && this.updateHistoryState(t)
            }
            updateAddToCartState(t) {
                let e = t.variant,
                    i = theme.strings.addToCart,
                    s = this.container.querySelectorAll(rh),
                    r = this.container.querySelectorAll(rl),
                    o = this.container.querySelectorAll("[data-add-to-cart-text]"),
                    n = this.container.querySelectorAll("[data-form-wrapper]");
                if (this.installmentForm && e) {
                    let a = this.installmentForm.querySelector(rp);
                    a.value = e.id, a.dispatchEvent(new Event("change", {
                        bubbles: !0
                    }))
                }
                this.isPreOrder && (i = theme.strings.preOrder), s.length && e && s.forEach(t => {
                    t.classList.remove(rm)
                }), r.length && r.forEach(t => {
                    t.hasAttribute("data-quick-add-btn") || (e && e.available ? t.disabled = !1 : t.disabled = !0)
                }), o.length && o.forEach(t => {
                    e ? e.available ? t.innerHTML = i : t.innerHTML = theme.strings.soldOut : t.innerHTML = theme.strings.unavailable
                }), n.length && n.forEach(t => {
                    if (e) {
                        e.available ? t.classList.remove(rg, rv) : (t.classList.add(rg), t.classList.remove(rv));
                        let i = t.querySelector("[data-product-select]");
                        i && (i.value = e.id);
                        let s = t.querySelector(`${rp}[form]`);
                        s && (s.value = e.id, s.dispatchEvent(new Event("change")))
                    } else t.classList.add(rv), t.classList.remove(rg)
                })
            }
            updateHistoryState(t) {
                let e = t.variant,
                    i = t.plan,
                    s = window.location.href;
                if (e && s.includes("/product")) {
                    let r = new window.URL(s),
                        o = r.searchParams;
                    o.set("variant", e.id), i && i.detail && i.detail.id && this.productState.hasPlan ? o.set("selling_plan", i.detail.id) : o.delete("selling_plan"), r.search = o.toString();
                    let n = r.toString();
                    window.history.replaceState({
                        path: n
                    }, "", n)
                }
            }
            updateRemaining(t) {
                var e;
                let i = t.variant;
                if (null === (e = this.remainingWrapper) || void 0 === e || e.classList.remove(rb, rS, rL, ry), i && this.remainingWrapper && this.remainingJSON) {
                    let s = this.remainingJSON[i.id];
                    ("out" === s || s < 1) && this.remainingWrapper.classList.add(rS), ("in" === s || s >= this.remainingMaxInt) && this.remainingWrapper.classList.add(rb), ("low" === s || s > 0 && s < this.remainingMaxInt) && (this.remainingWrapper.classList.add(ry), this.remainingCount && (this.remainingCount.innerHTML = s))
                } else !i && this.remainingWrapper && this.remainingWrapper.classList.add(rL)
            }
            getBaseUnit(t) {
                return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit
            }
            subsToggleListeners() {
                this.container.querySelectorAll("[data-toggles-group]").forEach(t => {
                    t.addEventListener("change", (function(t) {
                        let e = t.target.value.toString(),
                            i = this.container.querySelector(`[${rd}="${e}"]`),
                            s = this.container.querySelectorAll(`[${rd}]`);
                        if (i) {
                            i.classList.remove(rm);
                            let r = i.querySelector('[name="selling_plan"]');
                            r.checked = !0, r.dispatchEvent(new Event("change"))
                        }
                        s.forEach(t => {
                            t !== i && (t.classList.add(rm), t.querySelectorAll('[name="selling_plan"]').forEach(t => {
                                t.checked = !1, t.dispatchEvent(new Event("change"))
                            }))
                        })
                    }).bind(this))
                })
            }
            updateSaleText(t) {
                this.productState.planSale ? this.updateSaleTextSubscription(t) : this.productState.onSale ? this.updateSaleTextStandard(t) : this.priceOffWrap && this.priceOffWrap.classList.add(rm)
            }
            updateSaleTextStandard(t) {
                if (this.priceOffType && (this.priceOffType.innerHTML = window.theme.strings.sale || "sale"), this.priceOffAmount && this.priceOffWrap) {
                    let e = t.variant,
                        i = (e.compare_at_price - e.price) / e.compare_at_price;
                    this.priceOffAmount.innerHTML = `${Math.floor(100*i)}%`, this.priceOffWrap.classList.remove(rm)
                }
            }
            updateSubscriptionText(t) {
                t.plan && this.planDescription ? (this.planDescription.innerHTML = t.plan.detail.description, this.planDescription.classList.remove(rm)) : this.planDescription && this.planDescription.classList.add(rm)
            }
            updateSaleTextSubscription(t) {
                if (this.priceOffType && (this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton"), this.priceOffAmount && this.priceOffWrap) {
                    let e = t.plan.detail.price_adjustments[0],
                        s = e.value;
                    e && "percentage" === e.value_type ? this.priceOffAmount.innerHTML = `${s}%` : this.priceOffAmount.innerHTML = i.formatMoney(s, theme.moneyFormat), this.priceOffWrap.classList.remove(rm)
                }
            }
            updateProductPrices(t) {
                let e = t.variant,
                    s = t.plan;
                this.container.querySelectorAll(rh).forEach(t => {
                    let r = t.querySelector("[data-compare-price]"),
                        o = t.querySelector("[data-product-price]"),
                        n = t.querySelector("[data-compare-text]"),
                        a = "",
                        l = "";
                    this.productState.available && (a = e.compare_at_price, l = e.price), this.productState.hasPlan && (l = s.allocation.price), this.productState.planSale && (a = s.allocation.compare_at_price, l = s.allocation.price), r && (this.productState.onSale || this.productState.planSale ? (r.classList.remove(rm), n.classList.remove(rm), o.classList.add(rf)) : (r.classList.add(rm), n.classList.add(rm), o.classList.remove(rf)), r.innerHTML = i.formatMoney(a, theme.moneyFormat)), o.innerHTML = 0 === l ? window.theme.strings.free : i.formatMoney(l, theme.moneyFormat)
                }), this.hasUnitPricing && this.updateProductUnits(t)
            }
            updateProductUnits(t) {
                var e;
                let s = t.variant,
                    r = t.plan,
                    o = null;
                if (s && s.unit_price && (o = s.unit_price), r && r.allocation && r.allocation.unit_price && (o = r.allocation.unit_price), o) {
                    let n = this.getBaseUnit(s),
                        a = i.formatMoney(o, theme.moneyFormat);
                    this.container.querySelector("[data-product-unit-price]").innerHTML = a, this.container.querySelector("[data-product-base]").innerHTML = n, t_(this.container.querySelector(rc))
                } else(e = this.container.querySelector(rc)) && (e.style.display = "none")
            }
            fireHookEvent(t) {
                let e = t.variant;
                this.container.dispatchEvent(new CustomEvent("theme:variant:change", {
                    detail: {
                        variant: e
                    },
                    bubbles: !0
                }))
            }
            setProductState(t) {
                let e = t.variant,
                    i = t.plan,
                    s = {
                        available: !0,
                        soldOut: !1,
                        onSale: !1,
                        showUnitPrice: !1,
                        requiresPlan: !1,
                        hasPlan: !1,
                        planPerDelivery: !1,
                        planSale: !1
                    };
                return e && (!e.requires_selling_plan || i) ? (e.available || (s.soldOut = !0), e.compare_at_price > e.price && (s.onSale = !0), e.unit_price && (s.showUnitPrice = !0), this.product && this.product.requires_selling_plan && (s.requiresPlan = !0), i && this.subPrices && (s.hasPlan = !0, i.allocation.per_delivery_price !== i.allocation.price && (s.planPerDelivery = !0), e.price > i.allocation.price && (s.planSale = !0))) : s.available = !1, s
            }
            updateProductImage(t) {
                let e = t.dataset.variant;
                if (e && e.featured_media) {
                    let i = this.container.querySelector(`[data-image-id="${e.featured_media.id}"]`);
                    if (i) {
                        let s = i.getAttribute("data-media-id"),
                            r = y();
                        if (i.dispatchEvent(new CustomEvent("theme:media:select", {
                                bubbles: !0,
                                detail: {
                                    id: s
                                }
                            })), r && !this.productImages.hasAttribute("data-fader-desktop")) {
                            let o = i.getBoundingClientRect().top;
                            document.dispatchEvent(new CustomEvent("theme:tooltip:close", {
                                bubbles: !1,
                                detail: {
                                    hideTransition: !1
                                }
                            })), e6(o)
                        }
                        r || this.productImages.hasAttribute("data-fader-mobile") || this.productMediaList.scrollTo({
                            left: i.offsetLeft
                        })
                    }
                }
            }
            updateLegend(t) {
                let e = t.variant;
                if (e) {
                    let i = this.container.querySelectorAll("[data-option-value]");
                    i.length && i.forEach(t => {
                        let i = t.closest("[data-option-position]");
                        if (i) {
                            let s = i.getAttribute("data-option-position"),
                                r = parseInt(s, 10) - 1,
                                o = e.options[r];
                            t.innerHTML = o
                        }
                    })
                }
            }
            constructor() {
                super()
            }
        },
        rw = "[data-thumb-item]",
        rk = "data-active-media",
        r$ = "data-media-id",
        rA = "is-active";
    class rC extends HTMLElement {
        connectedCallback() {
            this.handleEvents(), this.preloadImagesOnHover(), this.activeMediaObserver()
        }
        disconnectedCallback() {
            this.observer && this.observer.disconnect()
        }
        activeMediaObserver() {
            this.observer = new MutationObserver(t => {
                for (let e of t) "attributes" === e.type && e.attributeName == rk && this.setActiveThumb()
            }), this.observer.observe(this.productImagesContainer, {
                attributes: !0,
                childList: !1,
                subtree: !1
            })
        }
        handleEvents() {
            this.thumbLinks.forEach(t => {
                t.addEventListener("click", e => {
                    e.preventDefault();
                    let i = t.closest(rw),
                        s = t.getAttribute(r$);
                    i.classList.contains(rA) || this.dispatchEvent(new CustomEvent("theme:media:select", {
                        bubbles: !0,
                        detail: {
                            id: s
                        }
                    }))
                }), t.addEventListener("keyup", e => {
                    if ("Enter" === e.code) {
                        var i;
                        let s = t.getAttribute(r$),
                            r = null === (i = this.productImagesContainer.querySelector(`[${r$}="${s}"]`)) || void 0 === i ? void 0 : i.querySelectorAll('model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])')[0];
                        r && (r.dispatchEvent(new Event("focus")), r.dispatchEvent(new Event("select")))
                    }
                })
            })
        }
        preloadImagesOnHover() {
            this.thumbLinks.forEach(t => {
                t.addEventListener("mouseover", () => {
                    let e = t.getAttribute(r$),
                        i = this.productImagesContainer.querySelector(`[${r$}="${e}"] img`);
                    null == i || i.setAttribute("loading", "eager")
                })
            })
        }
        setActiveThumb() {
            var t;
            let e = this.productImagesContainer.getAttribute(rk),
                i = this.querySelector(`[${r$}="${e}"]`);
            null === (t = this.querySelector(`${rw}.${rA}`)) || void 0 === t || t.classList.remove(rA), null == i || i.parentNode.classList.add(rA), requestAnimationFrame(() => {
                this.scrollToThumb()
            })
        }
        scrollToThumb() {
            let t = this.thumbSlider;
            if (t) {
                let e = t.querySelector(`.${rA}`);
                if (!e) return;
                let i = t.scrollTop,
                    s = t.scrollLeft,
                    r = t.offsetWidth,
                    o = t.offsetHeight,
                    n = e.offsetTop,
                    a = e.offsetLeft,
                    l = e.offsetWidth,
                    h = e.offsetHeight,
                    c = i > n,
                    d = s > a,
                    u = a + l > s + r,
                    p = b();
                if (n + h > i + o || c || u || d) {
                    let m = n - o + h,
                        g = a - r + l;
                    c && (m = n), u && p && (g += parseInt(window.getComputedStyle(t).paddingRight)), d && (g = a, p && (g -= parseInt(window.getComputedStyle(t).paddingLeft))), t.scrollTo({
                        top: m,
                        left: g,
                        behavior: "smooth"
                    })
                }
            }
        }
        constructor() {
            super(), this.container = this.closest("[data-section-type]"), this.productImages = this.container.querySelectorAll("[data-image-id]"), this.productImagesContainer = this.container.querySelector("product-images"), this.productThumbs = this.container.querySelectorAll(rw), this.thumbSlider = this.querySelector("[data-thumbs-slider]"), this.thumbLinks = this.querySelectorAll("[data-thumb-link]")
        }
    }
    let rT = "closing",
        rq = class {
            popupOpen() {
                this.popup && (this.showModal && "function" == typeof this.popup.showModal ? this.popup.showModal() : this.showModal || "function" != typeof this.popup.show || this.popup.show(), this.popup.setAttribute("open", !0), this.popup.removeAttribute("inert"), this.popup.dispatchEvent(new CustomEvent("theme:popup:open", {
                    bubbles: !1
                })), this.enableScrollLock && document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                    bubbles: !0
                })))
            }
            popupClose() {
                if (!this.isAnimating && this.popup && !this.popup.hasAttribute("inert")) {
                    if (!this.popup.hasAttribute(rT)) return this.popup.setAttribute(rT, ""), void(this.isAnimating = !0);
                    "function" == typeof this.popup.close ? this.popup.close() : this.popup.removeAttribute("open"), this.popup.removeAttribute(rT), this.popup.setAttribute("inert", ""), !sO() && this.enableScrollLock && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    })), this.popup.dispatchEvent(new CustomEvent("theme:popup:onclose", {
                        bubbles: !1
                    })), this.enableScrollLock && (this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement())
                }
            }
            popupEvents() {
                var t;
                if (!this.popup) return;
                null === (t = this.buttonPopupOpen) || void 0 === t || t.addEventListener("click", t => {
                    t.preventDefault(), this.popupOpen(), window.accessibility.lastElement = this.buttonPopupOpen
                });
                let e = this.popup.querySelectorAll("[data-popup-close]");
                e.length && e.forEach(t => {
                    t.addEventListener("click", t => {
                        t.preventDefault(), this.popupClose()
                    })
                }), this.showModal && this.popup.addEventListener("click", t => {
                    "DIALOG" === t.target.nodeName && "click" === t.type && this.popupClose()
                }), this.popup.addEventListener("keydown", t => {
                    "Escape" === t.code && (t.preventDefault(), this.popupClose())
                }), this.popup.addEventListener("theme:popup:close", () => {
                    this.popupClose()
                }), this.popup.addEventListener("animationend", t => {
                    if (t.target === this.popup) {
                        if (this.isAnimating = !1, this.popup.hasAttribute(rT)) this.popupClose();
                        else {
                            this.enableScrollLock && this.a11y.trapFocus(this.popup);
                            let e = this.popup.querySelector("[autofocus]") || this.popup.querySelector('button, [href], select, textarea, [tabindex]:not([tabindex="-1"])');
                            null == e || e.focus()
                        }
                    }
                })
            }
            constructor(t, e, i = !0, s = !0) {
                var r;
                this.popup = t, this.holder = e, this.a11y = F, this.isAnimating = !1, this.showModal = i, this.enableScrollLock = s, this.buttonPopupOpen = null === (r = this.holder) || void 0 === r ? void 0 : r.querySelector("[data-popup-open]"), this.popupEvents()
            }
        },
        rx = class extends HTMLElement {
            connectedCallback() {
                new rq(this.querySelector("dialog"), this, !0, !0)
            }
            constructor() {
                super()
            }
        };
    window.ProductModel = {
        loadShopifyXR() {
            Shopify.loadFeatures([{
                name: "shopify-xr",
                version: "1.0",
                onLoad: this.setupShopifyXR.bind(this)
            }])
        },
        setupShopifyXR(t) {
            t || (window.ShopifyXR ? (document.querySelectorAll('[id^="ModelJSON-"]').forEach(t => {
                window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove()
            }), window.ShopifyXR.setupXRElements()) : document.addEventListener("shopify_xr_initialized", () => this.setupShopifyXR()))
        }
    }, window.addEventListener("DOMContentLoaded", () => {
        window.ProductModel && window.ProductModel.loadShopifyXR()
    });
    let r_ = "hidden",
        rP = class extends HTMLElement {
            connectedCallback() {
                this.container = this.closest("[data-section-type]"), this.drawer = null, this.container.addEventListener("theme:variant:change", t => this.fetchPickupAvailability(t)), this.fetchPickupAvailability()
            }
            fetchPickupAvailability(t) {
                if (t && !t.detail.variant || t && t.detail.variant && !t.detail.variant.available) return void this.classList.add(r_);
                let e = t && t.detail.variant ? t.detail.variant.id : this.getAttribute("data-store-availability-container");
                e && (this.popupActions = null, fetch(`${window.theme.routes.root}variants/${e}/?section_id=api-pickup-availability`).then(this.handleErrors).then(t => t.text()).then(t => {
                    let e = new DOMParser().parseFromString(t, "text/html").querySelector(".shopify-section").innerHTML;
                    this.innerHTML = e, this.drawer = this.querySelector("[data-pickup-drawer]"), this.drawer ? (this.classList.remove(r_), this.popupActions = new rq(this.drawer, this, !0, !0)) : this.classList.add(r_)
                }).catch(t => {
                    console.error(t)
                }))
            }
            handleErrors(t) {
                return t.ok ? t : t.json().then(function(e) {
                    throw new tM({
                        status: t.statusText,
                        headers: t.headers,
                        json: e
                    })
                })
            }
            constructor() {
                super()
            }
        },
        rM = {};

    function rH(t = {}) {
        if (t.type || (t.type = "json"), t.url) return rM[t.url] ? rM[t.url] : function(t, e) {
            let i = new Promise((i, s) => {
                var r, o, n;
                let a, l, h;
                "text" === e ? fetch(t).then(t => t.text()).then(t => {
                    i(t)
                }).catch(t => {
                    s(t)
                }) : (r = t, o = function() {
                    i()
                }, n = function() {
                    s()
                }, a = document.getElementsByTagName("head")[0], l = !1, (h = document.createElement("script")).src = r, h.onload = h.onreadystatechange = function() {
                    l || this.readyState && "loaded" != this.readyState && "complete" != this.readyState ? n() : (l = !0, o())
                }, a.appendChild(h))
            });
            return rM[t] = i, i
        }(t.url, t.type);
        if (t.json) return rM[t.json] ? Promise.resolve(rM[t.json]) : window.fetch(t.json).then(t => t.json()).then(e => (rM[t.json] = e, e));
        if (t.name) {
            let e = "".concat(t.name, t.version);
            return rM[e] ? rM[e] : function(t) {
                let e = "".concat(t.name, t.version),
                    i = new Promise((e, i) => {
                        try {
                            window.Shopify.loadFeatures([{
                                name: t.name,
                                version: t.version,
                                onLoad(t) {
                                    var s, r, o;
                                    s = e, r = i, (o = t) ? r(o) : s()
                                }
                            }, ])
                        } catch (s) {
                            i(s)
                        }
                    });
                return rM[e] = i, i
            }(t)
        }
        return Promise.reject()
    }
    window.isYoutubeAPILoaded = !1, window.isVimeoAPILoaded = !1;
    let rB = ".pswp__thumbs",
        rI = "is-current",
        rD = "pswp--custom-loader",
        rO = "pswp--custom-opening",
        r8 = "pswp__loader",
        r9 = "data-pswp-option-classes",
        rF = "aria-current",
        rR = `<div class="${r8}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`,
        rN = class {
            init() {
                this.pswpElement.classList.add(rO), this.initLoader(), rH({
                    url: window.theme.assets.photoswipe
                }).then(() => this.loadPopup()).catch(t => console.error(t))
            }
            initLoader() {
                if (this.pswpElement.classList.contains(rD) && "" !== this.options && this.options.mainClass) {
                    this.pswpElement.setAttribute(r9, this.options.mainClass);
                    let t = document.createElement("div");
                    t.innerHTML = rR, t = t.firstChild, this.pswpElement.appendChild(t)
                } else this.pswpElement.setAttribute(r9, "")
            }
            loadPopup() {
                let t = window.themePhotoswipe.PhotoSwipe.default,
                    e = window.themePhotoswipe.PhotoSwipeUI.default;
                this.pswpElement.classList.contains(rD) && this.pswpElement.classList.remove(rD), this.pswpElement.classList.remove(rO), this.popup = new t(this.pswpElement, e, this.items, this.options), this.popup.init(), this.thumbsActions(), document.body.classList.contains("is-focused") && setTimeout(() => {
                    this.a11y.trapFocus(this.pswpElement, {
                        elementToFocus: this.closeBtn
                    })
                }, 200), this.popup.listen("close", () => this.onClose()), this.options && this.options.closeElClasses && this.options.closeElClasses.length && this.options.closeElClasses.forEach(t => {
                    let e = this.pswpElement.querySelector(`.pswp__${t}`);
                    e && e.addEventListener("keyup", this.keyupCloseEvent)
                })
            }
            thumbsActions() {
                this.popupThumbsContainer && this.popupThumbsContainer.children.length && (this.popupThumbsContainer.addEventListener("wheel", t => this.stopDisabledScroll(t)), this.popupThumbsContainer.addEventListener("mousewheel", t => this.stopDisabledScroll(t)), this.popupThumbsContainer.addEventListener("DOMMouseScroll", t => this.stopDisabledScroll(t)), this.popupThumbs = this.pswpElement.querySelectorAll(`${rB} > *`), this.popupThumbs.forEach((t, e) => {
                    t.addEventListener("click", i => {
                        i.preventDefault();
                        let s = t.parentElement.querySelector(`.${rI}`);
                        s.classList.remove(rI), s.setAttribute(rF, !1), t.classList.add(rI), t.setAttribute(rF, !0), this.popup.goTo(e)
                    })
                }), this.popup.listen("imageLoadComplete", () => this.setCurrentThumb()), this.popup.listen("beforeChange", () => this.setCurrentThumb()))
            }
            stopDisabledScroll(t) {
                t.stopPropagation()
            }
            keyupClose(t) {
                "Enter" === t.code && this.popup.close()
            }
            onClose() {
                let t = this.pswpElement.querySelector("iframe, video");
                if (t && t.parentNode.removeChild(t), this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
                    for (; this.popupThumbsContainer.firstChild;) this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild);
                this.pswpElement.setAttribute(r9, "");
                let e = this.pswpElement.querySelector(`.${r8}`);
                e && this.pswpElement.removeChild(e), this.options && this.options.closeElClasses && this.options.closeElClasses.length && this.options.closeElClasses.forEach(t => {
                    let e = this.pswpElement.querySelector(`.pswp__${t}`);
                    e && e.removeEventListener("keyup", this.keyupCloseEvent)
                }), this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()
            }
            setCurrentThumb() {
                let t = this.pswpElement.querySelector(`${rB} > .${rI}`);
                if (t && (t.classList.remove(rI), t.setAttribute(rF, !1)), !this.popupThumbs) return;
                let e = this.popupThumbs[this.popup.getCurrentIndex()];
                e.classList.add(rI), e.setAttribute(rF, !0), this.scrollThumbs(e)
            }
            scrollThumbs(t) {
                let e = this.popupThumbsContainer.scrollLeft + this.popupThumbsContainer.offsetWidth,
                    i = t.offsetLeft;
                if (e <= i + t.offsetWidth || e > i) {
                    let s = parseInt(window.getComputedStyle(t).marginLeft);
                    this.popupThumbsContainer.scrollTo({
                        top: 0,
                        left: i - s,
                        behavior: "smooth"
                    })
                }
            }
            constructor(t, e = "") {
                this.items = t, this.pswpElement = document.querySelectorAll(".pswp")[0], this.popup = null, this.popupThumbs = null, this.popupThumbsContainer = this.pswpElement.querySelector(rB), this.closeBtn = this.pswpElement.querySelector(".pswp__custom-close"), this.keyupCloseEvent = t => this.keyupClose(t), this.a11y = F, this.options = "" !== e ? e : {
                    history: !1,
                    focus: !1,
                    mainClass: ""
                }, this.init()
            }
        },
        rz = "variant--soldout",
        rW = "variant--unavailable",
        rU = "pswp-zoom-gallery",
        r0 = class extends HTMLElement {
            connectedCallback() {
                this.images.forEach((t, e) => {
                    t.addEventListener("click", i => {
                        i.preventDefault(), t.closest("product-images").classList.contains("is-dragging") || (this.createZoom(e), window.accessibility.lastElement = t)
                    }), t.addEventListener("keyup", i => {
                        "Enter" === i.code && (i.preventDefault(), this.createZoom(e), window.accessibility.lastElement = t)
                    })
                })
            }
            createZoom(t) {
                let e = this.container.querySelector("[data-pswp-thumbs-template]"),
                    i = null == e ? void 0 : e.innerHTML,
                    s = [],
                    r = 0;
                this.images.forEach(e => {
                    let o = e.getAttribute("data-image-src");
                    r += 1, s.push({
                        src: o,
                        w: parseInt(e.getAttribute("data-image-width")),
                        h: parseInt(e.getAttribute("data-image-height")),
                        msrc: o
                    }), this.images.length === r && (new rN(s, {
                        history: !1,
                        focus: !1,
                        index: t,
                        mainClass: 1 === r ? `${rU} pswp-zoom-gallery--single` : `${rU}`,
                        showHideOpacity: !0,
                        howAnimationDuration: 150,
                        hideAnimationDuration: 250,
                        closeOnScroll: !1,
                        closeOnVerticalDrag: !1,
                        captionEl: !0,
                        closeEl: !0,
                        closeElClasses: ["caption-close", "title"],
                        tapToClose: !1,
                        clickToCloseNonZoomable: !1,
                        maxSpreadZoom: 2,
                        loop: !0,
                        spacing: 0,
                        allowPanToNext: !0,
                        pinchToClose: !1,
                        addCaptionHTMLFn: (t, e, i) => {
                            this.zoomCaption(t, e, i)
                        },
                        getThumbBoundsFn: () => {
                            let e = this.images[t],
                                i = window.scrollY || document.documentElement.scrollTop,
                                s = e.getBoundingClientRect();
                            return {
                                x: s.left,
                                y: s.top + i,
                                w: s.width
                            }
                        }
                    }), this.thumbsContainer && "" !== i && (this.thumbsContainer.innerHTML = i))
                })
            }
            zoomCaption(t, e) {
                let i = "",
                    s = e.children[0];
                return this.zoomCaptions && (i = this.zoomCaptions.innerHTML, this.zoomCaptions.closest(`.${rz}`) ? s.classList.add(rz) : s.classList.remove(rz), this.zoomCaptions.closest(`.${rW}`) ? s.classList.add(rW) : s.classList.remove(rW)), s.innerHTML = i, !1
            }
            constructor() {
                super(), this.container = this.closest("[data-section-type]"), this.images = this.querySelectorAll("[data-zoom-image]"), this.zoomCaptions = this.container.querySelector("[data-zoom-caption]"), this.thumbsContainer = document.querySelector(".pswp__thumbs")
            }
        },
        rV = "[data-slider]",
        rj = "data-add-to-cart-bar",
        r1 = "data-slider-index",
        r3 = {};
    eH("product", [{
        onLoad() {
            r3[this.id] = new class {
                initCartBar() {
                    this.cartBarBtn = this.cartBar.querySelector(".product__submit__add"), this.cartBarBtn && (this.cartBarBtn.addEventListener("click", t => {
                        t.preventDefault(), t.currentTarget.hasAttribute(rj) ? (this.cartBarEnabled && (t.currentTarget.classList.add("is-loading"), t.currentTarget.setAttribute("disabled", "disabled")), this.form.querySelector("[data-add-to-cart]").dispatchEvent(new Event("click", {
                            bubbles: !0
                        }))) : t.currentTarget.hasAttribute("data-cart-bar-scroll") && this.scrollToTop()
                    }), this.cartBarBtn.hasAttribute(rj) && document.addEventListener("theme:product:add-error", this.scrollToTop)), this.setCartBarHeight()
                }
                scrollToTop() {
                    let t = this.container.querySelector("[data-product-variants]"),
                        e = (y() ? this.container : t || this.form).getBoundingClientRect().top;
                    e6(y() ? e : e - 10)
                }
                toggleCartBarOnScroll() {
                    let t = window.scrollY,
                        e = theme.variables.productPageSticky && this.formWrapper ? this.formWrapper : this.form;
                    if (e && this.cartBar) {
                        let i = t > e.offsetTop + e.offsetHeight;
                        this.cartBar.classList.toggle("is-visible", i)
                    }
                }
                setCartBarHeight() {
                    let t = this.cartBar.offsetHeight;
                    document.documentElement.style.setProperty("--cart-bar-height", `${t}px`)
                }
                onUnload() {
                    document.removeEventListener("theme:product:add-error", this.scrollToTop), this.cartBarEnabled && (document.removeEventListener("theme:scroll", this.toggleCartBarOnScroll), document.removeEventListener("theme:resize", this.setCartBarHeight))
                }
                onBlockSelect(t) {
                    let e = t.srcElement.closest(rV);
                    if (e && this.slider.length) {
                        let i = e.hasAttribute(r1) ? e.getAttribute(r1) : 0;
                        if (!this.slider[i]) return;
                        this.slider[i].onBlockSelect(t)
                    }
                }
                onBlockDeselect(t) {
                    let e = t.srcElement.closest(rV);
                    if (e && this.slider.length) {
                        let i = e.hasAttribute(r1) ? e.getAttribute(r1) : 0;
                        if (!this.slider[i]) return;
                        this.slider[i].onBlockDeselect(t)
                    }
                }
                constructor(t) {
                    this.section = t, this.container = t.container, this.id = this.container.getAttribute("data-section-id"), this.sliders = this.container.querySelectorAll(rV), this.slider = [], this.formWrapper = this.container.querySelector("[data-form-wrapper]"), this.cartBarEnabled = this.container.hasAttribute("data-cart-bar-enabled"), this.cartBar = this.container.querySelector("#cart-bar"), this.setCartBarHeight = this.setCartBarHeight.bind(this), this.scrollToTop = this.scrollToTop.bind(this), this.toggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this), this.unlockTimer = 0, this.accessibility = F;
                    let e = this.container.querySelector("[data-product-json]");
                    if (e && !e.innerHTML || !e) return;
                    let i = JSON.parse(e.innerHTML).handle,
                        s = {};
                    i && (s = {
                        handle: i
                    }), Shopify.Products.recordRecentlyViewed(s), this.form = this.container.querySelector("[data-product-form]"), this.sliders.length && this.sliders.forEach((t, e) => {
                        t.setAttribute(r1, e), this.slider.push(new e5(this.container, t))
                    }), this.cartBarEnabled && (this.initCartBar(), this.setCartBarHeight(), document.addEventListener("theme:scroll", this.toggleCartBarOnScroll), document.addEventListener("theme:resize", this.setCartBarHeight))
                }
            }(this)
        },
        onUnload(t) {
            r3[this.id].onUnload(t)
        },
        onBlockSelect(t) {
            r3[this.id].onBlockSelect(t)
        },
        onBlockDeselect(t) {
            r3[this.id].onBlockDeselect(t)
        }
    }, eU, sD, {
        onLoad() {
            s2[this.id] = new class {
                init() {
                    this.stickyEnabled && (this.stickyScrollCheck(), document.addEventListener("theme:resize", this.resizeEvent)), this.initSticky()
                }
                initSticky() {
                    theme.variables.productPageSticky && (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition()), this.formWrapper.addEventListener("theme:form:sticky", this.stickyFormEvent), document.addEventListener("theme:scroll", this.scrollEvent))
                }
                stickyFormEvents(t) {
                    this.removeAnimationFrameSticky(), this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(t))
                }
                scrollEvents(t) {
                    this.scrollTop = t.detail.position, this.scrollDirectionDown = t.detail.down, this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition()))
                }
                resizeEvents(t) {
                    this.stickyScrollCheck(), document.removeEventListener("theme:scroll", this.scrollEvent), this.formWrapper.removeEventListener("theme:form:sticky", this.stickyFormEvent), this.initSticky()
                }
                stickyScrollCheck() {
                    let t = this.container.querySelector(`.product__page ${s3}`);
                    if (t) {
                        if (y()) {
                            let e = this.container.querySelector(s3),
                                i = this.container.querySelector("[data-product-media-list]");
                            if (!e || !i) return;
                            e.offsetHeight < i.offsetHeight ? (theme.variables.productPageSticky = !0, t.classList.add(sX)) : (theme.variables.productPageSticky = !1, t.classList.remove(sX))
                        } else theme.variables.productPageSticky = !1, t.classList.remove(sX)
                    }
                }
                calculateStickyPosition(t = null) {
                    if (document.documentElement.hasAttribute("data-scroll-locked")) return void this.removeAnimationFrameSticky();
                    let e = Boolean(t && t.detail),
                        i = Boolean(e && t.detail.element && "accordion" === t.detail.element),
                        s = this.formWrapper.offsetHeight,
                        r = window.innerHeight - s - this.defaultTopBottomSpacings,
                        o = Math.abs(this.scrollTop - this.scrollLastPosition);
                    if (this.scrollDirectionDown ? this.stickyScrollTop -= o : this.stickyScrollTop += o, this.stickyFormLoad) {
                        if (document.querySelector("[data-header-sticky]")) {
                            let {
                                headerHeight: n
                            } = h();
                            this.stickyDefaultTop = n
                        } else this.stickyDefaultTop = this.defaultTopBottomSpacings;
                        this.stickyScrollTop = this.stickyDefaultTop
                    }
                    this.stickyScrollTop = Math.min(Math.max(this.stickyScrollTop, r), this.stickyDefaultTop);
                    let a = this.stickyScrollTop - this.currentPoint;
                    this.currentPoint = this.stickyFormLoad ? this.stickyScrollTop : this.currentPoint + .5 * a, this.formWrapper.style.setProperty("--sticky-top", `${this.currentPoint}px`), this.scrollLastPosition = this.scrollTop, this.stickyFormLoad = !1, i && this.onChangeCounter <= 10 || i && this.stickyFormLastHeight !== s || this.stickyScrollTop !== this.currentPoint && this.requestAnimationSticky ? (i && (this.onChangeCounter += 1), i && this.stickyFormLastHeight !== s && (this.onChangeCounter = 11), this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(t))) : this.requestAnimationSticky && this.removeAnimationFrameSticky(), this.stickyFormLastHeight = s
                }
                removeAnimationFrameSticky() {
                    this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), this.requestAnimationSticky = null, this.onChangeCounter = 0)
                }
                onUnload() {
                    this.stickyEnabled && document.removeEventListener("theme:resize", this.resizeEvent), theme.variables.productPageSticky && document.removeEventListener("theme:scroll", this.scrollEvent)
                }
                constructor(t) {
                    this.section = t, this.container = t.container, this.stickyEnabled = "true" === this.container.getAttribute("data-sticky-enabled"), this.formWrapper = this.container.querySelector(s3), this.stickyScrollTop = 0, this.scrollLastPosition = 0, this.stickyDefaultTop = 0, this.currentPoint = 0, this.defaultTopBottomSpacings = 30, this.scrollTop = window.scrollY, this.scrollDirectionDown = !0, this.requestAnimationSticky = null, this.stickyFormLoad = !0, this.stickyFormLastHeight = null, this.onChangeCounter = 0, this.scrollEvent = t => this.scrollEvents(t), this.resizeEvent = t => this.resizeEvents(t), this.stickyFormEvent = t => this.stickyFormEvents(t), setTimeout(() => {
                        this.init()
                    }, 50)
                }
            }(this)
        },
        onUnload() {
            s2[this.id].onUnload()
        }
    }]), customElements.get("complementary-products") || customElements.define("complementary-products", sj), customElements.get("pickup-availability") || customElements.define("pickup-availability", rP), customElements.get("product-form") || customElements.define("product-form", rE), customElements.get("product-images") || customElements.define("product-images", rs), customElements.get("product-thumbs") || customElements.define("product-thumbs", rC), customElements.get("product-modal") || customElements.define("product-modal", rx), customElements.get("product-model") || customElements.define("product-model", class extends tg {
        loadContent() {
            super.loadContent(), Shopify.loadFeatures([{
                name: "model-viewer-ui",
                version: "1.0",
                onLoad: this.setupModelViewerUI.bind(this)
            }])
        }
        setupModelViewerUI(t) {
            t || (this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector("model-viewer")))
        }
        constructor() {
            super()
        }
    }), customElements.get("product-siblings") || customElements.define("product-siblings", sC), customElements.get("radio-swatch") || customElements.define("radio-swatch", sv), customElements.get("recipient-form") || customElements.define("recipient-form", s1), customElements.get("share-button") || customElements.define("share-button", sY), customElements.get("zoom-images") || customElements.define("zoom-images", r0);
    let rX = "[data-recent-wrapper]",
        r2 = "data-limit",
        r4 = "data-minimum",
        rG = {};
    eH("related", [{
        onLoad() {
            rG[this.id] = new class {
                related() {
                    let t = this.container.querySelector("[data-related-section]");
                    if (!t) return;
                    let e = t.getAttribute("data-product-id"),
                        i = t.getAttribute(r2),
                        s = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${i}&product_id=${e}&intent=related`;
                    fetch(s).then(t => t.text()).then(e => {
                        let i = document.createElement("div");
                        i.innerHTML = new DOMParser().parseFromString(e, "text/html").querySelector("[data-api-related-template]").innerHTML, i.querySelector("[data-grid-item]") ? t.innerHTML = i.innerHTML : t.dispatchEvent(new CustomEvent("theme:tab:hide", {
                            bubbles: !0
                        }))
                    }).catch(function() {
                        t.dispatchEvent(new CustomEvent("theme:tab:hide", {
                            bubbles: !0
                        }))
                    })
                }
                recent() {
                    let t = this.container.querySelector(rX),
                        e = t ? parseInt(t.getAttribute(r2)) : 4;
                    Shopify.Products.showRecentlyViewed({
                        howManyToShow: e,
                        wrapperId: `recently-viewed-products-${this.sectionId}`,
                        section: this.section,
                        onComplete(t, e) {
                            let i = e.container,
                                s = i.querySelector(rX),
                                r = i.querySelector("[data-recently-viewed-wrapper]"),
                                o = t.querySelectorAll(".product-item"),
                                n = s.querySelector("grid-slider"),
                                a = s.hasAttribute(r4) ? parseInt(s.getAttribute(r4)) : 4,
                                l = !r && o.length > 0,
                                h = r && o.length >= a;
                            (l || h) && (h && r.classList.remove("is-hidden"), s.classList.remove("is-hidden"), s.dispatchEvent(new CustomEvent("theme:tab:check", {
                                bubbles: !0
                            })), n && n.dispatchEvent(new CustomEvent("theme:grid-slider:init", {
                                bubbles: !0
                            })))
                        }
                    })
                }
                constructor(t) {
                    this.section = t, this.sectionId = t.id, this.container = t.container, this.related(), this.recent()
                }
            }(this)
        }
    }, sD]), eH("reviews", [eJ, iQ]);
    let rY = {},
        r5 = "[data-slide]",
        rJ = "is-selected",
        r6 = "is-initialized",
        r7 = "flickity-enabled",
        rQ = "data-slide-index";
    eH("logos", [{
        onLoad() {
            rY[this.id] = new class {
                getSlidesWidth() {
                    return 200 * this.logoSlides.length
                }
                initSlideshowText() {
                    this.slideshowText && (this.flkty = new o(this.slideshowText, {
                        fade: !0,
                        autoPlay: !1,
                        prevNextButtons: !1,
                        cellAlign: "left",
                        contain: !0,
                        pageDots: !1,
                        wrapAround: !1,
                        selectedAttraction: .2,
                        friction: .6,
                        draggable: !1,
                        accessibility: !1,
                        on: {
                            ready: () => this.sliderAccessibility(),
                            change: () => this.sliderAccessibility()
                        }
                    }))
                }
                sliderAccessibility() {
                    let t = this.slideshowText.querySelectorAll(`${r5} a, ${r5} button`);
                    t.length && t.forEach(t => {
                        let e = t.closest(r5);
                        if (e) {
                            let i = e.classList.contains(rJ) ? 0 : -1;
                            t.setAttribute("tabindex", i)
                        }
                    })
                }
                initSlideshowNav() {
                    this.slideshowNav && (this.logoSlides.length && this.logoSlides.forEach(t => {
                        t.addEventListener("click", () => {
                            let e = parseInt(t.getAttribute(rQ)),
                                i = this.slideshowNav.classList.contains(r7);
                            if (this.flkty && this.flkty.select(e), i) this.flktyNav.select(e), this.slideshowNav.classList.contains(rJ) || this.flktyNav.playPlayer();
                            else {
                                let s = this.slideshowNav.querySelector(`.${rJ}`);
                                s && s.classList.remove(rJ), t.classList.add(rJ)
                            }
                        })
                    }), this.setSlideshowNavState(), document.addEventListener("theme:resize", this.setSlideshowNavStateOnResize))
                }
                setSlideshowNavState() {
                    let t = this.slideshowNav.classList.contains(r7);
                    if (this.logoSlidesWidth > v()) {
                        if (!t) {
                            this.slideshowNav.classList.add(r6);
                            let e = this.slideshowNav.querySelector(`.${rJ}`);
                            e && e.classList.remove(rJ), this.logoSlides[0].classList.add(rJ), this.flktyNav || (this.flktyNav = new r(this.slideshowNav, {
                                autoPlay: 4e3,
                                prevNextButtons: !1,
                                contain: !1,
                                pageDots: !1,
                                wrapAround: !0,
                                watchCSS: !0,
                                selectedAttraction: .05,
                                friction: .8,
                                initialIndex: 0
                            }), this.flktyNav.on("deactivate", () => {
                                this.slideshowNav.querySelector(r5).classList.add(rJ), this.flkty && this.flkty.select(0)
                            }), this.flkty && (this.flkty.select(0), this.flktyNav.on("change", t => this.flkty.select(t))))
                        }
                    } else t && this.slideshowNav.classList.remove(r6)
                }
                onBlockSelect(t) {
                    if (!this.slideshowNav) return;
                    let e = this.slideshowNav.querySelector(`[data-slide="${t.detail.blockId}"]`),
                        i = parseInt(e.getAttribute(rQ));
                    this.slideshowNav.classList.contains(r7) ? (this.flktyNav.select(i), this.flktyNav.stopPlayer(), this.slideshowNav.classList.add(rJ)) : e.dispatchEvent(new Event("click"))
                }
                onBlockDeselect() {
                    this.slideshowNav && this.slideshowNav.classList.contains(r7) && (this.flktyNav.playPlayer(), this.slideshowNav.classList.remove(rJ))
                }
                onUnload() {
                    document.removeEventListener("theme:resize", this.setSlideshowNavStateOnResize)
                }
                constructor(t) {
                    this.container = t.container, this.slideshowNav = this.container.querySelector("[data-slider-logos]"), this.slideshowText = this.container.querySelector("[data-slider-text]"), this.setSlideshowNavStateOnResize = () => this.setSlideshowNavState(), this.flkty = null, this.flktyNav = null, this.logoSlides = this.slideshowNav.querySelectorAll(r5), this.logoSlidesWidth = this.getSlidesWidth(), this.initSlideshowText(), this.initSlideshowNav()
                }
            }(this)
        },
        onUnload(t) {
            rY[this.id].onUnload(t)
        },
        onBlockSelect(t) {
            rY[this.id].onBlockSelect(t)
        },
        onBlockDeselect(t) {
            rY[this.id].onBlockDeselect(t)
        }
    }, iQ, ]);
    let rK = "data-video-play",
        rZ = class extends HTMLElement {
            connectedCallback() {
                var t;
                this.videoPlay = this.querySelectorAll(`[${rK}]`), null === (t = this.videoPlay) || void 0 === t || t.forEach(t => {
                    t.addEventListener("click", t => {
                        let e = t.currentTarget;
                        if ("" !== e.getAttribute(rK).trim()) {
                            t.preventDefault();
                            let i = [{
                                html: e.getAttribute(rK)
                            }];
                            new rN(i), window.accessibility.lastElement = e
                        }
                    })
                })
            }
            constructor() {
                super()
            }
        },
        ot = class extends HTMLElement {
            connectedCallback() {
                this.videoId = this.getAttribute("data-video-id"), this.videoTemplate = this.querySelector("[data-video-template]"), this.video = null, this.powerSaverVideoPlay = this.powerSaverVideoPlay.bind(this), this.videoId && this.renderVideo()
            }
            powerSaverVideoPlay() {
                var t;
                null === (t = this.video) || void 0 === t || t.play()
            }
            renderVideo() {
                this.videoTemplateObserver = new IntersectionObserver((t, e) => {
                    t.forEach(t => {
                        if (t.isIntersecting) {
                            let i = this.videoTemplate.innerHTML;
                            this.innerHTML = i, this.classList.remove("is-loading"), this.video = this.querySelector("video"), this.observeVideoPlayToggle(), this.video.play().then(() => {}).catch(() => {
                                document.addEventListener("click", this.powerSaverVideoPlay, {
                                    passive: !0,
                                    bubbles: !0,
                                    once: !0
                                }), document.addEventListener("touchstart", this.powerSaverVideoPlay, {
                                    passive: !0,
                                    bubbles: !0,
                                    once: !0
                                })
                            }), e.unobserve(t.target)
                        }
                    })
                }, {
                    root: null,
                    rootMargin: "300px",
                    threshold: [0, .1, .25, .5, .75, 1]
                }), this.videoTemplateObserver.observe(this)
            }
            observeVideoPlayToggle() {
                this.video && (this.videoPlayObserver = new IntersectionObserver(t => {
                    t.forEach(t => {
                        let e = t.isIntersecting;
                        e && "function" == typeof this.video.play && this.video.play(), e || "function" != typeof this.video.pause || this.video.pause()
                    })
                }, {
                    rootMargin: "0px",
                    threshold: [0, 1]
                }), this.videoPlayObserver.observe(this.video))
            }
            disconnectedCallback() {
                this.videoTemplateObserver && this.videoTemplateObserver.disconnect(), this.videoPlayObserver && this.videoPlayObserver.disconnect(), this.videoId && (document.removeEventListener("click", this.powerSaverVideoPlay), document.removeEventListener("touchstart", this.powerSaverVideoPlay))
            }
            constructor() {
                super()
            }
        };
    eH("featured-video", [eV]), customElements.get("video-background") || customElements.define("video-background", ot), customElements.get("video-popup") || customElements.define("video-popup", rZ), eH("slideshow", [eJ, eV]);
    let oe = class extends HTMLElement {
        connectedCallback() {
            this.setOverlapImageSize(), this.setImagePosition(), this.rangeInput.addEventListener("input", () => this.setImagePosition()), document.addEventListener("theme:resize", this.setOverlapImageSize)
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize", this.setOverlapImageSize)
        }
        setImagePosition() {
            let t = this.rangeInput.value,
                e = this.imageElement.offsetWidth,
                i = this.rangeButton.offsetWidth;
            this.rangeButton.style.left = `${t}%`, this.imageHolder.style.width = (e - i) * (100 - t) / 100 + i / 2 + "px"
        }
        setOverlapImageSize() {
            let t = this.offsetWidth;
            this.imageElement.style.width = `${t}px`, this.setImagePosition()
        }
        constructor() {
            super(), this.imageHolder = this.querySelector("[data-image-holder]"), this.imageElement = this.querySelector("[data-image-element]"), this.rangeButton = this.querySelector("[data-range-button]"), this.rangeInput = this.querySelector("[data-range-input]"), this.setOverlapImageSize = this.setOverlapImageSize.bind(this)
        }
    };
    eH("custom-content", [eJ, eV, ie]), customElements.get("video-background") || customElements.define("video-background", ot), customElements.get("video-popup") || customElements.define("video-popup", rZ), customElements.get("compare-images") || customElements.define("compare-images", oe);
    var oi = {};

    function os(t) {
        return oi[t]
    }
    oi.basic = [], oi.light = [{
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            lightness: "64"
        }, {
            hue: "#ff0000"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#bdbdbd"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f0f0f0"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "labels",
        stylers: [{
            lightness: "100"
        }]
    }, {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{
            visibility: "on"
        }]
    }, {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{
            saturation: "-41"
        }, {
            color: "#e8ede7"
        }]
    }, {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: "-100"
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            lightness: "25"
        }, {
            gamma: "1.06"
        }, {
            saturation: "-100"
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            gamma: "10.00"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            gamma: "10.00"
        }, {
            lightness: "100"
        }, {
            weight: "0.4"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            weight: "0.01"
        }, {
            lightness: "39"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.50"
        }, {
            gamma: "10.00"
        }, {
            lightness: "100"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#cfe5ee"
        }, {
            visibility: "on"
        }]
    }, ], oi.white_label = [{
        featureType: "all",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            gamma: "3.86"
        }, {
            lightness: "100"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#cccccc"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f2f2f2"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: -100
        }, {
            lightness: 45
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#e4e4e4"
        }, {
            visibility: "on"
        }]
    }, ], oi.dark_label = [{
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{
            saturation: 36
        }, {
            color: "#000000"
        }, {
            lightness: 40
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [{
            visibility: "on"
        }, {
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: 1.2
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            lightness: "-82"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.stroke",
        stylers: [{
            invert_lightness: !0
        }, {
            weight: "7.15"
        }]
    }, {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 21
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 29
        }, {
            weight: "0.01"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 18
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 19
        }]
    }, {
        featureType: "water",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }]
    }, ], window.theme.allMaps = window.theme.allMaps || {};
    let or = window.theme.allMaps;
    window.theme.mapAPI = window.theme.mapAPI || null, eH("map", {
        onLoad() {
            or[this.id] = new class {
                initMaps() {
                    (function(t) {
                        if (null === window.theme.mapAPI) {
                            let e = `https://maps.googleapis.com/maps/api/js?key=${t}`;
                            window.theme.mapAPI = rH({
                                url: e
                            })
                        }
                        return window.theme.mapAPI
                    })(this.key).then(() => {
                        var t;
                        return "true" === this.enableCorrection && "" !== this.lat && "" !== this.long ? new google.maps.LatLng(this.lat, this.long) : (t = this.address, new Promise((e, i) => {
                            new google.maps.Geocoder().geocode({
                                address: t
                            }, function(t, s) {
                                "OK" == s ? e({
                                    lat: t[0].geometry.location.lat(),
                                    lng: t[0].geometry.location.lng()
                                }) : i(s)
                            })
                        }))
                    }).then(t => {
                        var e, i, s, r, o;
                        let n = {
                                zoom: parseInt(this.zoomString, 10),
                                styles: oi[e = this.styleString],
                                center: t,
                                draggable: !0,
                                clickableIcons: !1,
                                scrollwheel: !1,
                                zoomControl: !1,
                                disableDefaultUI: !0
                            },
                            a = (i = this.mapContainer, s = n, o = (r = new google.maps.Map(i, s)).getCenter(), new google.maps.Marker({
                                map: r,
                                position: o
                            }), google.maps.event.addDomListener(window, "resize", function() {
                                google.maps.event.trigger(r, "resize"), r.setCenter(o)
                            }), r);
                        return a
                    }).then(t => {
                        this.map = t, or[this.id] = t
                    }).catch(t => {
                        console.log("Failed to load Google Map"), console.log(t)
                    })
                }
                unload() {
                    void 0 !== window.google && google.maps.event.clearListeners(this.map, "resize")
                }
                constructor(t) {
                    this.container = t.container, this.mapContainer = this.container.querySelector("[data-map-container]"), this.key = this.container.getAttribute("data-api-key"), this.styleString = this.container.getAttribute("data-style") || "", this.zoomString = this.container.getAttribute("data-zoom") || 14, this.address = this.container.getAttribute("data-address"), this.enableCorrection = this.container.getAttribute("data-latlong-correction"), this.lat = this.container.getAttribute("data-lat"), this.long = this.container.getAttribute("data-long"), this.key && this.initMaps()
                }
            }(this)
        },
        onUnload() {
            "function" == typeof or[this.id].unload && or[this.id].unload()
        }
    });
    let oo = "[data-tracking-consent]",
        on = "[data-newsletter-form]",
        oa = "data-cookie-name",
        ol = "data-target-referrer",
        oh = "hidden",
        oc = "has-value",
        od = "cart-bar-visible",
        ou = "is-visible",
        op = "has-success",
        om = "selected",
        og = "has-block-selected",
        ov = {},
        of = class {
            always() {
                this.popupActions.popupOpen()
            }
            delayed(t = 10) {
                setTimeout(() => {
                    this.popupActions.popupOpen()
                }, 1e3 * t)
            }
            idle() {
                let t = 0,
                    e = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
                    i = ["load", "resize", "scroll"],
                    s = () => {
                        t = setTimeout(() => {
                            t = 0, this.popupActions.popupOpen()
                        }, 6e4), e.forEach(t => {
                            document.addEventListener(t, r)
                        }), i.forEach(t => {
                            window.addEventListener(t, r)
                        })
                    },
                    r = () => {
                        t && clearTimeout(t), e.forEach(t => {
                            document.removeEventListener(t, r)
                        }), i.forEach(t => {
                            window.removeEventListener(t, r)
                        }), s()
                    };
                s()
            }
            bottom() {
                document.addEventListener("theme:scroll", this.showPopupOnScrollEvent)
            }
            showPopupOnScroll() {
                window.scrollY + window.innerHeight >= document.body.clientHeight && (this.popupActions.popupOpen(), document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent))
            }
            onUnload() {
                document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent)
            }
            constructor(t, e, i) {
                if (this.element = e, this.delay = t.getAttribute("data-popup-delay"), this.isSubmitted = -1 !== window.location.href.indexOf("accepts_marketing") || -1 !== window.location.href.indexOf("customer_posted=true"), this.popupActions = i, this.showPopupOnScrollEvent = () => this.showPopupOnScroll(), ("always" === this.delay || this.isSubmitted) && this.always(), this.delay && this.delay.includes("delayed") && !this.isSubmitted) {
                    let s = this.delay.includes("_") ? parseInt(this.delay.split("_")[1]) : 10;
                    this.delayed(s)
                }
                "bottom" !== this.delay || this.isSubmitted || this.bottom(), "idle" !== this.delay || this.isSubmitted || this.idle()
            }
        },
        oy = class {
            init() {
                -1 !== this.locationPath.indexOf(this.el.getAttribute(ol)) || window.Shopify.designMode || this.el.parentNode.removeChild(this.el)
            }
            constructor(t) {
                if (this.el = t, this.locationPath = location.href, !this.el.hasAttribute(ol)) return !1;
                this.init()
            }
        };
    eH("popups", [{
        onLoad() {
            ov[this.id] = [], this.container.querySelectorAll("[data-large-promo]").forEach(t => {
                ov[this.id].push(new class {
                    init() {
                        let t = !1 !== this.cookie.read(),
                            e = this.popup.classList.contains("mobile"),
                            i = this.popup.classList.contains("desktop"),
                            s = !y(),
                            r = !0;
                        if ((e && !s || i && s) && (r = !1), !r) return this.a11y.removeTrapFocus(), void document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                            bubbles: !0
                        }));
                        t && !window.Shopify.designMode || (window.Shopify.designMode || window.location.pathname.endsWith("/challenge") || new of(this.popup, this.modal, this.popupActions), this.form && this.form.classList.contains(op) && this.checkForSuccess(), this.modal.addEventListener("theme:popup:onclose", () => this.cookie.write()))
                    }
                    checkForSuccess() {
                        this.popupActions.popupOpen(), this.cookie.write()
                    }
                    onBlockSelect(t) {
                        this.popup.contains(t.target) && (this.popupActions.popupOpen(), this.popup.classList.add(om), this.popup.parentNode.classList.add(og))
                    }
                    onBlockDeselect(t) {
                        this.popup.contains(t.target) && (this.popupActions.popupClose(), this.popup.classList.remove(om), this.popup.parentNode.classList.remove(og))
                    }
                    constructor(t) {
                        this.popup = t, this.modal = this.popup.querySelector("[data-large-promo-inner]"), this.form = this.popup.querySelector(on), this.cookie = new e7(this.popup.getAttribute(oa), "user_has_closed"), this.isTargeted = new oy(this.popup), this.popupActions = new rq(this.modal, this.modal, !0, !0), this.a11y = F, this.init()
                    }
                }(t))
            }), this.container.querySelectorAll(oo).forEach(t => {
                ov[this.id].push(new class {
                    init() {
                        this.showPopup && this.popupActions.popupOpen(), this.clickEvents()
                    }
                    clickEvents() {
                        this.acceptButton.addEventListener("click", t => {
                            t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!0, () => this.popupActions.popupClose()), document.documentElement.style.setProperty("--cookie-bar-height", "0px")
                        }), document.addEventListener("trackingConsentAccepted", () => {})
                    }
                    onSelect() {
                        this.showPopup && (this.popupActions.popupOpen(), this.popup.classList.add(om), this.popup.parentNode.classList.add(og))
                    }
                    onDeselect() {
                        this.showPopup && (this.popupActions.popupClose(), this.popup.classList.remove(om), this.popup.parentNode.classList.remove(og))
                    }
                    constructor(t) {
                        this.popup = t, this.modal = document.querySelector(oo), this.acceptButton = this.modal.querySelector("[data-confirm-cookies]"), this.enable = "true" === this.modal.getAttribute("data-enable"), this.showPopup = !1, this.popupActions = new rq(this.popup, this.popup, !1, !1), window.Shopify.loadFeatures([{
                            name: "consent-tracking-api",
                            version: "0.1"
                        }], t => {
                            if (t) throw t;
                            let e = window.Shopify.customerPrivacy.userCanBeTracked(),
                                i = window.Shopify.customerPrivacy.getTrackingConsent();
                            this.showPopup = !e && "no_interaction" === i && this.enable, window.Shopify.designMode && (this.showPopup = !0), this.init()
                        })
                    }
                }(t))
            }), this.container.querySelectorAll("[data-newsletter]").forEach(t => {
                ov[this.id].push(new class {
                    init() {
                        let t = !1 !== this.cookie.read(),
                            e = -1 !== window.location.search.indexOf("?customer_posted=true"),
                            i = [...this.holder.classList].toString().includes("bottom");
                        e && (this.delay = 0), t && !window.Shopify.designMode || (this.show(), this.form.classList.contains(op) && this.checkForSuccess()), i && this.observeCartBar()
                    }
                    show() {
                        window.location.pathname.endsWith("/challenge") || (window.Shopify.designMode ? this.popupActions.popupOpen() : new of(this.popup, this.holder, this.popupActions)), this.showForm(), this.inputField(), this.holder.addEventListener("theme:popup:onclose", () => this.cookie.write())
                    }
                    checkForSuccess() {
                        this.popupActions.popupOpen(), this.cookie.write()
                    }
                    observeCartBar() {
                        if (this.cartBar = document.getElementById("cart-bar"), !this.cartBar) return;
                        let t = this.cartBar.classList.contains(ou);
                        document.body.classList.toggle(od, t), this.observer = new MutationObserver(e => {
                            for (let i of e) "attributes" === i.type && (t = i.target.classList.contains(ou), document.body.classList.toggle(od, t))
                        }), this.observer.observe(this.cartBar, {
                            attributes: !0,
                            childList: !1,
                            subtree: !1
                        })
                    }
                    showForm() {
                        this.heading.addEventListener("click", t => {
                            t.preventDefault(), this.heading.classList.add(oh), this.form.classList.remove(oh), this.newsletterField.focus()
                        }), this.heading.addEventListener("keyup", t => {
                            "Enter" === t.code && this.heading.dispatchEvent(new Event("click"))
                        })
                    }
                    inputField() {
                        let t = () => {
                            this.resetClassTimer && clearTimeout(this.resetClassTimer), "" !== this.newsletterField.value && this.holder.classList.add(oc)
                        };
                        this.newsletterField.addEventListener("input", t), this.newsletterField.addEventListener("focus", t), this.newsletterField.addEventListener("focusout", () => {
                            this.resetClassTimer && clearTimeout(this.resetClassTimer), this.resetClassTimer = setTimeout(() => {
                                this.holder.classList.remove(oc)
                            }, 2e3)
                        })
                    }
                    onBlockSelect(t) {
                        this.popup.contains(t.target) && (this.popupActions.popupOpen(), this.popup.classList.add(om), this.popup.parentNode.classList.add(og))
                    }
                    onBlockDeselect(t) {
                        this.popup.contains(t.target) && (this.popupActions.popupClose(), this.popup.classList.remove(om), this.popup.parentNode.classList.remove(og))
                    }
                    onUnload() {
                        this.observer && this.observer.disconnect()
                    }
                    constructor(t) {
                        this.popup = t, this.holder = this.popup.querySelector("[data-newsletter-holder]"), this.heading = this.popup.querySelector("[data-newsletter-heading]"), this.newsletterField = this.popup.querySelector("[data-newsletter-field]"), this.cookie = new e7(this.popup.getAttribute(oa), "newsletter_is_closed"), this.form = this.popup.querySelector(on), this.isTargeted = new oy(this.popup), this.popupActions = new rq(this.holder, this.holder, !1, !1), this.resetClassTimer = 0, this.init()
                    }
                }(t))
            }), this.container.querySelectorAll("[data-promo-text]").forEach(t => {
                ov[this.id].push(new class {
                    init() {
                        (!1 === this.cookie.read() || window.Shopify.designMode) && (window.Shopify.designMode ? this.popupActions.popupOpen() : new of(this.popup, this.popup, this.popupActions), this.popup.addEventListener("theme:popup:onclose", () => this.cookie.write()))
                    }
                    onSelect() {
                        this.popupActions.popupOpen(), this.popup.classList.add(om), this.popup.parentNode.classList.add(og)
                    }
                    onDeselect() {
                        this.popupActions.popupClose(), this.popup.classList.remove(om), this.popup.parentNode.classList.remove(og)
                    }
                    constructor(t) {
                        this.popup = t, this.cookie = new e7(this.popup.getAttribute(oa), "user_has_closed"), this.isTargeted = new oy(this.popup), this.popupActions = new rq(this.popup, this.popup, !1, !1), this.init()
                    }
                }(t))
            })
        },
        onBlockSelect(t) {
            ov[this.id].forEach(e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            })
        },
        onBlockDeselect(t) {
            ov[this.id].forEach(e => {
                "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
            })
        },
        onSelect() {
            ov[this.id].forEach(t => {
                "function" == typeof t.onSelect && t.onSelect()
            })
        },
        onDeselect() {
            ov[this.id].forEach(t => {
                "function" == typeof t.onDeselect && t.onDeselect()
            })
        },
        onUnload() {
            ov[this.id].forEach(t => {
                "function" == typeof t.onUnload && t.onUnload()
            })
        }
    }, ie]), eH("password-template", {
        onLoad() {
            new class {
                constructor(t) {
                    this.container = t.container, this.popupActions = new rq(this.container.querySelector("[data-password-modal]"), this.container, !0, !0), this.container.querySelector("#login_form .errors") && this.popupActions.popupOpen()
                }
            }(this)
        }
    }), eH("list-collections", [eJ, iQ]), eH("columns", [iQ, eJ]), eH("newsletter", ie), customElements.get("compare-images") || customElements.define("compare-images", oe);
    let ob = "data-tooltip-stop-mouseenter",
        oS = {},
        oL = "is-selected",
        oE = "data-scroll-spy",
        ow = "data-scroll-spy-mobile",
        ok = "data-scroll-spy-desktop",
        o$ = {},
        oA = {
            onLoad() {
                var t;
                o$[this.id] = [], null === (t = this.container.querySelectorAll("[data-scroll-spy]")) || void 0 === t || t.forEach(t => {
                    let e = this.container.querySelector(t.getAttribute(oE));
                    o$[this.id].push(new class {
                        init() {
                            this.toggleScrollObserver(), document.addEventListener("theme:resize:width", this.toggleScrollObserver)
                        }
                        toggleScrollObserver() {
                            this.isEligible() ? this.initialized || (document.addEventListener("theme:scroll", this.scrollCallback), this.initialized = !0) : (document.removeEventListener("theme:scroll", this.scrollCallback), this.initialized = !1)
                        }
                        isEligible() {
                            let t = y();
                            return !t && this.anchor.hasAttribute(ow) || t && this.anchor.hasAttribute(ok) || !this.anchor.hasAttribute(ok) && !this.anchor.hasAttribute(ow)
                        }
                        onScroll() {
                            this.top = this.elementToSpy.getBoundingClientRect().top;
                            let t = Math.round(window.innerHeight),
                                e = Math.round(window.scrollY),
                                i = Math.round(this.top + e),
                                s = this.elementToSpy.offsetHeight;
                            i < e + t && !(i + s < e) && this.triggerPointReached() && (this.anchorSiblings.forEach(t => {
                                t.matches(this.anchorSelector) || t.classList.remove(oL)
                            }), this.anchor.classList.add(oL))
                        }
                        triggerPointReached() {
                            let t = !1;
                            switch (this.triggerPoint) {
                                case "top":
                                default:
                                    t = this.top <= 0;
                                    break;
                                case "middle":
                                    t = this.top <= window.innerHeight / 2;
                                    break;
                                case "bottom":
                                    t = this.top <= window.innerHeight
                            }
                            return t
                        }
                        onUnload() {
                            document.removeEventListener("theme:resize:width", this.toggleScrollObserver), document.removeEventListener("theme:scroll", this.scrollCallback)
                        }
                        constructor(t, e) {
                            this.container = t, this.elementToSpy = e, this.anchorSelector = `[${oE}="#${this.elementToSpy.id}"]`, this.anchor = this.container.querySelector(this.anchorSelector), this.anchorSiblings = this.container.querySelectorAll(`[${oE}]`), this.initialized = !1, this.anchor && (this.triggerPoint = this.anchor.getAttribute("data-scroll-trigger-point"), this.scrollCallback = () => this.onScroll(), this.toggleScrollObserver = this.toggleScrollObserver.bind(this), this.init())
                        }
                    }(this.container, e))
                })
            },
            onUnload() {
                o$[this.id].forEach(t => {
                    "function" == typeof t.onUnload && t.onUnload()
                })
            }
        };
    eH("sidebar", [{
        onLoad() {
            oS[this.id] = new class {
                init() {
                    this.scrollToButtons.forEach(t => {
                        t.addEventListener("click", () => {
                            let e = this.container.querySelector(t.getAttribute("data-scroll-to"));
                            e && "A" !== t.tagName && this.scrollToElement(e)
                        })
                    })
                }
                scrollToElement(t) {
                    e6(t.getBoundingClientRect().top + 1);
                    let e = t.nextElementSibling.matches("details") ? t.nextElementSibling : null;
                    if (e) {
                        let i = null == e ? void 0 : e.querySelector("[data-collapsible-trigger]");
                        e.hasAttribute("open") || null == i || i.dispatchEvent(new Event("click"))
                    }
                    let s = document.querySelectorAll(`[data-tooltip]:not([${ob}])`);
                    s.length && s.forEach(t => {
                        t.setAttribute(ob, ""), setTimeout(() => {
                            t.removeAttribute(ob)
                        }, 1e3)
                    })
                }
                constructor(t) {
                    this.section = t, this.container = t.container, this.scrollToButtons = this.container.querySelectorAll("[data-scroll-to]"), this.scrollToButtons.length && this.init()
                }
            }(this)
        }
    }, oA]);
    let oC = "[data-hover-target]",
        oT = "data-hover-target",
        oq = "is-visible",
        ox = "is-selected",
        o_ = {};
    eH("collections-hover", [{
        onLoad() {
            o_[this.id] = new class {
                init() {
                    this.buttons.length && this.buttons.forEach(t => {
                        t.addEventListener("mouseenter", t => {
                            let e = t.currentTarget.getAttribute(oT);
                            this.updateState(e)
                        })
                    })
                }
                updateState(t) {
                    let e = this.container.querySelector(`[${oT}="${t}"]`),
                        i = this.container.querySelector(`#${t}:not(.${oq})`),
                        s = this.container.querySelector(`${oC}.${ox}`),
                        r = this.container.querySelector(`[data-collection-image].${oq}`);
                    i && y() && (null == r || r.classList.remove(oq), null == s || s.classList.remove(ox), i.classList.add(oq), e.classList.add(ox))
                }
                onBlockSelect(t) {
                    this.updateState(t.target.id)
                }
                constructor(t) {
                    this.container = t.container, this.buttons = this.container.querySelectorAll(oC), this.init()
                }
            }(this)
        },
        onBlockSelect(t) {
            o_[this.id].onBlockSelect(t)
        }
    }, oA, ]);
    let oP = {};
    eH("featured-product", [{
        onLoad() {
            oP[this.id] = new class {
                init() {
                    this.horizontalScroll && this.imagesHolder && (this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent), document.addEventListener("theme:scroll", this.scrollEvent)), this.wrapper && this.contentHolder && this.images.length && (this.calculateHeight(), document.addEventListener("theme:resize:width", this.calculateHeightEvent))
                }
                scrollEvents() {
                    this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent))
                }
                removeAnimationFrame() {
                    this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), this.requestAnimationSticky = null)
                }
                calculateHorizontalPosition() {
                    let t = window.scrollY + this.headerHeight,
                        e = t + window.innerHeight,
                        i = this.imagesHolder.offsetTop,
                        s = this.imagesHolder.offsetHeight,
                        r = i + s + this.headerHeight,
                        o = s - (window.innerHeight - this.headerHeight),
                        n = this.horizontalScrollReversed ? 1 : -1,
                        a = 0;
                    a = t >= i && e <= r ? (t - i) / o * 100 : t < i ? 0 : 100, a *= this.images.length - 1, this.container.style.setProperty("--translateX", a * n + "%"), this.lastPercent !== a ? this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent) : this.requestAnimationSticky && this.removeAnimationFrame(), this.lastPercent = a
                }
                calculateHeight() {
                    let {
                        stickyHeaderHeight: t
                    } = h();
                    this.container.style.removeProperty("--min-height"), this.container.style.setProperty("--min-height", `${this.wrapper.offsetHeight+this.contentHolder.offsetHeight}px`), this.headerHeight = t
                }
                onUnload() {
                    this.horizontalScroll && this.imagesHolder && document.removeEventListener("theme:scroll", this.calculateHorizontalPositionEvent), this.wrapper && this.contentHolder && this.images.length && document.removeEventListener("theme:resize:width", this.calculateHeightEvent)
                }
                constructor(t) {
                    this.container = t.container, this.horizontalScroll = this.container.hasAttribute("data-horizontal-scroll"), this.horizontalScrollReversed = this.container.hasAttribute("data-horizontal-scroll-reversed"), this.images = this.container.querySelectorAll("[data-featured-image]"), this.imagesHolder = this.container.querySelector("[data-featured-aside]"), this.contentHolder = this.container.querySelector("[data-featured-content]"), this.wrapper = this.container.querySelector("[data-featured-wrapper]"), this.requestAnimationSticky = null, this.lastPercent = 0, this.scrollEvent = () => this.scrollEvents(), this.calculateHorizontalPositionEvent = () => this.calculateHorizontalPosition(), this.calculateHeightEvent = () => this.calculateHeight(), this.init()
                }
            }(this)
        },
        onUnload(t) {
            oP[this.id].onUnload(t)
        }
    }, ]);
    let oM = "[data-timeline-row]",
        oH = {};
    eH("timeline", [{
        onLoad() {
            oH[this.id] = new class {
                init() {
                    this.calculateRowsDimensions(), this.requestAnimation = requestAnimationFrame(() => this.calculatePosition()), this.isDesktopView && !this.isScrollEnabled && (this.isScrollEnabled = !0, document.addEventListener("theme:scroll", this.scrollEvent)), this.rowsHolder.addEventListener("scroll", this.scrollEvent), document.addEventListener("theme:resize:width", this.resizeEvent), this.buttons.length && this.buttons.forEach((t, e) => {
                        t.addEventListener("click", t => {
                            t.preventDefault();
                            let i = t.currentTarget.closest(oM);
                            if (!i) return;
                            let s = Math.max(...this.rowsHeight),
                                r = this.holderHeight / this.rows.length,
                                o = this.holder.getBoundingClientRect().top,
                                n = y() ? (e > 0 && s < r ? r * e + o : o) + 1 : i.getBoundingClientRect().top;
                            e6(n)
                        })
                    })
                }
                resizeEvents() {
                    this.holderTop = this.holder.getBoundingClientRect().top + window.scrollY, this.holderHeight = this.holder.offsetHeight, this.calculateRowsDimensions(), this.requestAnimation = requestAnimationFrame(() => this.calculatePosition());
                    let t = y();
                    t && !this.isScrollEnabled ? (this.isScrollEnabled = !0, document.addEventListener("theme:scroll", this.scrollEvent)) : !t && this.isScrollEnabled && (this.isScrollEnabled = !1, document.removeEventListener("theme:scroll", this.scrollEvent))
                }
                scrollEvents(t) {
                    if (!this.requestAnimation) {
                        let e = t.currentTarget;
                        this.requestAnimation = requestAnimationFrame(() => this.calculatePosition(e))
                    }
                }
                removeAnimationFrame() {
                    this.requestAnimation && (cancelAnimationFrame(this.requestAnimation), this.requestAnimation = null)
                }
                calculateRowsDimensions() {
                    if (this.rows.length) {
                        this.rowsHeight = [], this.rowsWidth = 0;
                        let t = 0;
                        this.rows.forEach((e, i) => {
                            if (this.rowsHeight.push(e.offsetHeight), this.rowsWidth += e.offsetWidth + parseInt(getComputedStyle(e).marginRight), window.Shopify.designMode) {
                                var s, r;
                                let o = this.container.querySelectorAll("[data-timeline-row-editor]");
                                o.length && (t += e.offsetHeight, null === (s = o[i]) || void 0 === s || s.style.setProperty("--row-height-min", `${e.offsetHeight}px`), null === (r = o[i + 1]) || void 0 === r || r.style.setProperty("--row-top-mobile", `${t}px`))
                            }
                        })
                    }
                }
                calculatePosition(t = null) {
                    this.removeAnimationFrame();
                    let e = y(),
                        i = this.holderHeight / this.rows.length,
                        s = this.holderTop,
                        r = window.innerHeight,
                        o = window.scrollY + r,
                        n = 0;
                    if (!e && t) {
                        let a = t.scrollLeft - 16,
                            l = t.offsetWidth;
                        n = a / (this.rowsWidth - l) * 100, this.holder.style.setProperty("--percent-mobile", `${n}%`)
                    }
                    e && (o < this.holderTop || o > this.holderTop + this.holderHeight + r) || this.rows.forEach((t, r) => {
                        if (r > 0) {
                            var a;
                            let l = t.offsetLeft / this.rowsWidth * 100,
                                h = n > l;
                            e && (h = s + i < o, s - i < o && (null === (a = t.previousElementSibling) || void 0 === a || a.style.setProperty("--percent-desktop", (o - s) / i * 100 + "%"))), t.classList.toggle("is-selected", h)
                        }
                        s += i
                    })
                }
                onUnload() {
                    this.isScrollEnabled && (this.isScrollEnabled = !1, document.removeEventListener("theme:scroll", this.scrollEvent)), this.rowsHolder.removeEventListener("scroll", this.scrollEvent), document.removeEventListener("theme:resize:width", this.resizeEvent)
                }
                onBlockSelect(t) {
                    let e = this.container.querySelector("[data-block-scroll]");
                    if (e) {
                        let i = t.srcElement,
                            s = [...i.parentElement.children].indexOf(i),
                            r = this.rows[s];
                        r && e.scrollTo({
                            top: 0,
                            left: r.offsetLeft,
                            behavior: "smooth"
                        })
                    }
                }
                constructor(t) {
                    this.container = t.container, this.rows = this.container.querySelectorAll(oM), this.holder = this.container.querySelector("[data-timeline-holder]"), this.rows.length < 2 || !this.holder || (this.rowsWidth = 0, this.rowsHeight = [], this.holderTop = this.holder.getBoundingClientRect().top + window.scrollY, this.holderHeight = this.holder.offsetHeight, this.buttons = this.container.querySelectorAll("[data-timeline-button]"), this.rowsHolder = this.container.querySelector("[data-timeline-rows]"), this.requestAnimation = null, this.isDesktopView = y(), this.isScrollEnabled = !1, this.scrollEvent = t => this.scrollEvents(t), this.resizeEvent = () => this.resizeEvents(), this.init())
                }
            }(this)
        },
        onUnload(t) {
            oH[this.id].onUnload(t)
        },
        onBlockSelect(t) {
            oH[this.id].onBlockSelect(t)
        }
    }, ]), document.addEventListener("DOMContentLoaded", function() {
        eB("*");
        let t = document.querySelector("[data-scroll-top-button]");
        t && (t.addEventListener("click", () => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            })
        }), document.addEventListener("theme:scroll", () => {
            t.classList.toggle("is-visible", window.scrollY > window.innerHeight)
        })), window.self !== window.top && document.querySelector("html").classList.add("iframe"), "scrollBehavior" in document.documentElement.style || rH({
            url: window.theme.assets.smoothscroll
        })
    }), window.navigator.cookieEnabled && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies"))
}(themeVendor.ScrollLock, themeVendor.themeAddresses, themeVendor.themeCurrency, themeVendor.Rellax, themeVendor.Flickity, themeVendor.FlickityFade, themeVendor.themeImages);
